(function() {
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Core
            'app.core',
            'angular-intro',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick Panel
            'app.quick-panel',

            // Errors
            'app.errors',

            // Auth
            'app.auth',

            // Main
            'app.pages',

            'ngFileSaver',
            'ng-sortable'
        ]);
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('CreateDomainDialogController', CreateDomainDialogController);

    /** @ngInject */
    function CreateDomainDialogController(publisher, DomainService, $mdDialog) {
        var vm = this;

        // Data
        vm.isSaving = false;
        vm.domain = new DomainService();
        vm.publisher = publisher;

        // Methods
        vm.cancel = cancel;
        vm.createDomain = createDomain;

        // ------------------------------------------------------------------------------------------------------ //
        // Method definitions
        // ------------------------------------------------------------------------------------------------------ //

        // closes the dialog
        function cancel() {
            closeDialog();
        }

        // closes the dialog
        function closeDialog() {
            $mdDialog.hide();
        }

        // adds a new site
        function createDomain() {
            vm.domain.publisherId = vm.publisher.publisherId;
            vm.isSaving = true;

            vm.publisher.createDomain(vm.domain)
                .then(function () {
                    closeDialog();
                })
                .finally(function () {
                    vm.isSaving = false;
                });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('ChangePasswordDialogController', ChangePasswordDialogController);

    /** @ngInject */
    function ChangePasswordDialogController(publisher, $mdDialog, $mdToast, $translate, $timeout, $scope) {
        var vm = this;

        // Data
        vm.isSaving = false;
        vm.publisher = publisher;

        // Methods
        vm.cancel = cancel;
        vm.savePassword = savePassword;
        vm.clearError = clearError;

        // ------------------------------------------------------------------------------------------------------ //
        // Method definitions
        // ------------------------------------------------------------------------------------------------------ //

        function cancel() {
            closeDialog();
        }

        function closeDialog() {
            delete(vm.publisher.currentPassword);
            delete(vm.publisher.password);
            delete(vm.publisher.confirmPassword);
            $mdDialog.hide();
        }

        function savePassword() {
            vm.isSaving = true;
            vm.publisher.savePassword()
                .then(function () {
                    closeDialog();
                })
                .catch(function(resp) {
                    if (resp.data.error === 'currentPassword.invalid') {
                        $scope.passwordForm.currentPassword.$setValidity('invalid', false);
                    }
                })
                .finally(function () {
                    vm.isSaving = false;
                });
        }

        function clearError(field, error) {
            $scope.passwordForm[field].$setValidity(error, true);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('AuthorizedSellerDialogController', AuthorizedSellerDialogController);

    /** @ngInject */
    function AuthorizedSellerDialogController(authorizedSeller, authorizedSellerList, reassignCallback, $mdDialog) {
        var vm = this;

        // Data
        vm.authorizedSeller = authorizedSeller;
        vm.authorizedSellerList = authorizedSellerList;
        vm.selectedAuthorizedSeller = -1;

        // Methods
        vm.cancel = cancel;
        vm.reassign = reassign;

        // ------------------------------------------------------------------------------------------------------ //
        // Method definitions
        // ------------------------------------------------------------------------------------------------------ //

        function cancel() {
            closeDialog();
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function reassign() {
            reassignCallback(vm.selectedAuthorizedSeller);
            closeDialog();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.viewAdsTxt', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.pages.viewAdsTxt', {
            url      : '/view',
            views    : {
                'pagescontent@app.pages': {
                    templateUrl: 'app/main/apps/pages/view-adstxt/view-adstxt.html',
                    controller : 'ViewAdsTxtController as vm'
                }
            },
            resolve  : {
                AdsTxt: function (DomainService) {
                    return DomainService.GetAdsTxt().then(function (adsTxt) {
                        return adsTxt;
                    });
                }
            },
            bodyClass: 'view-adstxt'
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.pages.viewAdsTxt')
        .controller('ViewAdsTxtController', ViewAdsTxtController);

    /** @ngInject */
    function ViewAdsTxtController(AdsTxt) {
        var vm = this;
        vm.adsTxt = AdsTxt;
    }

})();
(function () {
    'use strict';

    angular
        .module('app.pages.sellers', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('app.pages.sellers', {
            url: '/sellers',
            views: {
                'pagescontent@app.pages': {
                    templateUrl: 'app/main/apps/pages/sellers/sellers.html',
                    controller: 'SellersController as vm'
                }
            },
            resolve: {
                SellerList: function (SellerListService) {
                    return SellerListService.GetNewList().then(function (list) {
                        return list;
                    });
                }
            },
            bodyClass: 'authorize-sellers'
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.pages.sellers')
        .controller('SellersController', SellersController);

    /** @ngInject */
    function SellersController(SellerList, AuthorizedSellerList, RootService, $state, $scope) {
        var vm = this;

        // Data
        vm.authorizedSellerList = AuthorizedSellerList;
        vm.search;
        vm.sellerList = SellerList;
        vm.sellerListType = "all";
        vm.filters = {};

        // Methods
        vm.filterChange = filterChange;

        $scope.$watch('vm.sellerListType', function () {
            vm.filterChange(vm.sellerListType);
        });

        // ------------------------------------------------------------------------------------------------------ //
        // Method definitions
        // ------------------------------------------------------------------------------------------------------ //

        // applies the filter
        function filterChange(type) {
            if (type === 'all') {
                vm.filters = {};
            }
            else if (type === 'authorized') {
                vm.filters = {
                    isAuthorized: 1
                };
            }
            else if (type === 'unauthorized') {
                vm.filters = {
                    isAuthorized: 0
                };
            }
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.pages.manualEntries', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('app.pages.manualEntries', {
            url: '/manualEntries',
            views: {
                'pagescontent@app.pages': {
                    templateUrl: 'app/main/apps/pages/manual-entries/manual-entries.html',
                    controller: 'ManualEntriesController as vm'
                }
            },
            resolve: {
                DomainEntryList: function (DomainEntryListService) {
                    return DomainEntryListService.GetNewList(0).then(function (list) {
                        return list;
                    });
                }
            },
            bodyClass: 'manual-entries'
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.pages.manualEntries')
        .controller('ManualEntriesController', ManualEntriesController);

    /** @ngInject */
    function ManualEntriesController(SellerService, AuthorizedSellerList, DomainEntryList) {
        var vm = this;

        // Data
        vm.authorizedSeller = new SellerService();
        vm.authorizedSellerList = AuthorizedSellerList;
        vm.domainEntryList = DomainEntryList;
        vm.errorList = [];
        vm.duplicateList = [];

        // Methods
        vm.callbackErrors = callbackErrors;
        vm.handleCloseErrorsClick = handleCloseErrorsClick;
        vm.callbackDuplicateErrors = callbackDuplicateErrors;
        vm.handleCloseDuplicatesClick = handleCloseDuplicatesClick;

        // ------------------------------------------------------------------------------------------------------ //
        // Method definitions
        // ------------------------------------------------------------------------------------------------------ //

        // handles any errors
        function callbackErrors(errors) {
            if (errors.length > 0) {
                vm.errorList = errors;
            } else {
                vm.errorList = [];
            }
        }

        // clears the error list to hide the form
        function handleCloseErrorsClick() {
            vm.errorList = [];
        }

        // handles any errors
        function callbackDuplicateErrors(duplicateErrors) {
            if (duplicateErrors.length > 0) {
                vm.duplicateList = duplicateErrors;
            } else {
                vm.duplicateList = [];
            }
        }

        // clears the error list to hide the form
        function handleCloseDuplicatesClick() {
            vm.duplicateList = [];
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.pages.home', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('app.pages.home', {
            url: '/home',
            views: {
                'pagescontent@app.pages': {
                    templateUrl: 'app/main/apps/pages/home/home.html',
                    controller: 'HomeController as vm'
                }
            },
            resolve: {
                CrawlStats: function (DomainService) {
                    return DomainService.GetCrawlStats().then(function (data) {
                        return data;
                    });
                }
            },
            bodyClass: 'dashboard-project'
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.pages.home')
        .controller('HomeController', HomeController);

    /** @ngInject */
    function HomeController(QuickPanel, RootService, Publisher, CrawlStats, $state) {
        var vm = this;

        // Data
        vm.publisher = Publisher;
        vm.quickPanel = QuickPanel;
        vm.selectedDomain = Publisher.getSelectedDomain();
        vm.lineChart = _getLineChart();

        // Methods
        vm.handleDisplayClick = handleDisplayClick;
        vm.handleGetStartedClick = handleGetStartedClick;
        vm.handleIntegrationClick = handleIntegrationClick;
        vm.handleViewClick = handleViewClick;

        // ------------------------------------------------------------------------------------------------------ //
        // Method definitions
        // ------------------------------------------------------------------------------------------------------ //

        // open the quick panel to the today tab
        function handleDisplayClick() {
            vm.quickPanel.setSelectedTab(vm.quickPanel.tabs.TODAY);
            vm.quickPanel.toggle();
        }

        // direct user to the get started page
        function handleGetStartedClick() {
            $state.go(RootService.states.STATE_GET_STARTED);
        }

        // checks the integration status of the domain
        function handleIntegrationClick() {
            RootService.showLoading('FE_CHECKING_INTEGRATION');

            vm.selectedDomain.checkIntegration()
                .finally(function () {
                    RootService.hideLoading();
                });
        }

        // direct user to the view ads.txt page
        function handleViewClick() {
            $state.go(RootService.states.STATE_VIEW_ADS_TXT);
        }

        // sets up the line chart
        function _getLineChart() {
            var lc = {
                options: {
                    layout: {
                        padding: {
                            left: 0,
                            right: 10,
                            top: 20,
                            bottom: 0
                        }
                    },
                    responsive: true,
                    tooltips: {
                        enabled: true,
                        intersect: false
                    },
                    elements: {
                        point: {
                            radius: 0
                        }
                    },
                    animation: {
                        duration: 1
                    },
                    scales: {
                        xAxes: [{
                            display: false,
                            gridLines: {
                                lineWidth: 0,
                                zeroLineWidth: 0,
                                display: false
                            }
                        }],
                        yAxes: [{
                            display: true,
                            gridLines: {
                                lineWidth: 0,
                                zeroLineWidth: 0,
                                color: 'white',
                                display: false
                            },
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                },
                series: ['Crawls']
            };

            lc.labels = CrawlStats.dates;
            lc.data = [CrawlStats.crawls];
            lc.options.elements.point.radius = CrawlStats.crawls.length > 1 ? 0 : 3;

            return lc;
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.pages.getStarted', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider.state('app.pages.getStarted', {
            url: '/getStarted',
            views: {
                'pagescontent@app.pages': {
                    templateUrl: 'app/main/apps/pages/get-started/get-started.html',
                    controller: 'GetStartedController as vm'
                }
            },
            resolve: {
                DomainEntryList: function (DomainEntryListService) {
                    return DomainEntryListService.GetNewList(0).then(function (list) {
                        return list;
                    });
                },
                SellerList: function (SellerListService) {
                    return SellerListService.GetNewList().then(function (list) {
                        return list;
                    });
                }
            },
            bodyClass: 'get-started'
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.pages.getStarted')
        .controller('GetStartedController', GetStartedController);

    /** @ngInject */
    function GetStartedController(Publisher, SellerList, AuthorizedSellerList, DomainEntryList, RootService, $scope) {
        var vm = this;

        // Data
        vm.authorizedSellerList = AuthorizedSellerList;
        vm.domainEntryList = DomainEntryList;
        vm.errorList = [];
        vm.duplicateList = [];
        vm.filters = {};
        vm.sellerList = SellerList;
        vm.publisher = Publisher;
        vm.search;
        vm.selectedDomain = Publisher.getSelectedDomain();
        vm.sellerListType = "all";
        vm.toggleSelected = true;

        // Methods
        vm.callbackErrors = callbackErrors;
        vm.filterChange = filterChange;
        vm.handleCloseErrorsClick = handleCloseErrorsClick;
        vm.handleImportClick = handleImportClick;
        vm.handleIntegrationClick = handleIntegrationClick;
        vm.callbackDuplicateErrors = callbackDuplicateErrors;
        vm.handleCloseDuplicatesClick = handleCloseDuplicatesClick;

        $scope.$watch('vm.sellerListType', function () {
            vm.filterChange(vm.sellerListType);
        });

        // ------------------------------------------------------------------------------------------------------ //
        // Method definitions
        // ------------------------------------------------------------------------------------------------------ //

        // handles any errors
        function callbackErrors(errors) {
            if (errors.length > 0) {
                vm.errorList = errors;
            } else {
                vm.errorList = [];
            }
        }

        // applies the filter
        function filterChange(type) {
            if (type === 'all') {
                vm.filters = {};
            }
            else if (type === 'authorized') {
                vm.filters = {
                    isAuthorized: 1
                };
            }
            else if (type === 'unauthorized') {
                vm.filters = {
                    isAuthorized: 0
                };
            }
        }

        // clears the error list to hide the form
        function handleCloseErrorsClick() {
            vm.errorList = [];
        }

        // imports the current ads.txt file
        function handleImportClick() {
            RootService.showLoading('FE_IMPORTING');

            vm.selectedDomain.importAdsTxt()
                .then(function (data) {
                    vm.adsTxt = data.message;
                })
                .finally(function () {
                    RootService.hideLoading();
                });
        }

        // checks the integration status of the domain
        function handleIntegrationClick() {
            RootService.showLoading('FE_CHECKING_INTEGRATION');

            vm.selectedDomain.checkIntegration()
                .finally(function () {
                    RootService.hideLoading();
                });
        }

        // handles any errors
        function callbackDuplicateErrors(duplicateErrors) {
            if (duplicateErrors.length > 0) {
                vm.duplicateList = duplicateErrors;
            } else {
                vm.duplicateList = [];
            }
        }

        // clears the error list to hide the form
        function handleCloseDuplicatesClick() {
            vm.duplicateList = [];
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.pages.authorizedSeller', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.pages.authorizedSeller', {
            url: '/authorizedSeller/:id',
            views: {
                'pagescontent@app.pages': {
                    templateUrl: 'app/main/apps/pages/authorized-seller/authorized-seller.html',
                    controller: 'AuthorizedSellerController as vm'
                }
            },
            resolve: {
                AuthorizedSeller: function(AuthorizedSellerList, $state, $stateParams) {
                    // checks to make sure the seller exists and that it is authorized; otherwise,
                    // the user cannot view the page.
                    var seller = AuthorizedSellerList.filterById($stateParams.id);
                    if (Helper.isUnsetOrEmpty(seller) || seller.isAuthorized === 0) {
                        $state.go('error.error-503');
                    } else {
                        return seller;
                    }
                },
                SellerEntryList: function (SellerEntryListService, $stateParams) {
                    return SellerEntryListService.GetNewList($stateParams.id).then(function (list) {
                        return list;
                    });
                },
                DomainEntryList: function (DomainEntryListService, $stateParams) {
                    return DomainEntryListService.GetNewList($stateParams.id).then(function (list) {
                        return list;
                    });
                }
            },
            bodyClass: 'authorized-seller'
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.pages.authorizedSeller')
        .controller('AuthorizedSellerController', AuthorizedSellerController);

    /** @ngInject */
    function AuthorizedSellerController(DomainEntryList, AuthorizedSeller, SellerEntryList, AuthorizedSellerList, RootService, $rootScope, $state, $mdDialog, $translate) {
        var vm = this;

        // Data
        vm.authorizedSeller = AuthorizedSeller;
        vm.authorizedSellerList = AuthorizedSellerList;
        vm.domainEntryList = DomainEntryList;
        vm.sellerEntryList = SellerEntryList;
        vm.errorList = [];
        vm.duplicateList = [];

        // Methods
        vm.handleUnauthorizeClick = handleUnauthorizeClick;
        vm.callbackErrors = callbackErrors;
        vm.handleCloseErrorsClick = handleCloseErrorsClick;
        vm.callbackDuplicateErrors = callbackDuplicateErrors;
        vm.handleCloseDuplicatesClick = handleCloseDuplicatesClick;

        // ------------------------------------------------------------------------------------------------------ //
        // Method definitions
        // ------------------------------------------------------------------------------------------------------ //

        // get the confirm dialog to show before unauthorizing
        function getConfirmDialog() {
            return $mdDialog
                .confirm()
                .title($translate.instant('FE_CONFIRM_UNAUTHORIZE_TITLE'))
                .textContent($translate.instant('FE_CONFIRM_UNAUTHORIZE_TEXT'))
                .ariaLabel('confirm unauthorize')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok($translate.instant('FE_CONFIRM'))
                .cancel($translate.instant('FE_CANCEL'));
        }

        // unauthorize's a seller if confirmed
        function handleUnauthorizeClick() {
            // get the confirm dialog before unauthorizing
            $mdDialog.show(getConfirmDialog()).then(function () {
                RootService.showLoading("FE_UNAUTHORIZING");
                vm.authorizedSellerList.unauthorizeSeller(vm.authorizedSeller.sellerId)
                    .then(function () {
                        $state.go(RootService.states.STATE_SELLERS);
                    });
            });
        }

        // ------------------------------------------------------------------------------------------------------ //
        // Method definitions
        // ------------------------------------------------------------------------------------------------------ //

        // handles any errors
        function callbackErrors(errors) {
            if (errors.length > 0) {
                vm.errorList = errors;
            } else {
                vm.errorList = [];
            }
        }

        // clears the error list to hide the form
        function handleCloseErrorsClick() {
            vm.errorList = [];
        }

        // handles any errors
        function callbackDuplicateErrors(duplicateErrors) {
            if (duplicateErrors.length > 0) {
                vm.duplicateList = duplicateErrors;
            } else {
                vm.duplicateList = [];
            }
        }

        // clears the error list to hide the form
        function handleCloseDuplicatesClick() {
            vm.duplicateList = [];
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.accountSettings', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.pages.accountSettings', {
            url      : '/settings',
            views    : {
                'pagescontent@app.pages': {
                    templateUrl: 'app/main/apps/pages/account-settings/account-settings.html',
                    controller : 'AccountSettingsController as vm'
                }
            },
            bodyClass: 'account-settings'
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.pages.accountSettings')
        .controller('AccountSettingsController', AccountSettingsController);

    /** @ngInject */
    function AccountSettingsController($translate, $mdDialog, Publisher, $state, $timeout, RootService) {
        var vm = this;

        // Data
        vm.publisher = Publisher;

        // Methods
        vm.handleChangePasswordClick = handleChangePasswordClick;
        vm.handleSaveClick = handleSaveClick;

        // ------------------------------------------------------------------------------------------------------ //
        // Method definitions
        // ------------------------------------------------------------------------------------------------------ //

        // shows the form to change a password
        function handleChangePasswordClick() {
            $mdDialog.show({
                controller: 'ChangePasswordDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/pages/dialogs/change-password/change-password-dialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                focusOnOpen: false,
                locals: {
                    publisher: vm.publisher
                }
            });
        }

        // saves a publisher's settings
        function handleSaveClick() {
            RootService.showLoading('FE_SAVING');
            vm.publisher.save().finally(function() {
                RootService.hideLoading();
            });
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .directive('sellerEntries', sellerEntriesDirective);

    /** @ngInject */
    function sellerEntriesDirective(RootService, $mdDialog, $translate, $rootScope, $mdToast) {
        return {
            restrict: 'E',
            scope: {
                authorizedSeller: '=',
                sellerEntryList: '=',
                authorizedSellerList: '='
            },
            templateUrl: 'app/main/apps/directives/seller-entries/seller-entries.html',
            controller: function () {
                var vm = this;

                // Data
                vm.dtOptions = getDtOptions();
                vm.selectAll = false;

                // Methods
                vm.checkBoxToggleAll = checkBoxToggleAll;
                vm.handleEnableClick = handleEnableClick;
                vm.handleDisableClick = handleDisableClick;

                // ------------------------------------------------------------------------------------------------------ //
                // Method definitions
                // ------------------------------------------------------------------------------------------------------ //

                // toggle checkboxes
                function checkBoxToggleAll() {
                    var ids = [];
                    $(".seller-entries tbody tr md-checkbox").each(function (idx, el) {
                        ids.push($(el).data('entry'));
                    });
                    if (!vm.selectAll) { // it's backwards
                        vm.sellerEntryList.selectItemsById(ids);
                    } else {
                        vm.sellerEntryList.deselectItemsById(ids);
                    }
                }

                // get the confirm dialog to show before disabling
                function getDisableConfirmDialog() {
                    return $mdDialog
                        .confirm()
                        .title($translate.instant('FE_CONFIRM_DISABLE_TITLE'))
                        .ariaLabel('confirm disable')
                        .clickOutsideToClose(true)
                        .parent(angular.element(document.body))
                        .ok($translate.instant('FE_CONFIRM'))
                        .cancel($translate.instant('FE_CANCEL'));
                }

                // returns the options for the table
                function getDtOptions() {
                    return {
                        dom: '',
                        pagingType: 'simple',
                        autoWidth: false,
                        responsive: false,
                        sort: true,
                        pageLength: 2000,
                        order: [],
                        initComplete: function () {
                            var api = this.api(),
                                searchBox = angular.element('body').find('#seller-entries-search');
                            if (searchBox.length > 0) {
                                searchBox.on('keyup', function (event) {
                                    api.search(event.target.value).draw();
                                });
                            }
                        }
                    };
                }

                // get the confirm dialog to show before disabling
                function getEnableConfirmDialog() {
                    return $mdDialog
                        .confirm()
                        .title($translate.instant('FE_CONFIRM_ENABLE_TITLE'))
                        .ariaLabel('confirm enable')
                        .clickOutsideToClose(true)
                        .parent(angular.element(document.body))
                        .ok($translate.instant('FE_CONFIRM'))
                        .cancel($translate.instant('FE_CANCEL'));
                }

                // enables the selected entries
                function handleDisableClick() {
                    // gets the selected items
                    var entryIds = vm.sellerEntryList.getSelectedIds();

                    // make sure items are selected
                    if (entryIds.length === 0) {
                        showNoItemsSelected();
                        return;
                    }

                    // get the confirm dialog before deleting
                    $mdDialog.show(getDisableConfirmDialog()).then(function () {
                        _callbackDisable(entryIds)
                    });
                }

                // enables the selected entries
                function handleEnableClick() {
                    // gets the selected items
                    var entryIds = vm.sellerEntryList.getSelectedIds();

                    // make sure items are selected
                    if (entryIds.length === 0) {
                        showNoItemsSelected();
                        return;
                    }

                    // get the confirm dialog before enabling
                    $mdDialog.show(getEnableConfirmDialog()).then(function () {
                        _callbackEnable(entryIds)
                    });
                }

                // resets the form
                function resetForm(entryIds) {
                    $('#seller-entries-search').val('');
                    vm.selectAll = false;
                    vm.sellerEntryList.deselectItemsById(entryIds);
                }

                // shows a message that no items were selected
                function showNoItemsSelected() {
                    $mdDialog.show(
                        $mdDialog.alert()
                            .parent(angular.element(document.body))
                            .clickOutsideToClose(true)
                            .title($translate.instant('FE_ALERT_NO_ENTRIES_TITLE'))
                            .textContent($translate.instant('FE_ALERT_NO_ENTRIES_DESC'))
                            .ariaLabel('no items dialog')
                            .ok($translate.instant("FE_GOT_IT"))
                    );
                }

                // disables the selected entries
                function _callbackDisable(entryIds) {
                    // only keep entries that are enabled
                    var filteredIds = vm.sellerEntryList.filterIdsByIsEnabled(entryIds, 1);

                    // nothing to do, return!
                    if (filteredIds.length === 0) {
                        resetForm(entryIds); // resets the form
                        $mdToast.show($mdToast.simple().textContent($translate.instant("FE_TOAST_SAVE")).position('top right'));
                        return;
                    }

                    RootService.showLoading("FE_DISABLING");

                    vm.sellerEntryList.disable(filteredIds)
                        .then(function () {
                            // resets the form
                            resetForm(entryIds);

                            // removes the items from the list count
                            vm.authorizedSellerList.adjustEntryCount(vm.authorizedSeller.sellerId, filteredIds.length * -1);
                        })
                        .finally(function () {
                            RootService.hideLoading();
                        });
                }

                // enables the selected entries
                function _callbackEnable(entryIds) {
                    // only keep entries that are disabled
                    var filteredIds = vm.sellerEntryList.filterIdsByIsEnabled(entryIds, 0);

                    // nothing to do, return!
                    if (filteredIds.length === 0) {
                        resetForm(entryIds); // resets the form
                        $mdToast.show($mdToast.simple().textContent($translate.instant("FE_TOAST_SAVE")).position('top right'));
                        return;
                    }

                    RootService.showLoading("FE_ENABLING");

                    vm.sellerEntryList.enable(filteredIds)
                        .then(function () {
                            // resets the form
                            resetForm(entryIds);

                            // adds the items from the list count
                            vm.authorizedSellerList.adjustEntryCount(vm.authorizedSeller.sellerId, filteredIds.length);
                        })
                        .finally(function () {
                            RootService.hideLoading();
                        });
                }
            },
            controllerAs: 'vm',
            bindToController: true
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .directive('sellerCard', sellerCardDirective);

    /** @ngInject */
    function sellerCardDirective() {
        return {
            restrict: 'E',
            scope: {
                authorizedSellerList: "=",
                seller: "=",
                showUnauthorize: "=?",
                showManage: "=?"
            },
            templateUrl: 'app/main/apps/directives/seller-card/seller-card.html',
            controller: function (RootService, $state) {
                var vm = this;

                // Data
                vm.showUnauthorize = angular.isDefined(vm.showUnauthorize) ? vm.showUnauthorize : false;
                vm.showManage = angular.isDefined(vm.showManage) ? vm.showManage : false;

                // Methods
                vm.handleAuthorizeClick = handleAuthorizeClick;
                vm.handleManageClick = handleManageClick;
                vm.handleUnauthorizeClick = handleUnauthorizeClick;

                // ------------------------------------------------------------------------------------------------------ //
                // Method definitions
                // ------------------------------------------------------------------------------------------------------ //

                // authorizes the seller
                function handleAuthorizeClick(seller) {
                    RootService.showLoading('FE_AUTHORIZING');

                    vm.authorizedSellerList.authorizeSeller(seller.sellerId)
                        .then(function (response) {
                            seller.isAuthorized = 1;
                            seller.dateAuthorized = response.dateAuthorized;
                        })
                        .finally(function () {
                            RootService.hideLoading();
                        });
                }

                // directs the user to the seller page
                function handleManageClick(seller) {
                    $state.go(RootService.states.STATE_AUTHORIZED_SELLER, {id: seller.sellerId});
                }

                // unauthorize's a seller if confirmed
                function handleUnauthorizeClick(seller) {
                    RootService.showLoading("FE_UNAUTHORIZING");

                    vm.authorizedSellerList.unauthorizeSeller(seller.sellerId)
                        .then(function () {
                            seller.isAuthorized = 0;
                            seller.dateAuthorized = "";
                        })
                        .finally(function () {
                            RootService.hideLoading();
                        });
                }
            },
            controllerAs: 'vm',
            bindToController: true
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .directive('manualEntries', manualEntriesDirective);

    /** @ngInject */
    function manualEntriesDirective() {
        return {
            restrict: 'E',
            scope: {
                authorizedSeller: '=',
                domainEntryList: '=',
                authorizedSellerList: '='
            },
            templateUrl: 'app/main/apps/directives/manual-entries/manual-entries.html',
            controller: function (RootService, $rootScope, DomainEntryService, $mdDialog, $translate) {
                var vm = this;

                // Data
                vm.dtOptions = getDtOptions();
                vm.newEntry = new DomainEntryService();
                vm.selectAll = false;

                // Methods
                vm.checkBoxToggleAll = checkBoxToggleAll;
                vm.handleAddClick = handleAddClick;
                vm.handleDeleteClick = handleDeleteClick;
                vm.handleReassignClick = handleReassignClick;
                vm.handleSaveClick = handleSaveClick;

                // ------------------------------------------------------------------------------------------------------ //
                // Method definitions
                // ------------------------------------------------------------------------------------------------------ //

                // toggle checkboxes
                function checkBoxToggleAll() {
                    var ids = [];
                    $(".entries tbody tr md-checkbox").each(function (idx, el) {
                        ids.push($(el).data('entry'));
                    });
                    if (!vm.selectAll) { // it's backwards
                        vm.domainEntryList.selectItemsById(ids);
                    } else {
                        vm.domainEntryList.deselectItemsById(ids);
                    }
                }

                // get the confirm dialog to show before deleting
                function getConfirmDialog() {
                    return $mdDialog
                        .confirm()
                        .title($translate.instant('FE_CONFIRM_DELETE_TITLE'))
                        .ariaLabel('confirm delete')
                        .clickOutsideToClose(true)
                        .parent(angular.element(document.body))
                        .ok($translate.instant('FE_CONFIRM'))
                        .cancel($translate.instant('FE_CANCEL'));
                }

                // returns the options for the table
                function getDtOptions() {
                    return {
                        dom: '',
                        pagingType: 'simple',
                        autoWidth: false,
                        responsive: false,
                        sort: true,
                        pageLength: 2000,
                        order: [],
                        initComplete: function () {
                            var api = this.api(),
                                searchBox = angular.element('body').find('#manual-entries-search');
                            if (searchBox.length > 0) {
                                searchBox.on('keyup', function (event) {
                                    api.search(event.target.value).draw();
                                });
                            }
                        }
                    };
                }

                // get an alert letting the user know they have no authorized sellers
                function getNoSellerAlert() {
                    return $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title($translate.instant('FE_NO_AUTHORIZED_SELLERS_ALERT_TITLE'))
                        .textContent($translate.instant('FE_NO_AUTHORIZED_SELLERS_ALERT_TEXT'))
                        .ariaLabel('No authorized sellers')
                        .ok($translate.instant('FE_GOT_IT'));
                }

                // get the seller dialog to show before re-assigning
                function getSellerDialog() {
                    return {
                        controller: 'AuthorizedSellerDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/apps/pages/dialogs/authorized-seller/authorized-seller-dialog.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: false,
                        focusOnOpen: false,
                        locals: {
                            authorizedSeller: vm.authorizedSeller,
                            authorizedSellerList: vm.authorizedSellerList,
                            reassignCallback: _callbackReassign
                        }
                    };
                }

                // adds a new entry
                function handleAddClick() {
                    RootService.showLoading('FE_SAVING');

                    // set the seller id for the new entry
                    vm.newEntry.sellerId = vm.authorizedSeller.sellerId;

                    vm.newEntry.create()
                        .then(function (newItem) {
                            // adds the new item to the list of entries
                            vm.domainEntryList.addItem(newItem);

                            // reset the new entry object
                            vm.newEntry = new DomainEntryService();

                            // reset some inputs
                            resetSearchAndCheck();

                            // increase the count of manual entries by 1
                            vm.authorizedSellerList.adjustEntryCount(vm.authorizedSeller.sellerId, 1);
                        })
                        .finally(function () {
                            RootService.hideLoading();
                        });
                }

                // deletes the selected entries
                function handleDeleteClick() {

                    // gets the selected items
                    var entryIds = vm.domainEntryList.getSelectedIds();

                    // make sure items are selected
                    if (entryIds.length === 0) {
                        showNoItemsSelected();
                        return;
                    }

                    // get the confirm dialog before deleting`
                    $mdDialog.show(getConfirmDialog()).then(function () {
                        _callbackDelete(entryIds)
                    });
                }

                // re-assigns the selected entries to a new authorized seller
                function handleReassignClick() {

                    // gets the selected items
                    var entryIds = vm.domainEntryList.getSelectedIds();

                    // make sure items are selected
                    if (entryIds.length === 0) {
                        showNoItemsSelected();
                        return;
                    }

                    // show the re-assign dialog (there is always 1 record for manual entries returned with the
                    // authorized seller list; that is why we check less than 2
                    if (vm.authorizedSellerList.list.length < 2) {
                        $mdDialog.show(getNoSellerAlert());
                    } else {
                        $mdDialog.show(getSellerDialog());
                    }
                }

                // saves an existing entry
                function handleSaveClick(entry) {
                    RootService.showLoading('FE_SAVING');

                    entry.save()
                        .then(function () {
                            entry.isEditing = false;
                        })
                        .finally(function () {
                            RootService.hideLoading();
                        });
                }

                // reset's the search input and check all box
                function resetSearchAndCheck() {
                    $('#manual-entries-search').val('');
                    vm.selectAll = false;
                }

                // shows a message that no items were selected
                function showNoItemsSelected() {
                    $mdDialog.show(
                        $mdDialog.alert()
                            .parent(angular.element(document.body))
                            .clickOutsideToClose(true)
                            .title($translate.instant('FE_ALERT_NO_ENTRIES_TITLE'))
                            .textContent($translate.instant('FE_ALERT_NO_ENTRIES_DESC'))
                            .ariaLabel('no items dialog')
                            .ok($translate.instant("FE_GOT_IT"))
                    );
                }

                // deletes the selected entries
                function _callbackDelete(entryIds) {
                    RootService.showLoading('FE_DELETING');

                    vm.domainEntryList.delete(entryIds)
                        .then(function () {
                            // resets some inputs
                            resetSearchAndCheck();

                            // removes the items from the list count
                            vm.authorizedSellerList.adjustEntryCount(vm.authorizedSeller.sellerId, entryIds.length * -1);
                        })
                        .finally(function () {
                            RootService.hideLoading();
                        });
                }

                // re-assigns the selected entries
                function _callbackReassign(sellerId) {
                    // gets the selected items
                    var entryIds = vm.domainEntryList.getSelectedIds();

                    RootService.showLoading('FE_REASSIGNING');

                    vm.domainEntryList.reassign(entryIds, sellerId)
                        .then(function () {
                            // resets some inputs
                            resetSearchAndCheck();

                            // removes the items from the list count and adds them to the other one
                            vm.authorizedSellerList.adjustEntryCount(vm.authorizedSeller.sellerId, entryIds.length * -1);
                            vm.authorizedSellerList.adjustEntryCount(sellerId, entryIds.length);
                        })
                        .finally(function () {
                            RootService.hideLoading();
                        });
                }
            },
            controllerAs: 'vm',
            bindToController: true
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('bulkUploadFormController', bulkUploadFormController)
        .directive('bulkUploadForm', bulkUploadFormDirective);

    /** @ngInject */
    function bulkUploadFormController($scope) {
        var BulkUploadForm = this;

        //Data
        BulkUploadForm.isSaving = false;
        BulkUploadForm.type = '';
        BulkUploadForm.defaultForm = {
            'description': ''
        };

        //Methods
        BulkUploadForm.init = init;
        BulkUploadForm.submit = submit;
        BulkUploadForm.isNotValid = isNotValid;

        //////

        function init() {
            resetForm();
        }

        $scope.$on('BulkUpload:closed', function () {
            resetForm();
        });

        function resetForm() {
            $scope.$evalAsync(function () {
                BulkUploadForm.form = angular.copy(BulkUploadForm.defaultForm);
                $('.center ').mouseenter();
            });
        }

        function submit() {
            add();
        }

        function add() {
            if (isNotValid()) {
                return;
            }

            BulkUploadForm.isSaving = true;

            if (typeof $scope.authorizedSeller !== 'undefined' && $scope.authorizedSeller.sellerId > 0) {
                // Add the list to this seller
                $scope.domainEntryList.bulkUploadSeller(BulkUploadForm.form.description, $scope.authorizedSeller.sellerId)
                    .then(function (data) {
                        $scope.authorizedSellerList.adjustEntryCount($scope.authorizedSeller.sellerId, data.success.length);
                        $scope.callbackErrors(data.error);
                        $scope.callbackDuplicateErrors(data.duplicates)
                    })
                    .finally(function () {
                        BulkUploadForm.isSaving = false;

                        // Reset the current note to an empty one
                        BulkUploadForm.form = angular.copy(BulkUploadForm.defaultForm);

                        $scope.$emit('BulkUpload:close');
                    });
            } else {
                // Add the list
                $scope.domainEntryList.bulkUpload(BulkUploadForm.form.description)
                    .then(function (data) {
                        $scope.authorizedSellerList.adjustEntryCount(0, data.success.length);
                        $scope.callbackErrors(data.error);
                        $scope.callbackDuplicateErrors(data.duplicates)
                    })
                    .finally(function () {
                        BulkUploadForm.isSaving = false;

                        // Reset the current note to an empty one
                        BulkUploadForm.form = angular.copy(BulkUploadForm.defaultForm);

                        $scope.$emit('BulkUpload:close');
                    });
            }
        }

        function isNotValid() {
            return BulkUploadForm.form.description === '' || BulkUploadForm.isSaving === true;
        }
    }

    /** @ngInject */
    function bulkUploadFormDirective() {
        return {
            restrict: 'EA',
            controller: 'bulkUploadFormController',
            controllerAs: 'BulkUploadForm',
            scope: {
                type: '=',
                domainEntryList: '=',
                callbackErrors: '=',
                callbackDuplicateErrors: '=',
                authorizedSellerList: '=',
                authorizedSeller: '='
            },
            templateUrl: 'app/main/apps/directives/bulk-upload-form/bulk-upload-form.html',
            link: function (scope, element, attributes, BulkUploadForm) {
                // Type
                BulkUploadForm.type = scope.type;
                BulkUploadForm.init();
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('bulkUploadController', bulkUploadController)
        .directive('bulkUploadButton', bulkUploadButtonDirective)
        .directive('bulkUpload', bulkUploadDirective);

    /** @ngInject */
    function bulkUploadController($scope, $document) {
        var BulkUpload = this;

        //Data
        BulkUpload.formVisible = false;
        BulkUpload.form = {
            description: ''
        };

        //Methods
        BulkUpload.open = open;
        BulkUpload.close = close;
        BulkUpload.element = [];

        //////

        /**
         * Close Trigger
         */
        $scope.$on('BulkUpload:close', function () {
            close();
        });

        function open() {
            BulkUpload.element.addClass('form-visible');
            BulkUpload.element.find('textarea').focus();
            $document.on('click', outSideClick);
        }

        function close() {
            BulkUpload.element.removeClass('form-visible');
            $scope.$broadcast('BulkUpload:closed');
            $document.off('click', outSideClick);
        }

        function outSideClick(event) {
            var isChild = BulkUpload.element.has(event.target).length > 0;
            var isSelf = BulkUpload.element[0] === event.target;
            var isMenu = angular.element(event.target).closest('md-menu-content').length > 0;
            var isCalendar = angular.element(event.target).closest('md-calendar').length > 0 || angular.element(event.target).closest('.md-datepicker-calendar-pane').length > 0 || angular.element(event.target).hasClass('md-scroll-mask');

            var isInside = isChild || isSelf || isMenu || isCalendar;
            if (!isInside) {
                close();
            }
        }
    }

    /** @ngInject */
    function bulkUploadDirective() {
        return {
            restrict: 'E',
            controller: 'bulkUploadController',
            controllerAs: 'BulkUpload',
            scope: {
                domainEntryList: '=',
                callbackErrors: '=',
                callbackDuplicateErrors: '=',
                authorizedSellerList: '=',
                authorizedSeller: '='
            },
            templateUrl: 'app/main/apps/directives/bulk-upload/bulk-upload.html',
            link: function (scope, element, attributes, BulkUpload) {
                BulkUpload.element = element;
            }
        };
    }

    /** @ngInject */
    function bulkUploadButtonDirective() {
        return {
            restrict: 'EA',
            require: '^bulkUpload',
            link: function (scope, element, attributes, bulkUpload) {
                element.on('click', function () {
                    bulkUpload.open();
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .directive('siteSelection', siteSelectionDirective);

    /** @ngInject */
    function siteSelectionDirective() {
        return {
            restrict: 'E',
            scope: {
                publisher: '=',
                quickPanel: '='
            },
            templateUrl: 'app/toolbar/directives/site-selection/site-selection.html',
            controller: function () {
                var vm = this;

                // Methods
                vm.handleSelectionsClick = handleSelectionsClick;

                // ------------------------------------------------------------------------------------------------------ //
                // Method definitions
                // ------------------------------------------------------------------------------------------------------ //

                // opens the correct tab
                function handleSelectionsClick() {
                    this.quickPanel.setSelectedTab(this.quickPanel.tabs.SITES);
                    this.quickPanel.toggle();
                }
            },
            controllerAs: 'vm',
            bindToController: true
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config() {
    }
})();

(function () {
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('TodayTabController', TodayTabController);

    /** @ngInject */
    function TodayTabController() {
        var vm = this;
        var now = moment();

        // Data
        vm.dayOfWeek = now.format("dddd");
        vm.dayOfMonth = now.format("Do").replace(/[a-z]/gi, '');
        vm.dayOfMonthSub = now.format("Do").replace(/[0-9]/g, '');
        vm.month = now.format("MMMM");
    }

})();
(function () {
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('SitesTabController', SitesTabController);

    /** @ngInject */
    function SitesTabController() {
        var vm = this;

        // Data
        vm.listOrderAsc = false;
        vm.siteSearch = "";
    }

})();
(function () {
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('HelpTabController', HelpTabController);

    /** @ngInject */
    function HelpTabController(HelpService, $window, $mdDialog, HELP_CENTER) {
        var vm = this;

        // Data
        vm.helpList = HelpService.help;
        vm.isLoading = false;
        vm.siteSearch = "";

        // Methods
        vm.gotoHelpCenter = gotoHelpCenter;
        vm.handleHelpClick = handleHelpClick;
        vm.search = search;

        // ------------------------------------------------------------------------------------------------------ //
        // Method definitions
        // ------------------------------------------------------------------------------------------------------ //

        // takes the user to the help center
        function gotoHelpCenter() {
            $window.open(HELP_CENTER);
        }

        // opens a dialog to show the selected help item
        function handleHelpClick(helpItem) {
            $mdDialog.show(
                $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .title(helpItem.title)
                    .htmlContent(helpItem.body + "<br><p><a href='"+helpItem.url +"' target='_helpcenter'>Visit the article in the Help Center</a></p>")
                    .ariaLabel('Help')
                    .ok('Close')
            );
        }

        // processes a help search request
        function search(event) {
            if (event.which === 13) {
                vm.isLoading = true;
                if (event.target.value === "") {
                    HelpService.get($window.location.pathname).finally(function () {
                        vm.isLoading = false;
                    });
                } else {
                    HelpService.search(event.target.value).finally(function () {
                        vm.isLoading = false;
                    });
                }
            }
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('Error503Controller', Error503Controller);

    /** @ngInject */
    function Error503Controller(RootService, $state) {
        var vm = this;
        vm.goBack = function () {
            RootService.showLoading("FE_LOADING");
            $state.go(RootService.states.DEFAULT_STATE);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('fuse')
        .factory('Errors', Errors);

    /** @ngInject */
    function Errors($rootScope) {

        return {
            DB_ERROR: "DB_ERROR",
            INTERNAL_ERROR: "INTERNAL_ERROR",
            create: create,
            show: show
        };

        ////////////////////////////////////////////////////////////////////////

        function create(type, code, message) {
            $rootScope.loadingProgress = false;
            var typeMessage = message;

            switch (type) {
                case 'DB_ERROR':
                    typeMessage = "Just kidding, looks like we have an internal issue, please try again in couple minutes";
                    break;
                case 'INTERNAL_ERROR':
                    typeMessage = "Just kidding, looks like we have an internal issue, please try again in couple minutes";
                    break;
            }

            return {
                type: type,
                code: code,
                message: typeMessage
            };
        }

        function show(state, error, goToStateName) {
            var s = state.get('app.errors_error-500');
            s.error = error;
            s.error.fromStateName = goToStateName;
            state.go('app.errors_error-500');
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.errors.error-500', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider
            .state('app.errors_error-500', {
                url: '/error/500',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/errors/500/error-500.html',
                        controller: 'Error500Controller as vm'
                    }
                },
                resolve: {
                    errorObj: [function () {
                        return this.self.error;
                    }],
                    PreviousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name,
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                            return currentStateData;
                        }
                    ]
                }
            });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.errors.error-500')
        .controller('Error500Controller', Error500Controller);

    /** @ngInject */
    function Error500Controller(errorObj, $state, PreviousState, RootService) {
        var vm = this;

        // Data
        vm.error = {};

        // Methods
        vm.goBack = goBack;

        // ------------------------------------------------------------------------------------------------------ //
        // ------------------------------------------------------------------------------------------------------ //

        activate();

        // ------------------------------------------------------------------------------------------------------ //
        // ------------------------------------------------------------------------------------------------------ //

        function activate() {
            if (typeof errorObj === "undefined") {
                vm.error.message = "";
                vm.error.fromStateName = RootService.states.DEFAULT_STATE;
                vm.error.code = 500;
            } else {
                vm.error = errorObj;
            }

            if (PreviousState.name !== "") {
                vm.error.fromStateName = PreviousState.name;
                vm.error.fromStateParams = PreviousState.params;
            }

            if (typeof vm.error.fromStateName === "undefined" || vm.error.fromStateName === null || vm.error.fromStateName === "") {
                vm.error.fromStateName = RootService.states.DEFAULT_STATE;
            }
        }

        function goBack() {
            if (Helper.isUnsetOrEmpty(vm.error.fromStateParams)) {
                $state.go(vm.error.fromStateName);
            } else {
                $state.go(vm.error.fromStateName, vm.error.fromStateParams);
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('Error404Controller', Error404Controller);

    /** @ngInject */
    function Error404Controller($state, RootService) {
        var vm = this;
        vm.goBack = function () {
            RootService.showLoading("FE_LOADING");
            $state.go(RootService.states.DEFAULT_STATE);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .directive('rangeDatePicker', rangeDatePickerDirective);

    /** @ngInject */
    function rangeDatePickerDirective(DatePickerHelper) {
        return {
            restrict: 'E',
            scope: {
                options: "=ngModel"
            },
            templateUrl: 'app/main/directives/range-date-picker/range-date-picker.html',
            link: function (scope) {
                // Data
                scope.inputDate = "";
                scope.compareToText = typeof scope.options.compareToText !== 'undefined' ? scope.options.compareToText : "Compare to";
                scope.previousRange = {};
                scope.baseRanges = DatePickerHelper.getBaseDates();
                scope.prevRanges = DatePickerHelper.getPreviousDates();
                scope.currentBaseOption = typeof scope.options.baseSelectId !== 'undefined' && scope.options.baseSelectId !== null ? Number(scope.options.baseSelectId) : 5;
                scope.currentCompareOption = typeof scope.options.compareSelectId !== 'undefined' && scope.options.compareSelectId !== null ? Number(scope.options.compareSelectId) : null;
                scope.currentCompareChecked = typeof scope.options.compareChecked !== 'undefined' && scope.options.compareChecked !== null ? scope.options.compareChecked : false;

                var defaultBaseRange = angular.copy(scope.baseRanges[scope.currentBaseOption].range);
                if (scope.options.baseSelectId === DatePickerHelper.selectIds.BASE_CUSTOM) {
                    defaultBaseRange[0] = scope.options.baseMoments.start;
                    defaultBaseRange[1] = scope.options.baseMoments.end;
                }

                var defaultCompareRange = angular.copy(getCompareDefaultRange(scope.currentCompareOption, defaultBaseRange[0], defaultBaseRange[1]));
                if (scope.options.compareSelectId === DatePickerHelper.selectIds.COMPARE_CUSTOM) {
                    defaultCompareRange[0] = scope.options.compareMoments.start;
                    defaultCompareRange[1] = scope.options.compareMoments.end;
                }

                var localOptionsTemplate = {
                    currentFocusId: "",
                    baseSelectId: scope.currentBaseOption,
                    baseEndMoment: defaultBaseRange[1],
                    baseStartMoment: defaultBaseRange[0],
                    compareChecked: scope.currentCompareChecked,
                    compareSelectId: scope.currentCompareOption,
                    compareEndMoment: defaultCompareRange[1],
                    compareStartMoment: defaultCompareRange[0],
                    customBaseRange: false,
                    customCompareRange: false,
                    getMomentString: function (momentType) {
                        var m = null;
                        switch (momentType) {
                            case 'baseStartMoment':
                                m = this.baseStartMoment;
                                break;
                            case 'baseEndMoment':
                                m = this.baseEndMoment;
                                break;
                            case 'compareStartMoment':
                                m = this.compareStartMoment;
                                break;
                            case 'compareEndMoment':
                                m = this.compareEndMoment;
                                break;
                        }
                        return m !== null ? m.format("YYYY-MM-DD") : "";
                    }
                };
                var localOptions = angular.copy(localOptionsTemplate);

                var to = new Date();
                var from = new Date(to.getTime() - 1000 * 60 * 60 * 24 * 14);
                var calendars = $('#datepicker-calendar', ".ez-date-picker").DatePickerInit({
                    inline: true,
                    date: [from, to],
                    calendars: 3,
                    mode: 'range',
                    locale: DatePickerHelper.loadLocale(),
                    onRangeChange: function () {
                        addRangeClasses();
                    },
                    onChange: onCalendarsChange
                });

                // ------------------------------------------------------------------------------------------------------ //
                // ------------------------------------------------------------------------------------------------------ //

                init();

                // ------------------------------------------------------------------------------------------------------ //
                // ------------------------------------------------------------------------------------------------------ //

                function addRangeClasses() {
                    if ($('#datepicker-calendar .datepickerSelected', ".ez-date-picker").not('.datepickerDisabled').length > 2) {
                        $('#datepicker-calendar .datepickerSelected', ".ez-date-picker").not('.datepickerDisabled').first().addClass("firstBase");
                        $('#datepicker-calendar .datepickerSelected', ".ez-date-picker").not('.datepickerDisabled').last().addClass("lastBase");
                    }
                    if ($('#datepicker-calendar .datepickerCompareSelected', ".ez-date-picker").not('.datepickerDisabled').length > 2) {
                        $('#datepicker-calendar .datepickerCompareSelected', ".ez-date-picker").not('.datepickerDisabled').first().addClass("firstCompare");
                        $('#datepicker-calendar .datepickerCompareSelected', ".ez-date-picker").not('.datepickerDisabled').last().addClass("lastCompare");
                    }
                }

                function setMoment(type, date) {
                    switch (type) {
                        case 'BaseStart':
                            setBaseDate(date, null, "Start");
                            localOptions.baseStartMoment = getDateMoment("BaseStart");
                            break;
                        case 'BaseEnd':
                            setBaseDate(null, date, "End");
                            localOptions.baseEndMoment = getDateMoment("BaseEnd");
                            break;
                        case 'CompareStart':
                            setCompareDate(date, null, "Start");
                            localOptions.compareStartMoment = getDateMoment("CompareStart");
                            break;
                        case 'CompareEnd':
                            setCompareDate(null, date, "End");
                            localOptions.compareEndMoment = getDateMoment("CompareEnd");
                            break;
                    }
                }

                function baseStartCaseHandler(startDate) {
                    setMoment('BaseStart', startDate);
                    if (localOptions.baseStartMoment > localOptions.baseEndMoment) {
                        setMoment('BaseEnd', startDate);
                    }
                    localOptions.currentFocusId = "inputBaseEndDate";
                    load();
                }

                function compareStartCaseHandler(startDate) {
                    setMoment('CompareStart', startDate);
                    if (localOptions.compareStartMoment > localOptions.compareEndMoment) {
                        setMoment('CompareEnd', startDate);
                    }
                    localOptions.currentFocusId = "inputCompareEndDate";
                    load();
                }

                function baseEndCaseHandler(endDate) {
                    setMoment('BaseEnd', endDate);
                    if (localOptions.baseStartMoment > localOptions.baseEndMoment) {
                        setMoment('BaseEnd', localOptions.baseStartMoment._d);
                        setMoment('BaseStart', endDate);
                    }
                    updateLocalCompareMoments();
                    setCurrentFocusCheckCompareFirst();
                    load();
                }

                function getCompareDefaultRange(compareSelectId, baseStartMoment, baseEndMoment) {
                    var range = [];
                    switch (compareSelectId) {
                        case 3:
                            range = [null, null];
                            break;
                        case 2:
                            range = DatePickerHelper.getPreviousYearCustomBaseRange(baseStartMoment, baseEndMoment);
                            break;
                        case 1:
                            range = DatePickerHelper.getPreviousWeekCustomBaseRange(baseStartMoment, baseEndMoment);
                            break;
                        case 0:
                            range = DatePickerHelper.getPreviousCustomBaseRange(baseStartMoment, baseEndMoment);
                            break;
                    }
                    return range;
                }

                function updateLocalCompareMoments() {
                    // dates is [] (empty) when custom
                    var dates = DatePickerHelper.getCompareDatesFromCompareSelectId(localOptions.compareSelectId, localOptions.baseStartMoment, localOptions.baseEndMoment);
                    if (dates.length > 0) {
                        updateLocalCompareMomentsFromRange(dates);
                    }
                }

                function compareEndCaseHandler(endDate) {
                    setMoment('CompareEnd', endDate);
                    if (localOptions.compareStartMoment > localOptions.compareEndMoment) {
                        setMoment('CompareEnd', localOptions.compareStartMoment._d);
                        setMoment('CompareStart', endDate);
                    }
                    if (DatePickerHelper.isBaseCustom(localOptions.baseSelectId)) {
                        localOptions.currentFocusId = "inputBaseStartDate";
                    } else if (DatePickerHelper.isCompareCustom(localOptions.compareSelectId)) {
                        localOptions.currentFocusId = "inputCompareStartDate";
                    } else {
                        localOptions.currentFocusId = "";
                    }
                    load();
                }

                function disableCheckBox() {
                    $("#inputCompareCheckbox", ".ez-date-picker").addClass("disableApply");
                    $("#compareRange", ".ez-date-picker").addClass("disableApply");
                    $("#inputCompareCheckbox", ".ez-date-picker").prop('disabled', true);
                    $("#compareRange", ".ez-date-picker").prop('disabled', true);
                }

                function disableCompareSelect() {
                    $("#compareSelect select", ".ez-date-picker").addClass("disableApply");
                    $("#compareSelect select", ".ez-date-picker").prop('disabled', true);
                }

                function enableCheckBox() {
                    $("#inputCompareCheckbox", ".ez-date-picker").removeClass("disableApply");
                    $("#compareRange", ".ez-date-picker").removeClass("disableApply");
                    $("#inputCompareCheckbox", ".ez-date-picker").prop('disabled', false);
                    $("#compareRange", ".ez-date-picker").prop('disabled', false);
                }

                function enableCompareSelect() {
                    $("#compareSelect select", ".ez-date-picker").removeClass("disableApply");
                    $("#compareSelect select", ".ez-date-picker").prop('disabled', false);
                }

                function getDateFromCalendarDates(dates, posStr) {
                    var calendarDate;

                    if (dates.length === 2) {
                        if (posStr === "start") {
                            calendarDate = dates[0];
                        } else {
                            if (String(dates[3]) === "Invalid Date") {
                                scope.compareStartDate = dates[1];
                                var fixCompareMoment = moment().month(scope.compareStartDate.getMonth()).day(scope.compareStartDate.getDate()).subtract(1, 'days');
                                calendarDate = fixCompareMoment._d;
                            } else {
                                calendarDate = dates[1];
                            }
                        }
                    } else {
                        if (posStr === "end") {
                            calendarDate = dates[3];
                        } else {
                            calendarDate = dates[2];
                        }
                    }

                    return calendarDate;
                }

                function getDateMoment(posStr) {
                    var dateStr = $("#input" + posStr + "Date", ".ez-date-picker").val();
                    if (typeof dateStr === "undefined") {
                        return;
                    }

                    dateStr = dateStr.trim();
                    dateStr = ( dateStr.indexOf("/") ) ? dateStr.split("/").join("-") : dateStr;
                    var dateArray = dateStr.split("-");

                    var dateMoment = moment();
                    dateMoment.month(dateArray[0] - 1);
                    dateMoment.date(dateArray[1]);
                    dateMoment.year(dateArray[2]);
                    return dateMoment;
                }

                function init() {
                    setupEvents();
                    if (scope.options.isInitialized !== true) {
                        initializeScope();
                    } else {
                        initializeLocalOptions();
                    }
                    load();
                    updateInputDate();
                }

                function initializeLocalOptions() {
                    localOptions.baseStartMoment = moment(scope.options.baseStartDate);
                    localOptions.baseEndMoment = moment(scope.options.baseEndDate);
                    localOptions.baseSelectId = scope.options.baseSelectId;
                    localOptions.compareStartMoment = moment(scope.options.compareStartDate);
                    localOptions.compareEndMoment = moment(scope.options.compareEndDate);
                    localOptions.compareSelectId = scope.options.compareSelectId;
                    localOptions.compareChecked = scope.options.compareChecked;
                    localOptions.currentFocusId = scope.options.currentFocusId;
                    scope.currentBaseOption = scope.options.baseSelectId;
                }

                function initializeScope() {
                    scope.options.baseStartDate = localOptions.getMomentString('baseStartMoment');
                    scope.options.baseEndDate = localOptions.getMomentString('baseEndMoment');
                    scope.options.baseSelectId = localOptions.baseSelectId;
                    scope.options.compareChecked = localOptions.compareChecked;
                    if (localOptions.compareChecked === true) {
                        scope.options.compareSelectId = localOptions.compareSelectId;
                        scope.options.compareStartDate = localOptions.getMomentString('compareStartMoment');
                        scope.options.compareEndDate = localOptions.getMomentString('compareEndMoment');
                    } else {
                        scope.options.compareSelectId = null;
                        scope.options.compareStartDate = null;
                        scope.options.compareEndDate = null;
                    }
                    scope.options.isInitialized = true;
                    scope.options.currentFocusId = localOptions.currentFocusId;
                }

                function newDateAdded(posStr) {
                    var inputBox = $("#input" + posStr + "Date", ".ez-date-picker");
                    var enteredDate = inputBox.val();
                    var checkDateObj = DatePickerHelper.isDate(enteredDate);

                    // Walk through Base From to Base To first
                    if (checkDateObj.isValid) {
                        switch (posStr) {
                            case "BaseStart" :
                                baseStartCaseHandler(checkDateObj.date);
                                break;
                            case "BaseEnd" :
                                baseEndCaseHandler(checkDateObj.date);
                                break;
                            case "CompareStart" :
                                compareStartCaseHandler(checkDateObj.date);
                                break;
                            case "CompareEnd" :
                                compareEndCaseHandler(checkDateObj.date);
                                break;
                        }

                    } else {
                        inputBox.addClass("errorInputTxt");
                    }
                }

                function onCalendarsChange(dates) {
                    if (Helper.isUnsetOrEmpty(localOptions.currentFocusId)) {
                        localOptions.currentFocusId = "inputBaseStartDate";
                        localOptions.baseSelectId = 0;
                    } else if (["inputBaseStartDate", "inputBaseEndDate"].indexOf(localOptions.currentFocusId) !== -1) {
                        localOptions.baseSelectId = 0;
                    } else if (["inputCompareStartDate", "inputCompareEndDate"].indexOf(localOptions.currentFocusId) !== -1) {
                        localOptions.compareSelectId = 3;
                    }

                    var compareStartDate = getDateFromCalendarDates(dates, "start");
                    var compareEndDate = getDateFromCalendarDates(dates, "end");

                    switch (localOptions.currentFocusId) {
                        case "inputBaseStartDate" :
                            if (String(compareStartDate) === "Invalid Date") compareStartDate = dates[1];
                            baseStartCaseHandler(compareStartDate);
                            break;
                        case "inputBaseEndDate" :
                            baseEndCaseHandler(compareEndDate);
                            break;
                        case "inputCompareStartDate" :
                            compareStartCaseHandler(compareStartDate);
                            break;
                        case "inputCompareEndDate" :
                            compareEndCaseHandler(compareEndDate);
                            break;
                    }
                }

                function load() {
                    $('#datepicker-calendar', ".ez-date-picker").DatePickerClear();
                    $("#baseSelect, #inputBaseStartDate, #inputBaseEndDate, #inputCompareStartDate, #inputCompareEndDate", ".ez-date-picker").removeClass("compareRangeSelected disableApply baseRangeSelected");
                    $("#inputBaseStartDate, #inputBaseEndDate, #inputCompareStartDate, #inputCompareEndDate", ".ez-date-picker").val("");
                    setAllDisabled();
                    calendars.DatePickerClearLastSelected();

                    var dates = [];

                    if (localOptions.baseStartMoment !== null) {
                        setBaseDate(localOptions.baseStartMoment._d, null, "Start");
                        dates.push(localOptions.baseStartMoment._d);
                    }
                    if (localOptions.baseEndMoment !== null) {
                        setBaseDate(null, localOptions.baseEndMoment._d, "End");
                        dates.push(localOptions.baseEndMoment._d);
                    }

                    if (DatePickerHelper.isBaseCustom(localOptions.baseSelectId)) {
                        setBaseInputsEnabled();
                        disableCheckBox();
                        if (localOptions.baseStartMoment === null) {
                            localOptions.currentFocusId = "inputBaseStartDate";
                        }
                        if (localOptions.baseStartMoment !== null && localOptions.baseEndMoment !== null) {
                            enableCheckBox();
                        }
                    } else {
                        enableCheckBox();
                    }

                    if (localOptions.compareChecked === true) {
                        if (DatePickerHelper.isCompareCustom(localOptions.compareSelectId)) {
                            setCompareInputsEnabled();
                        }
                        if (localOptions.compareStartMoment !== null) {
                            setCompareDate(localOptions.compareStartMoment._d, null, "Start");
                            dates.push(localOptions.compareStartMoment._d);
                        }
                        if (localOptions.compareEndMoment !== null) {
                            setCompareDate(null, localOptions.compareEndMoment._d, "End");
                            dates.push(localOptions.compareEndMoment._d);
                        }
                    }

                    calendars.DatePickerSetDate(dates, false);

                    // COMPARE CHECK BOX
                    $('#inputCompareCheckbox', ".ez-date-picker").prop('checked', localOptions.compareChecked);

                    // COMPARE SELECT & INPUTS
                    if (localOptions.compareChecked) {
                        enableCompareSelect();
                        $("#compareGroup", ".ez-date-picker").show();
                    } else {
                        disableCompareSelect();
                        $("#compareGroup", ".ez-date-picker").hide();
                    }

                    // SELECT VALUES
                    $("#baseSelect select > option:eq(" + localOptions.baseSelectId + ")", ".ez-date-picker").prop('selected', true);
                    $("#compareSelect select > option:eq(" + localOptions.compareSelectId + ")", ".ez-date-picker").prop('selected', true);

                    // APPLY BUTTON
                    if (localOptions.baseStartMoment !== null && localOptions.baseEndMoment !== null &&
                        (localOptions.compareChecked === false || (localOptions.compareChecked === true && localOptions.compareStartMoment !== null && localOptions.compareEndMoment !== null))) {
                        setApplyEnabled();
                    } else {
                        setApplyDisabled();
                    }

                    if (localOptions.currentFocusId.length > 0) {
                        setCurrentFocus(localOptions.currentFocusId);
                    }

                    addRangeClasses();
                }

                function reset() {
                    initializeLocalOptions();
                    load();
                }

                function setAllDisabled() {
                    setBaseInputsDisabled();
                    setCompareInputsDisabled();
                }

                function setApplyDisabled() {
                    $("#applyDates", ".ez-date-picker").addClass("disableApply");
                    $("#applyDates", ".ez-date-picker").prop('disabled', true);
                }

                function setApplyEnabled() {
                    $("#applyDates", ".ez-date-picker").removeClass("disableApply");
                    $("#applyDates", ".ez-date-picker").prop('disabled', false);
                }

                function setBaseDate(startDate, endDate, posStr) {
                    var baseDate = (posStr === "Start") ? startDate : endDate;
                    var baseNumDateStr = ( baseDate.getMonth() + 1 ) + "/" + baseDate.getDate() + "/" + baseDate.getFullYear();
                    $("#inputBase" + posStr + "Date", ".ez-date-picker").val(baseNumDateStr);

                    // need up update the base moments
                    if (posStr === "Start") {
                        if (null !== localOptions.baseStartMoment) {
                            localOptions.baseStartMoment.year(baseDate.getFullYear());
                            localOptions.baseStartMoment.month(baseDate.getMonth());
                            localOptions.baseStartMoment.date(baseDate.getDate());
                        }
                    } else {
                        if (null !== localOptions.baseEndMoment) {
                            // this order matters
                            // in different year some months will different number of days
                            localOptions.baseEndMoment.year(baseDate.getFullYear());
                            localOptions.baseEndMoment.month(baseDate.getMonth());
                            localOptions.baseEndMoment.date(baseDate.getDate());
                        }
                    }
                }

                function setBaseInputsDisabled() {
                    $("#inputBaseStartDate", ".ez-date-picker").addClass("disableApply");
                    $("#inputBaseEndDate", ".ez-date-picker").addClass("disableApply");
                }

                function setBaseInputsEnabled() {
                    $("#inputBaseStartDate, #inputBaseEndDate", ".ez-date-picker").removeClass("disableApply");
                }

                function setCompareInputsEnabled() {
                    $("#inputCompareStartDate, #inputCompareEndDate", ".ez-date-picker").removeClass("disableApply");
                }

                function setCompareDate(startDate, endDate, posStr) {
                    var compareDate = (posStr === "Start") ? startDate : endDate;
                    var compareNumDateStr = ( Number(compareDate.getMonth()) + 1 ) + "/" + compareDate.getDate() + "/" + compareDate.getFullYear();
                    $("#inputCompare" + posStr + "Date", ".ez-date-picker").val(compareNumDateStr);

                    if (posStr === "Start") {
                        if (null !== localOptions.compareStartMoment) {
                            localOptions.compareStartMoment.year(compareDate.getFullYear());
                            localOptions.compareStartMoment.month(compareDate.getMonth());
                            localOptions.compareStartMoment.date(compareDate.getDate());
                        }
                    } else {
                        if (null !== localOptions.compareEndMoment) {
                            // this order matters
                            // in different year some months will different number of days
                            localOptions.compareEndMoment.year(compareDate.getFullYear());
                            localOptions.compareEndMoment.month(compareDate.getMonth());
                            localOptions.compareEndMoment.date(compareDate.getDate());
                        }
                    }
                }

                function setCompareInputsDisabled() {
                    $("#inputCompareStartDate, #inputCompareEndDate", ".ez-date-picker").addClass("disableApply");
                }

                function removeInputFocuses() {
                    $("#baseSelect, #inputBaseStartDate, #inputBaseEndDate, #inputCompareStartDate, #inputCompareEndDate", ".ez-date-picker").removeClass("compareRangeSelected baseRangeSelected");
                }

                function setCurrentFocus(inputId) {
                    removeInputFocuses();
                    localOptions.currentFocusId = inputId;
                    var currentFocusId = inputId;
                    var curInputEl = $("#" + currentFocusId, ".ez-date-picker");
                    if (currentFocusId.indexOf("Compare") !== -1) curInputEl.addClass("compareRangeSelected");
                    else curInputEl.addClass("baseRangeSelected");
                }

                function setupEvents() {
                    var checkAlpha = function (event) {
                        var code = (event.keyCode ? event.keyCode : event.which);
                        if (!(
                                (code >= 48 && code <= 57) //numbers
                                || (code === 47) //forward slash
                            )
                            || (code === 46 && $(this).val().indexOf('.') !== -1)
                        )
                            event.preventDefault();
                    };

                    // APPLY DATES
                    $("#applyDates", ".ez-date-picker").on("click", function () {
                        localOptions.currentFocusId = "";
                        if (DatePickerHelper.isBaseCustom(localOptions.baseSelectId)) localOptions.currentFocusId = "inputBaseStartDate";
                        else if (!DatePickerHelper.isBaseCustom(localOptions.baseSelectId) && DatePickerHelper.isCompareCustom(localOptions.compareSelectId) && localOptions.compareChecked === true) localOptions.currentFocusId = "inputCompareStartDate";
                        initializeScope();
                        updateInputDate();
                        load();
                    });

                    // CANCEL DATES
                    $("#cancelDates", ".ez-date-picker").on("click", function () {
                        reset();
                    });

                    // FOCUS START BASE
                    $("#inputBaseStartDate", ".ez-date-picker").on("focus", function () {
                        calendars.DatePickerClearLastSelected();
                        setCurrentFocus($(this).attr("id"));
                    });
                    $("#inputBaseEndDate", ".ez-date-picker").on("focus", function () {
                        setCurrentFocus($(this).attr("id"));
                    });
                    $("#inputCompareStartDate", ".ez-date-picker").on("focus", function () {
                        setCurrentFocus($(this).attr("id"));
                    });
                    $("#inputCompareEndDate", ".ez-date-picker").on("focus", function () {
                        setCurrentFocus($(this).attr("id"));
                    });

                    // KEYPRESS
                    $("#inputBaseStartDate", ".ez-date-picker").on("keypress", function (event) {
                        checkAlpha(event);
                        var code = event.keyCode || event.which;
                        if (code === 13) {
                            newDateAdded("BaseStart");
                        }
                    });
                    $("#inputBaseEndDate", ".ez-date-picker").on('keypress', function (e) {
                        checkAlpha(e);
                        var code = e.keyCode || e.which;
                        if (code === 13) {
                            newDateAdded("BaseEnd");
                        }
                    });
                    $("#inputCompareStartDate", ".ez-date-picker").on('keypress', function (e) {
                        checkAlpha(e);
                        var code = e.keyCode || e.which;
                        if (code === 13) {
                            newDateAdded("CompareStart");
                        }
                    });
                    $("#inputCompareEndDate", ".ez-date-picker").on('keypress', function (e) {
                        checkAlpha(e);
                        var code = e.keyCode || e.which;
                        if (code === 13) {
                            newDateAdded("CompareEnd");
                        }
                    });

                    // BASE SELECT CHANGE !!!!!!!!!!!
                    $("#baseSelect", ".ez-date-picker").on("change", function (e) {
                        var idNum = Number(e.target.value);

                        localOptions.baseSelectId = idNum;

                        setCurrentFocusCheckBaseFirst();

                        for (var i = 1; i < scope.baseRanges.length; i++) {
                            if (i === idNum) {
                                updateLocalBaseMomentsFromRange(scope.baseRanges[i].range);
                                if (localOptions.compareChecked && !DatePickerHelper.isCompareCustom(localOptions.compareSelectId)) {
                                    updateCompareMoments();
                                }
                                break;
                            }
                        }

                        load();
                    });

                    // COMPARE SELECT CHANGED
                    $("#compareSelect", ".ez-date-picker").on("change", function (e) {
                        localOptions.compareSelectId = Number(e.target.value);

                        setCurrentFocusCheckCompareFirst();

                        if (!DatePickerHelper.isCompareCustom(localOptions.compareSelectId)) {
                            updateCompareMoments();
                        }

                        load();
                    });

                    // COMPARE CHECKBOX CHECKED
                    $("#inputCompareCheckbox", ".ez-date-picker").on("change", function (e) {
                        localOptions.compareChecked = e.currentTarget.checked;
                        if (localOptions.compareChecked === false) {
                            localOptions.compareSelectId = 0;
                        } else {
                            updateCompareMoments();
                        }
                        load();
                    });
                }

                function setCurrentFocusCheckBaseFirst() {
                    if (DatePickerHelper.isBaseCustom(localOptions.baseSelectId)) {
                        localOptions.currentFocusId = "inputBaseStartDate";
                    } else if (DatePickerHelper.isCompareCustom(localOptions.compareSelectId)) {
                        localOptions.currentFocusId = "inputCompareStartDate";
                    } else {
                        localOptions.currentFocusId = "";
                    }
                }
                function setCurrentFocusCheckCompareFirst() {
                    if (DatePickerHelper.isCompareCustom(localOptions.compareSelectId)) {
                        localOptions.currentFocusId = "inputCompareStartDate";
                    } else if (DatePickerHelper.isBaseCustom(localOptions.baseSelectId)) {
                        localOptions.currentFocusId = "inputBaseStartDate";
                    } else {
                        localOptions.currentFocusId = "";
                    }
                }

                function updateCompareMoments() {
                    if (localOptions.compareChecked === true) {
                        switch (localOptions.compareSelectId) {
                            case 0:
                            default:
                                localOptions.compareSelectId = 0;
                                updateLocalCompareMomentsFromRange(DatePickerHelper.getPreviousCustomBaseRange(localOptions.baseStartMoment, localOptions.baseEndMoment));
                                break;
                            case 1:
                                updateLocalCompareMomentsFromRange(DatePickerHelper.getPreviousWeekCustomBaseRange(localOptions.baseStartMoment, localOptions.baseEndMoment));
                                break;
                            case 2:
                                updateLocalCompareMomentsFromRange(DatePickerHelper.getPreviousYearCustomBaseRange(localOptions.baseStartMoment, localOptions.baseEndMoment));
                                break;
                            case 3:
                                localOptions.currentFocusId = "inputCompareStartDate";
                                localOptions.compareEndMoment = null;
                                localOptions.compareStartMoment = null;
                                break;
                        }
                    }
                }

                function updateInputDate() {
                    var format = "MMM D, YYYY";
                    var inputBaseStartMoment = getDateMoment("BaseStart");
                    var inputBaseEndMoment = getDateMoment("BaseEnd");
                    var inputCompareStartMoment = getDateMoment("CompareStart");
                    var inputCompareEndMoment = getDateMoment("CompareEnd");

                    scope.inputDate = "<span class='ez-date-picker-base-date'>{0} - {1}</span>".sprintF(inputBaseStartMoment.format(format), inputBaseEndMoment.format(format));
                    if (scope.options.compareChecked === true) {
                        scope.inputDate = "{0}<br><span class='ez-date-picker-compare-label'>{1}: </span><span class='ez-date-picker-compare-date'>{2} - {3}</span>".sprintF(scope.inputDate, scope.compareToText, inputCompareStartMoment.format(format), inputCompareEndMoment.format(format));
                    }
                }

                function updateLocalBaseMomentsFromRange(range) {
                    if (range.length === 2) {
                        localOptions.baseStartMoment = angular.copy(range[0]);
                        localOptions.baseEndMoment = angular.copy(range[1]);
                    } else {
                        localOptions.baseStartMoment = null;
                        localOptions.baseEndMoment = null;
                    }
                }

                function updateLocalCompareMomentsFromRange(range) {
                    if (range.length === 2) {
                        localOptions.compareStartMoment = range[0];
                        localOptions.compareEndMoment = range[1];
                    } else {
                        localOptions.compareStartMoment = null;
                        localOptions.compareEndMoment = null;
                    }
                }
            }
        };
    }
})();
/**
 * DatePicker 1.0.0
 *
 * A jQuery-based DatePicker that provides an easy way of creating both single
 * and multi-viewed calendars capable of accepting single, range, and multiple
 * selected dates.  Easily styled with two example styles provided: an attractive
 * 'dark' style, and a Google Analytics-like 'clean' style.
 *
 * View project page for Examples and Documentation:
 * http://foxrunsoftware.github.com/DatePicker/
 *
 * This project is distinct from and not affiliated with the jquery.ui.datepicker.
 *
 * Copyright 2012, Justin Stern (www.foxrunsoftware.net)
 * Dual licensed under the MIT and GPL Version 2 licenses.
 *
 * Based on Work by Original Author: Stefan Petre www.eyecon.ro
 *
 * Depends:
 *   jquery.js
 */
(function ($) {
    var cache = {}, tmpl,
        DatePicker = function () {
            var ids = {},
                views = {
                    years: 'datepickerViewYears',
                    moths: 'datepickerViewMonths',
                    days: 'datepickerViewDays'
                },
                tpl = {
                    wrapper: '<div class="datepicker"><div class="datepickerBorderT" /><div class="datepickerBorderB" /><div class="datepickerBorderL" /><div class="datepickerBorderR" /><div class="datepickerBorderTL" /><div class="datepickerBorderTR" /><div class="datepickerBorderBL" /><div class="datepickerBorderBR" /><div class="datepickerContainer"><table cellspacing="0" cellpadding="0"><tbody><tr></tr></tbody></table></div></div>',
                    head: [
                        '<td class="datepickerBlock">',
                        '<table cellspacing="0" cellpadding="0">',
                        '<thead>',
                        '<tr>',
                        '<th colspan="7"><a class="datepickerGoPrev" href="#"><span><%=prev%></span></a>',
                        '<a class="datepickerMonth" href="#"><span></span></a>',
                        '<a class="datepickerGoNext" href="#"><span><%=next%></span></a></th>',
                        '</tr>',
                        '<tr class="datepickerDoW">',
                        '<th><span><%=day1%></span></th>',
                        '<th><span><%=day2%></span></th>',
                        '<th><span><%=day3%></span></th>',
                        '<th><span><%=day4%></span></th>',
                        '<th><span><%=day5%></span></th>',
                        '<th><span><%=day6%></span></th>',
                        '<th><span><%=day7%></span></th>',
                        '</tr>',
                        '</thead>',
                        '</table></td>'
                    ],
                    space: '<td class="datepickerSpace"><span></span></td>',
                    days: [
                        '<tbody class="datepickerDays">',
                        '<tr>',
                        '<td class="<%=weeks[0].days[0].classname%>"><a href="#"><span><%=weeks[0].days[0].text%></span></a></td>',
                        '<td class="<%=weeks[0].days[1].classname%>"><a href="#"><span><%=weeks[0].days[1].text%></span></a></td>',
                        '<td class="<%=weeks[0].days[2].classname%>"><a href="#"><span><%=weeks[0].days[2].text%></span></a></td>',
                        '<td class="<%=weeks[0].days[3].classname%>"><a href="#"><span><%=weeks[0].days[3].text%></span></a></td>',
                        '<td class="<%=weeks[0].days[4].classname%>"><a href="#"><span><%=weeks[0].days[4].text%></span></a></td>',
                        '<td class="<%=weeks[0].days[5].classname%>"><a href="#"><span><%=weeks[0].days[5].text%></span></a></td>',
                        '<td class="<%=weeks[0].days[6].classname%>"><a href="#"><span><%=weeks[0].days[6].text%></span></a></td>',
                        '</tr>',
                        '<tr>',
                        '<td class="<%=weeks[1].days[0].classname%>"><a href="#"><span><%=weeks[1].days[0].text%></span></a></td>',
                        '<td class="<%=weeks[1].days[1].classname%>"><a href="#"><span><%=weeks[1].days[1].text%></span></a></td>',
                        '<td class="<%=weeks[1].days[2].classname%>"><a href="#"><span><%=weeks[1].days[2].text%></span></a></td>',
                        '<td class="<%=weeks[1].days[3].classname%>"><a href="#"><span><%=weeks[1].days[3].text%></span></a></td>',
                        '<td class="<%=weeks[1].days[4].classname%>"><a href="#"><span><%=weeks[1].days[4].text%></span></a></td>',
                        '<td class="<%=weeks[1].days[5].classname%>"><a href="#"><span><%=weeks[1].days[5].text%></span></a></td>',
                        '<td class="<%=weeks[1].days[6].classname%>"><a href="#"><span><%=weeks[1].days[6].text%></span></a></td>',
                        '</tr>',
                        '<tr>',
                        '<td class="<%=weeks[2].days[0].classname%>"><a href="#"><span><%=weeks[2].days[0].text%></span></a></td>',
                        '<td class="<%=weeks[2].days[1].classname%>"><a href="#"><span><%=weeks[2].days[1].text%></span></a></td>',
                        '<td class="<%=weeks[2].days[2].classname%>"><a href="#"><span><%=weeks[2].days[2].text%></span></a></td>',
                        '<td class="<%=weeks[2].days[3].classname%>"><a href="#"><span><%=weeks[2].days[3].text%></span></a></td>',
                        '<td class="<%=weeks[2].days[4].classname%>"><a href="#"><span><%=weeks[2].days[4].text%></span></a></td>',
                        '<td class="<%=weeks[2].days[5].classname%>"><a href="#"><span><%=weeks[2].days[5].text%></span></a></td>',
                        '<td class="<%=weeks[2].days[6].classname%>"><a href="#"><span><%=weeks[2].days[6].text%></span></a></td>',
                        '</tr>',
                        '<tr>',
                        '<td class="<%=weeks[3].days[0].classname%>"><a href="#"><span><%=weeks[3].days[0].text%></span></a></td>',
                        '<td class="<%=weeks[3].days[1].classname%>"><a href="#"><span><%=weeks[3].days[1].text%></span></a></td>',
                        '<td class="<%=weeks[3].days[2].classname%>"><a href="#"><span><%=weeks[3].days[2].text%></span></a></td>',
                        '<td class="<%=weeks[3].days[3].classname%>"><a href="#"><span><%=weeks[3].days[3].text%></span></a></td>',
                        '<td class="<%=weeks[3].days[4].classname%>"><a href="#"><span><%=weeks[3].days[4].text%></span></a></td>',
                        '<td class="<%=weeks[3].days[5].classname%>"><a href="#"><span><%=weeks[3].days[5].text%></span></a></td>',
                        '<td class="<%=weeks[3].days[6].classname%>"><a href="#"><span><%=weeks[3].days[6].text%></span></a></td>',
                        '</tr>',
                        '<tr>',
                        '<td class="<%=weeks[4].days[0].classname%>"><a href="#"><span><%=weeks[4].days[0].text%></span></a></td>',
                        '<td class="<%=weeks[4].days[1].classname%>"><a href="#"><span><%=weeks[4].days[1].text%></span></a></td>',
                        '<td class="<%=weeks[4].days[2].classname%>"><a href="#"><span><%=weeks[4].days[2].text%></span></a></td>',
                        '<td class="<%=weeks[4].days[3].classname%>"><a href="#"><span><%=weeks[4].days[3].text%></span></a></td>',
                        '<td class="<%=weeks[4].days[4].classname%>"><a href="#"><span><%=weeks[4].days[4].text%></span></a></td>',
                        '<td class="<%=weeks[4].days[5].classname%>"><a href="#"><span><%=weeks[4].days[5].text%></span></a></td>',
                        '<td class="<%=weeks[4].days[6].classname%>"><a href="#"><span><%=weeks[4].days[6].text%></span></a></td>',
                        '</tr>',
                        '<tr>',
                        '<td class="<%=weeks[5].days[0].classname%>"><a href="#"><span><%=weeks[5].days[0].text%></span></a></td>',
                        '<td class="<%=weeks[5].days[1].classname%>"><a href="#"><span><%=weeks[5].days[1].text%></span></a></td>',
                        '<td class="<%=weeks[5].days[2].classname%>"><a href="#"><span><%=weeks[5].days[2].text%></span></a></td>',
                        '<td class="<%=weeks[5].days[3].classname%>"><a href="#"><span><%=weeks[5].days[3].text%></span></a></td>',
                        '<td class="<%=weeks[5].days[4].classname%>"><a href="#"><span><%=weeks[5].days[4].text%></span></a></td>',
                        '<td class="<%=weeks[5].days[5].classname%>"><a href="#"><span><%=weeks[5].days[5].text%></span></a></td>',
                        '<td class="<%=weeks[5].days[6].classname%>"><a href="#"><span><%=weeks[5].days[6].text%></span></a></td>',
                        '</tr>',
                        '</tbody>'
                    ],
                    months: [
                        '<tbody class="<%=className%>">',
                        '<tr>',
                        '<td colspan="2"><a href="#"><span><%=data[0]%></span></a></td>',
                        '<td colspan="2"><a href="#"><span><%=data[1]%></span></a></td>',
                        '<td colspan="2"><a href="#"><span><%=data[2]%></span></a></td>',
                        '<td colspan="1"><a href="#"><span><%=data[3]%></span></a></td>',
                        '</tr>',
                        '<tr>',
                        '<td colspan="2"><a href="#"><span><%=data[4]%></span></a></td>',
                        '<td colspan="2"><a href="#"><span><%=data[5]%></span></a></td>',
                        '<td colspan="2"><a href="#"><span><%=data[6]%></span></a></td>',
                        '<td colspan="1"><a href="#"><span><%=data[7]%></span></a></td>',
                        '</tr>',
                        '<tr>',
                        '<td colspan="2"><a href="#"><span><%=data[8]%></span></a></td>',
                        '<td colspan="2"><a href="#"><span><%=data[9]%></span></a></td>',
                        '<td colspan="2"><a href="#"><span><%=data[10]%></span></a></td>',
                        '<td colspan="1"><a href="#"><span><%=data[11]%></span></a></td>',
                        '</tr>',
                        '</tbody>'
                    ]
                },
                defaults = {
                    /**
                     * The currently selected date(s).  This can be: a single date, an array
                     * of two dates (sets a range when 'mode' is 'range'), or an array of
                     * any number of dates (selects all dates when 'mode' is 'multiple'.
                     * The supplied dates can be any one of: Date object, milliseconds
                     * (as from date.getTime(), date.valueOf()), or a date string
                     * parseable by Date.parse().
                     */
                    date: null,
                    /**
                     * Optional date which determines the current calendar month/year.  This
                     * can be one of: Date object, milliseconds (as from date.getTime(), date.valueOf()), or a date string
                     * parseable by Date.parse().  Defaults to todays date.
                     */
                    current: null,
                    /**
                     * true causes the datepicker calendar to be appended to the DatePicker
                     * element and rendered, false binds the DatePicker to an event on the trigger element
                     */
                    inline: false,
                    /**
                     * Date selection mode, one of 'single', 'range' or 'multiple'.  Default
                     * 'single'.  'Single' allows the selection of a single date, 'range'
                     * allows the selection of range of dates, and 'multiple' allows the
                     * selection of any number of individual dates.
                     */
                    mode: 'single',
                    /**
                     * Number of side-by-side calendars, defaults to 1.
                     */
                    calendars: 1,
                    /**
                     * The day that starts the week, where 0: Sunday, 1: Monday, 2: Tuesday, 3: Wednesday, 4: Thursday, 5: Friday, 6: Saturday.  Defaults to Sunday
                     */
                    starts: 0,
                    /**
                     * Previous link text.  Default '&#9664;' (Unicode left arrow)
                     */
                    prev: '&lsaquo;',
                    /**
                     * Next link text.  Default '&#9664;' (Unicode left arrow)
                     */
                    next: '&rsaquo;',
                    /**
                     * Initial calendar view, one of 'days', 'months' or 'years'.  Defaults to 'days'.
                     */
                    view: 'days',
                    /**
                     * Date picker's position relative to the trigger element (non inline
                     * mode only), one of 'top', 'left', 'right' or 'bottom'. Defaults to 'bottom'
                     */
                    position: 'bottom',
                    /**
                     * The trigger event used to show a non-inline calendar.  Defaults to
                     * 'focus' which is useful when the trigger element is a text input,
                     * can also be 'click' for instance if the trigger element is a button
                     * or some text element.
                     */
                    showOn: 'focus',
                    /**
                     * Callback, invoked prior to the rendering of each date cell, which
                     * allows control of the styling of the cell via the returned hash.
                     *
                     * @param HTMLDivElement el the datepicker containing element, ie the
                     *        div with class 'datepicker'
                     * @param Date date the date that will be rendered
                     * @return hash with the following optional attributes:
                     *         selected: if true, date will be selected
                     *         disabled: if true, date cell will be disabled
                     *         className: css class name to add to the cell
                     */
                    onRenderCell: function () {
                        return {}
                    },
                    /*
                     * Callback, invoked when a date is selected, with 'this' referring to
                     * the HTMLElement that DatePicker was invoked upon.
                     *
                     * @param dates: Selected date(s) depending on calendar mode.  When calendar mode  is 'single' this
                     *        is a single Date object.  When calendar mode is 'range', this is an array containing
                     *        a 'from' and 'to' Date objects.  When calendar mode is 'multiple' this is an array
                     *        of Date objects.
                     * @param HTMLElement el the DatePicker element, ie the element that DatePicker was invoked upon
                     */
                    onChange: function () {
                    },

                    onChangeMonthYear: function () {
                    },
                    /*
                     * Callback, invoked when a date range is selected, with 'this' referring to
                     * the HTMLElement that DatePicker was invoked upon.
                     *
                     * @param dates: Selected date(s), ie an array containing a 'from' and 'to' Date objects.
                     * @param HTMLElement el the DatePicker element, ie the element that DatePicker was invoked upon
                     */
                    onRangeChange: function () {
                    },
                    /**
                     * Invoked before a non-inline datepicker is shown, with 'this'
                     * referring to the HTMLElement that DatePicker was invoked upon, ie
                     * the trigger element
                     *
                     * @param HTMLDivElement el The datepicker container element, ie the div with class 'datepicker'.
                     * @return true to allow the datepicker to be shown, false to keep it hidden
                     */

                    onBeforeShow: function () {
                        return true
                    },
                    /**
                     * Invoked after a non-inline datepicker is shown, with 'this'
                     * referring to the HTMLElement that DatePicker was invoked upon, ie
                     * the trigger element
                     *
                     * @param HTMLDivElement el The datepicker container element, ie the div with class 'datepicker'
                     */
                    onAfterShow: function () {
                    },
                    /**
                     * Invoked before a non-inline datepicker is hidden, with 'this'
                     * referring to the HTMLElement that DatePicker was invoked upon, ie
                     * the trigger element
                     *
                     * @param HTMLDivElement el The datepicker container element, ie the div with class 'datepicker'
                     * @return true to allow the datepicker to be hidden, false to keep it visible
                     */
                    onBeforeHide: function () {
                        return true
                    },
                    /**
                     * Invoked after a non-inline datepicker is hidden, with 'this'
                     * referring to the HTMLElement that DatePicker was invoked upon, ie
                     * the trigger element
                     *
                     * @param HTMLDivElement el The datepicker container element, ie the div with class 'datepicker'
                     */
                    onAfterHide: function () {
                    },
                    /**
                     * Locale text for day/month names: provide a hash with keys 'daysMin', 'months' and 'monthsShort'. Default english
                     */
                    locale: {
                        daysMin: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                        months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                        monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
                    },
                    /**
                     * The combined height from the top/bottom borders.  'false' is the default
                     * and generally the correct value.
                     */
                    extraHeight: false,
                    /**
                     * The combined width from the left/right borders.  'false' is the default
                     * and generally the correct value.
                     */
                    extraWidth: false,
                    /**
                     * Private option, used to determine when a range is selected
                     */
                    lastSel: false
                },

                /**
                 * Internal method which renders the calendar cells
                 *
                 * @param HTMLDivElement el datepicker container element
                 */
                fill = function (el) {
                    var options = $(el).data('datepicker');
                    var cal = $(el);
                    var currentCal = Math.floor(options.calendars / 2), date, data, dow, month, cnt = 0, days, indic,
                        indic2, html, tblCal;

                    cal.find('td>table tbody').remove();
                    for (var i = 0; i < options.calendars; i++) {
                        date = new Date(options.current);
                        date.addMonths(-currentCal + i);
                        tblCal = cal.find('table').eq(i + 1);

                        if (i == 0) tblCal.addClass('datepickerFirstView');
                        if (i == options.calendars - 1) tblCal.addClass('datepickerLastView');

                        if (tblCal.hasClass('datepickerViewDays')) {
                            dow = date.getMonthName(true) + ", " + date.getFullYear();
                        } else if (tblCal.hasClass('datepickerViewMonths')) {
                            dow = date.getFullYear();
                        } else if (tblCal.hasClass('datepickerViewYears')) {
                            dow = (date.getFullYear() - 6) + ' - ' + (date.getFullYear() + 5);
                        }
                        tblCal.find('thead tr:first th a:eq(1) span').text(dow);
                        dow = date.getFullYear() - 6;
                        data = {
                            data: [],
                            className: 'datepickerYears'
                        }
                        for (var j = 0; j < 12; j++) {
                            data.data.push(dow + j);
                        }
                        // datepickerYears template
                        html = tmpl(tpl.months.join(''), data);
                        date.setDate(1);
                        data = {weeks: [], test: 10};
                        month = date.getMonth();
                        var dow = (date.getDay() - options.starts) % 7;
                        date.addDays(-(dow + (dow < 0 ? 7 : 0)));
                        cnt = 0;
                        while (cnt < 42) {
                            indic = parseInt(cnt / 7, 10);
                            indic2 = cnt % 7;
                            if (!data.weeks[indic]) {
                                data.weeks[indic] = {
                                    days: []
                                };
                            }
                            data.weeks[indic].days[indic2] = {
                                text: date.getDate(),
                                classname: []
                            };
                            var today = new Date();
                            if (today.getDate() == date.getDate() && today.getMonth() == date.getMonth() && today.getYear() == date.getYear()) {
                                data.weeks[indic].days[indic2].classname.push('datepickerToday');
                            }
                            if (date > today) {
                                // current month, date in future
                                data.weeks[indic].days[indic2].classname.push('datepickerFuture');
                            }

                            if (month != date.getMonth()) {
                                data.weeks[indic].days[indic2].classname.push('datepickerNotInMonth');
                                // disable clicking of the 'not in month' cells
                                data.weeks[indic].days[indic2].classname.push('datepickerDisabled');
                            }
                            if (date.getDay() == 0) {
                                data.weeks[indic].days[indic2].classname.push('datepickerSunday');
                            }
                            if (date.getDay() == 6) {
                                data.weeks[indic].days[indic2].classname.push('datepickerSaturday');
                            }

                            var fromUser = options.onRenderCell(el, date);
                            var val = date.valueOf();

                            if (options.date && (!$.isArray(options.date) || options.date.length > 0)) {

                                // update to fill to allow base and compare ranges
                                if (options.date.length === 3 && ( val == options.date[2] )) {
                                    var dateCandidate = data.weeks[indic].days[indic2];
                                    var containsDisabled = _.contains(dateCandidate.classname, "datepickerDisabled");
                                    if (containsDisabled === false) dateCandidate.classname.push('datepickerCompareSelected');
                                }

                                if (options.date.length > 3 && ( val >= options.date[2] && val <= options.date[3])) {
                                    var dateCandidate = data.weeks[indic].days[indic2];
                                    var containsDisabled = _.contains(dateCandidate.classname, "datepickerDisabled");
                                    if (containsDisabled === false) dateCandidate.classname.push('datepickerCompareSelected');
                                }

                                if ((options.mode == 'range' && val >= options.date[0] && val <= options.date[1])) {
                                    data.weeks[indic].days[indic2].classname.push('datepickerSelected');
                                }
                            }

                            if (fromUser.disabled) {
                                data.weeks[indic].days[indic2].classname.push('datepickerDisabled');
                            }
                            if (fromUser.className) {
                                data.weeks[indic].days[indic2].classname.push(fromUser.className);
                            }
                            data.weeks[indic].days[indic2].classname = data.weeks[indic].days[indic2].classname.join(' ');
                            cnt++;
                            date.addDays(1);
                        }
                        // Fill the datepickerDays template with data
                        html = tmpl(tpl.days.join(''), data) + html;

                        data = {
                            data: options.locale.monthsShort,
                            className: 'datepickerMonths'
                        };
                        // datepickerMonths template
                        html = tmpl(tpl.months.join(''), data) + html;
                        tblCal.append(html);
                    }
                },

                /**
                 * Extends the Date object with some useful helper methods
                 */
                extendDate = function (locale) {
                    if (Date.prototype.tempDate) {
                        return;
                    }
                    Date.prototype.tempDate = null;
                    Date.prototype.months = locale.months;
                    Date.prototype.monthsShort = locale.monthsShort;
                    Date.prototype.getMonthName = function (fullName) {
                        return this[fullName ? 'months' : 'monthsShort'][this.getMonth()];
                    };
                    Date.prototype.addDays = function (n) {
                        this.setDate(this.getDate() + n);
                        this.tempDate = this.getDate();
                    };
                    Date.prototype.addMonths = function (n) {
                        if (this.tempDate == null) {
                            this.tempDate = this.getDate();
                        }
                        this.setDate(1);
                        this.setMonth(this.getMonth() + n);
                        this.setDate(Math.min(this.tempDate, this.getMaxDays()));
                    };
                    Date.prototype.addYears = function (n) {
                        if (this.tempDate == null) {
                            this.tempDate = this.getDate();
                        }
                        this.setDate(1);
                        this.setFullYear(this.getFullYear() + n);
                        this.setDate(Math.min(this.tempDate, this.getMaxDays()));
                    };
                    Date.prototype.getMaxDays = function () {
                        var tmpDate = new Date(Date.parse(this)),
                            d = 28, m;
                        m = tmpDate.getMonth();
                        d = 28;
                        while (tmpDate.getMonth() == m) {
                            d++;
                            tmpDate.setDate(d);
                        }
                        return d - 1;
                    };
                },

                /**
                 * Internal method which lays out the calendar widget
                 */
                layout = function (el) {
                    var options = $(el).data('datepicker');
                    var cal = $('#' + options.id);
                    if (options.extraHeight === false) {
                        var divs = $(el).find('div');
                        options.extraHeight = divs.get(0).offsetHeight + divs.get(1).offsetHeight;  // heights from top/bottom borders
                        options.extraWidth = divs.get(2).offsetWidth + divs.get(3).offsetWidth;     // widths from left/right borders
                    }
                    var tbl = cal.find('table:first').get(0);
                    var width = tbl.offsetWidth;
                    var height = tbl.offsetHeight;
                    cal.css({
                        width: width + options.extraWidth + 'px',
                        height: height + options.extraHeight + 'px'
                    }).find('div.datepickerContainer').css({
                        width: width + 'px',
                        height: height + 'px'
                    });
                },

                /**
                 * Internal method, bound to the HTML DatePicker Element, onClick.
                 * This is the function that controls the behavior of the calendar when
                 * the title, next/previous, or a date cell is clicked on.
                 */
                click = function (ev) {
                    if ($(ev.target).is('span')) {
                        ev.target = ev.target.parentNode;
                    }

                    var el = $(ev.target);
                    if (el.is('a')) {
                        ev.target.blur();

                        if (el.hasClass('datepickerDisabled')) {
                            //  return false;
                        }

                        var options = $(this).data('datepicker');
                        var parentEl = el.parent();
                        var tblEl = parentEl.parent().parent().parent();
                        var tblIndex = $('table', this).index(tblEl.get(0)) - 1;
                        var tmp = new Date(options.current);
                        var changed = false;
                        var changedRange = false;
                        var fillIt = false;
                        var currentCal = Math.floor(options.calendars / 2);

                        if (parentEl.is('th')) {
                            // clicking the calendar title

                            if (el.hasClass('datepickerMonth')) {
                                // clicking on the title of a Month Datepicker
                                tmp.addMonths(tblIndex - currentCal);

                                if (options.mode == 'range') {
                                    // range, select the whole month
                                    options.date[0] = (tmp.setHours(0, 0, 0, 0)).valueOf();
                                    tmp.addDays(tmp.getMaxDays() - 1);
                                    tmp.setHours(23, 59, 59, 0);
                                    options.date[1] = tmp.valueOf();
                                    fillIt = true;
                                    changed = true;
                                    options.lastSel = false;
                                }
                                else if (options.calendars == 1) {
                                    // single/multiple mode with a single calendar: swap between daily/monthly/yearly view.
                                    // Note:  there's no reason a multi-calendar widget can't have this functionality,
                                    //   however I think it looks really unintuitive.
                                    if (tblEl.eq(0).hasClass('datepickerViewDays')) {
                                        tblEl.eq(0).toggleClass('datepickerViewDays datepickerViewMonths');
                                        el.find('span').text(tmp.getFullYear());
                                    } else if (tblEl.eq(0).hasClass('datepickerViewMonths')) {
                                        tblEl.eq(0).toggleClass('datepickerViewMonths datepickerViewYears');
                                        el.find('span').text((tmp.getFullYear() - 6) + ' - ' + (tmp.getFullYear() + 5));
                                    } else if (tblEl.eq(0).hasClass('datepickerViewYears')) {
                                        tblEl.eq(0).toggleClass('datepickerViewYears datepickerViewDays');
                                        el.find('span').text(tmp.getMonthName(true) + ", " + tmp.getFullYear());
                                    }
                                }
                            }
                            else if (parentEl.parent().parent().is('thead')) {
                                // clicked either next/previous arrows
                                if (tblEl.eq(0).hasClass('datepickerViewDays')) {
                                    options.current.addMonths(el.hasClass('datepickerGoPrev') ? -1 : 1);
                                } else if (tblEl.eq(0).hasClass('datepickerViewMonths')) {
                                    options.current.addYears(el.hasClass('datepickerGoPrev') ? -1 : 1);
                                } else if (tblEl.eq(0).hasClass('datepickerViewYears')) {
                                    options.current.addYears(el.hasClass('datepickerGoPrev') ? -12 : 12);
                                }
                                fillIt = true;
                            }
                        }
                        else if (parentEl.is('td') && !parentEl.hasClass('datepickerDisabled')) {
                            // clicking the calendar grid
                            if (tblEl.eq(0).hasClass('datepickerViewMonths')) {
                                // clicked a month cell
                                options.current.setMonth(tblEl.find('tbody.datepickerMonths td').index(parentEl));
                                options.current.setFullYear(parseInt(tblEl.find('thead th a.datepickerMonth span').text(), 10));
                                options.current.addMonths(currentCal - tblIndex);
                                tblEl.eq(0).toggleClass('datepickerViewMonths datepickerViewDays');
                            } else if (tblEl.eq(0).hasClass('datepickerViewYears')) {
                                // clicked a year cell
                                options.current.setFullYear(parseInt(el.text(), 10));
                                tblEl.eq(0).toggleClass('datepickerViewYears datepickerViewMonths');
                            } else {
                                // clicked a day cell
                                var val = parseInt(el.text(), 10);
                                tmp.addMonths(tblIndex - currentCal);
                                if (parentEl.hasClass('datepickerNotInMonth')) {
                                    tmp.addMonths(val > 15 ? -1 : 1);
                                }
                                tmp.setDate(val);
                                switch (options.mode) {
                                    case 'multiple':
                                        val = (tmp.setHours(0, 0, 0, 0)).valueOf();
                                        if ($.inArray(val, options.date) > -1) {
                                            $.each(options.date, function (nr, dat) {
                                                if (dat == val) {
                                                    options.date.splice(nr, 1);
                                                    return false;
                                                }
                                            });
                                        } else {
                                            options.date.push(val);
                                        }
                                        break;
                                    case 'range':
                                        val = (tmp.setHours(0, 0, 0, 0)).valueOf();

                                        if (!options.lastSel && options.date.length <= 2) {
                                            // first click: set to the start of the day
                                            options.date[0] = val;
                                        } else if (!options.lastSel) {
                                            options.date[2] = val;
                                        }

                                        if (options.date.length > 2) {
                                            if (val < options.date[2]) {
                                                options.date[3] = options.date[2];
                                                options.date[2] = val;
                                            } else {
                                                options.date[3] = val;
                                            }
                                        } else if (options.date.length <= 2) {
                                            if (val < options.date[0]) {
                                                options.date[1] = options.date[0];
                                                options.date[0] = val;
                                            } else {
                                                options.date[1] = val;
                                            }
                                        }
                                        options.lastSel = !options.lastSel;
                                        changedRange = !options.lastSel;
                                        break;
                                    default:
                                        options.date = tmp.valueOf();
                                        break;
                                }
                                changed = true;
                            }
                            fillIt = true;
                        }
                        if (fillIt) {
                            fill(this);
                        }
                        if (changed) {
                            options.onChange.apply(this, prepareDate(options));
                        }
                        if (changedRange) {
                            options.onRangeChange.apply(this, prepareDate(options));
                        }
                    }

                    return false;
                },

                /**
                 * Internal method, called from the public getDate() method, and when
                 * invoking the onChange callback function
                 *
                 * @param object options with the following attributes: 'mode' which can
                 *        be one of 'single', 'range', or 'multiple'.  Attribute 'date'
                 *        which will be a single timestamp when 'mode' is 'single', or
                 *        an array of timestamps otherwise.  Attribute 'el' which is the
                 *        HTML element that DatePicker was invoked upon.
                 * @return array where the first item is either a Date object, or an
                 *         array of Date objects, depending on the DatePicker mode, and
                 *         the second item is the HTMLElement that DatePicker was invoked
                 *         upon.
                 */
                prepareDate = function (options) {
                    var dates = null;
                    if (options.mode == 'single') {
                        if (options.date) dates = new Date(options.date);
                    } else {
                        dates = new Array();
                        $(options.date).each(function (i, val) {
                            dates.push(new Date(val));
                        });
                    }
                    return [dates, options.el];
                },

                /**
                 * Internal method, returns an object containing the viewport dimensions
                 */
                getViewport = function () {
                    var m = document.compatMode == 'CSS1Compat';
                    return {
                        l: window.pageXOffset || (m ? document.documentElement.scrollLeft : document.body.scrollLeft),
                        t: window.pageYOffset || (m ? document.documentElement.scrollTop : document.body.scrollTop),
                        w: window.innerWidth || (m ? document.documentElement.clientWidth : document.body.clientWidth),
                        h: window.innerHeight || (m ? document.documentElement.clientHeight : document.body.clientHeight)
                    };
                },

                /**
                 * Internal method, returns true if el is a child of parentEl
                 */
                isChildOf = function (parentEl, el, container) {
                    if (parentEl == el) {
                        return true;
                    }
                    if (parentEl.contains) {
                        return parentEl.contains(el);
                    }
                    if (parentEl.compareDocumentPosition) {
                        return !!(parentEl.compareDocumentPosition(el) & 16);
                    }
                    var prEl = el.parentNode;
                    while (prEl && prEl != container) {
                        if (prEl == parentEl)
                            return true;
                        prEl = prEl.parentNode;
                    }
                    return false;
                },

                /**
                 * Bound to the HTML DatePicker element when it's not inline, and also
                 * can be called directly to show the bound datepicker.  A DatePicker
                 * calendar shown with this method will hide on a mouseclick outside
                 * of the calendar.
                 *
                 * Method is not applicable for inline DatePickers
                 */
                show = function (ev) {
                    var cal = $('#' + $(this).data('datepickerId'));
                    if (!cal.is(':visible')) {
                        var calEl = cal.get(0);
                        var options = cal.data('datepicker');

                        var test = options.onBeforeShow.apply(this, [calEl]);
                        if (options.onBeforeShow.apply(this, [calEl]) == false) {
                            return;
                        }

                        fill(calEl);
                        var pos = $(this).offset();
                        var viewPort = getViewport();
                        var top = pos.top;
                        var left = pos.left;
                        var oldDisplay = $.curCSS(calEl, 'display');
                        cal.css({
                            visibility: 'hidden',
                            display: 'block'
                        });
                        layout(calEl);
                        switch (options.position) {
                            case 'top':
                                top -= calEl.offsetHeight;
                                break;
                            case 'left':
                                left -= calEl.offsetWidth;
                                break;
                            case 'right':
                                left += this.offsetWidth;
                                break;
                            case 'bottom':
                                top += this.offsetHeight;
                                break;
                        }
                        if (top + calEl.offsetHeight > viewPort.t + viewPort.h) {
                            top = pos.top - calEl.offsetHeight;
                        }
                        if (top < viewPort.t) {
                            top = pos.top + this.offsetHeight + calEl.offsetHeight;
                        }
                        if (left + calEl.offsetWidth > viewPort.l + viewPort.w) {
                            left = pos.left - calEl.offsetWidth;
                        }
                        if (left < viewPort.l) {
                            left = pos.left + this.offsetWidth
                        }
                        cal.css({
                            visibility: 'visible',
                            display: 'block',
                            top: top + 'px',
                            left: left + 'px'
                        });
                        options.onAfterShow.apply(this, [cal.get(0)]);
                        $(document).bind('mousedown', {cal: cal, trigger: this}, hide);  // global listener so clicking outside the calendar will close it
                    }
                    return false;
                },

                /**
                 * Hide a non-inline DatePicker calendar.
                 *
                 * Not applicable for inline DatePickers.
                 *
                 * @param ev Event object
                 */
                hide = function (ev) {
                    if (ev.target != ev.data.trigger && !isChildOf(ev.data.cal.get(0), ev.target, ev.data.cal.get(0))) {
                        if (ev.data.cal.data('datepicker').onBeforeHide.apply(this, [ev.data.cal.get(0)]) != false) {
                            ev.data.cal.hide();
                            ev.data.cal.data('datepicker').onAfterHide.apply(this, [ev.data.cal.get(0)]);
                            $(document).unbind('mousedown', hide);  // remove the global listener
                        }
                    }
                },

                /**
                 * Internal method to normalize the selected date based on the current
                 * calendar mode.
                 */
                normalizeDate = function (mode, date) {
                    // if range/multi mode, make sure that the current date value is at least an empty array
                    if (mode != 'single' && !date) date = [];

                    // if we have a selected date and not a null or empty array
                    if (date && (!$.isArray(date) || date.length > 0)) {
                        // Create a standardized date depending on the calendar mode
                        if (mode != 'single') {
                            if (!$.isArray(date)) {
                                date = [((new Date(date)).setHours(0, 0, 0, 0)).valueOf()];
                                if (mode == 'range') {
                                    // create a range of one day
                                    date.push(((new Date(date[0])).setHours(23, 59, 59, 0)).valueOf());
                                }
                            } else {
                                for (var i = 0; i < date.length; i++) {
                                    date[i] = ((new Date(date[i])).setHours(0, 0, 0, 0)).valueOf();
                                }
                                if (mode == 'range') {
                                    // for range mode, create the other end of the range
                                    if (date.length == 1) date.push(new Date(date[0]));
                                    date[1] = ((new Date(date[1])).setHours(23, 59, 59, 0)).valueOf();
                                }
                            }
                        } else {
                            // mode is single, convert date object into a timestamp
                            date = ((new Date(date)).setHours(0, 0, 0, 0)).valueOf();
                        }
                        // at this point date is either a timestamp at hour zero
                        //  for 'single' mode, an array of timestamps at hour zero for
                        //  'multiple' mode, or a two-item array with timestamps at hour
                        //  zero and hour 23:59 for 'range' mode
                    }
                    return date;
                };
            return {
                /**
                 * 'Public' functions
                 */

                /**
                 * Called when element.DatePicker() is invoked
                 *
                 * Note that 'this' is the HTML element that DatePicker was invoked upon
                 * @see DatePicker()
                 */
                init: function (options) {
                    options = $.extend({}, defaults, options || {});
                    extendDate(options.locale);
                    options.calendars = Math.max(1, parseInt(options.calendars, 10) || 1);
                    options.mode = /single|multiple|range/.test(options.mode) ? options.mode : 'single';
                    return this.each(function () {
                        if (!$(this).data('datepicker')) {
                            options.el = this;

                            options.date = normalizeDate(options.mode, options.date);

                            if (!options.current) {
                                options.current = new Date();
                            } else {
                                options.current = new Date(options.current);
                            }
                            options.current.setDate(1);
                            options.current.setHours(0, 0, 0, 0);

                            var id = 'datepicker_' + parseInt(Math.random() * 1000), cnt;
                            options.id = id;
                            $(this).data('datepickerId', options.id);
                            var cal = $(tpl.wrapper).attr('id', id).bind('click', click).data('datepicker', options);
                            if (options.className) {
                                cal.addClass(options.className);
                            }
                            var html = '';
                            for (var i = 0; i < options.calendars; i++) {
                                cnt = options.starts;
                                if (i > 0) {
                                    html += tpl.space;
                                }
                                // calendar header template
                                html += tmpl(tpl.head.join(''), {
                                    prev: options.prev,
                                    next: options.next,
                                    day1: options.locale.daysMin[(cnt++) % 7],
                                    day2: options.locale.daysMin[(cnt++) % 7],
                                    day3: options.locale.daysMin[(cnt++) % 7],
                                    day4: options.locale.daysMin[(cnt++) % 7],
                                    day5: options.locale.daysMin[(cnt++) % 7],
                                    day6: options.locale.daysMin[(cnt++) % 7],
                                    day7: options.locale.daysMin[(cnt++) % 7]
                                });
                            }
                            cal
                                .find('tr:first').append(html)
                                .find('table').addClass(views[options.view]);
                            fill(cal.get(0));
                            if (options.inline) {
                                cal.appendTo(this).show().css('position', 'relative');
                                layout(cal.get(0));
                            } else {
                                cal.appendTo(document.body);
                                $(this).bind(options.showOn, show);
                            }
                        }
                    });
                },

                /**
                 * Shows the DatePicker, applicable only when the picker is not inline
                 *
                 * @return the DatePicker HTML element
                 * @see DatePickerShow()
                 */
                showPicker: function () {
                    return this.each(function () {
                        if ($(this).data('datepickerId')) {
                            var cal = $('#' + $(this).data('datepickerId'));
                            var options = cal.data('datepicker');
                            if (!options.inline) {
                                show.apply(this);
                            }
                        }
                    });
                },

                /**
                 * Hides the DatePicker, applicable only when the picker is not inline
                 *
                 * @return the DatePicker HTML element
                 * @see DatePickerHide()
                 */
                hidePicker: function () {
                    return this.each(function () {
                        if ($(this).data('datepickerId')) {
                            var cal = $('#' + $(this).data('datepickerId'));
                            var options = cal.data('datepicker');
                            if (!options.inline) {
                                $('#' + $(this).data('datepickerId')).hide();
                            }
                        }
                    });
                },

                /**
                 * Sets the DatePicker current date, and optionally shifts the current
                 * calendar to that date.
                 *
                 * @param Date|String|int|Array date The currently selected date(s).
                 *        This can be: a single date, an array
                 *        of two dates (sets a range when 'mode' is 'range'), or an array of
                 *        any number of dates (selects all dates when 'mode' is 'multiple'.
                 *        The supplied dates can be any one of: Date object, milliseconds
                 *        (as from date.getTime(), date.valueOf()), or a date string
                 *        parseable by Date.parse().
                 * @param boolean shiftTo if true, shifts the visible calendar to the
                 *        newly set date(s)
                 *
                 * @see DatePickerSetDate()
                 */
                setDate: function (date, shiftTo) {
                    return this.each(function () {
                        if ($(this).data('datepickerId')) {
                            var cal = $('#' + $(this).data('datepickerId'));
                            var options = cal.data('datepicker');
                            options.date = normalizeDate(options.mode, date);
                            if (shiftTo) {
                                options.current = new Date(options.mode != 'single' ? options.date[0] : options.date);
                            }
                            fill(cal.get(0));
                        }
                    });
                },

                /**
                 * Returns the currently selected date(s) and the datepicker element.
                 *
                 * @return array where the first element is the selected date(s)  When calendar mode  is 'single' this
                 *        is a single date object, or null if no date is selected.  When calendar mode is 'range', this is an array containing
                 *        a 'from' and 'to' date objects, or the empty array if no date range is selected.  When calendar mode is 'multiple' this
                 *        is an array of Date objects, or the empty array if no date is selected.
                 *        The second element is the HTMLElement that DatePicker was invoked upon
                 *
                 * @see DatePickerGetDate()
                 */
                getDate: function () {
                    if (this.size() > 0) {
                        return prepareDate($('#' + $(this).data('datepickerId')).data('datepicker'));
                    }
                },

                /**
                 * Clears the currently selected date(s)
                 *
                 * @see DatePickerClear()
                 */
                clear: function () {
                    return this.each(function () {
                        if ($(this).data('datepickerId')) {
                            var cal = $('#' + $(this).data('datepickerId'));
                            var options = cal.data('datepicker');
                            if (options.mode == 'single') {
                                options.date = null;
                            } else {
                                options.date = [];
                            }
                            fill(cal.get(0));
                        }
                    });
                },

                clearLastSelected: function() {
                    return this.each(function () {
                        if ($(this).data('datepickerId')) {
                            var cal = $('#' + $(this).data('datepickerId'));
                            var options = cal.data('datepicker');
                            options.lastSel = false;
                            fill(cal.get(0));
                        }
                    });
                },

                /**
                 * Only applicable when the DatePicker is inline
                 *
                 * @see DatePickerLayout()
                 */
                fixLayout: function () {
                    return this.each(function () {
                        if ($(this).data('datepickerId')) {
                            var cal = $('#' + $(this).data('datepickerId'));
                            var options = cal.data('datepicker');
                            if (options.inline) {
                                layout(cal.get(0));
                            }
                        }
                    });
                }
            };
        }();  // DatePicker

    // Extend jQuery with the following functions so that they can be called on HTML elements, ie: $('#widgetCalendar').DatePicker();
    $.fn.extend({
        DatePickerInit: DatePicker.init,
        DatePickerHide: DatePicker.hidePicker,
        DatePickerShow: DatePicker.showPicker,
        DatePickerSetDate: DatePicker.setDate,
        DatePickerGetDate: DatePicker.getDate,
        DatePickerClearLastSelected: DatePicker.clearLastSelected,
        DatePickerClear: DatePicker.clear,
        DatePickerLayout: DatePicker.fixLayout
    });

    tmpl = function tmpl(str, data) {
        // Figure out if we're getting a template, or if we need to
        // load the template - and be sure to cache the result.
        var fn = !/\W/.test(str) ?
            cache[str] = cache[str] ||
                tmpl(document.getElementById(str).innerHTML) :

            // Generate a reusable function that will serve as a template
            // generator (and which will be cached).
            new Function("obj",
                "var p=[],print=function(){p.push.apply(p,arguments);};" +

                // Introduce the data as local variables using with(){}
                "with(obj){p.push('" +

                // Convert the template into pure JavaScript
                str
                    .replace(/[\r\t\n]/g, " ")
                    .split("<%").join("\t")
                    .replace(/((^|%>)[^\t]*)'/g, "$1\r")
                    .replace(/\t=(.*?)%>/g, "',$1,'")
                    .split("\t").join("');")
                    .split("%>").join("p.push('")
                    .split("\r").join("\\'")
                + "');}return p.join('');");

        // Provide some basic currying to the user
        return data ? fn(data) : fn;
    };

})(jQuery);

(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('DatePickerHelper', DatePickerHelper);

    /** @ngInject */
    function DatePickerHelper(TranslationsService) {

        var BASE_CUSTOM_ID = 0;
        var BASE_TODAY_ID = 1;
        var BASE_YESTERDAY_ID = 2;
        var BASE_LAST_WEEK_ID = 3;
        var BASE_LAST_MONTH_ID = 4;
        var BASE_LAST_7_ID = 5;
        var BASE_LAST_30_ID = 6;
        var COMPARE_PREVIOUS_PERIOD_ID = 0;
        var COMPARE_PREVIOUS_WEEK_ID = 1;
        var COMPARE_PREVIOUS_YEAR_ID = 2;
        var COMPARE_CUSTOM_ID = 3;

        return {
            selectIds: {
                BASE_CUSTOM: BASE_CUSTOM_ID,
                BASE_TODAY: BASE_TODAY_ID,
                BASE_YESTERDAY: BASE_YESTERDAY_ID,
                BASE_LAST_WEEK: BASE_LAST_WEEK_ID,
                BASE_LAST_MONTH: BASE_LAST_MONTH_ID,
                BASE_LAST_7: BASE_LAST_7_ID,
                BASE_LAST_30: BASE_LAST_30_ID,
                COMPARE_PREVIOUS_PERIOD: COMPARE_PREVIOUS_PERIOD_ID,
                COMPARE_PREVIOUS_WEEK: COMPARE_PREVIOUS_WEEK_ID,
                COMPARE_PREVIOUS_YEAR: COMPARE_PREVIOUS_YEAR_ID,
                COMPARE_CUSTOM: COMPARE_CUSTOM_ID
            },
            formatMomentForReport: formatMomentForReport,
            getBaseDatesFromSelectId: getBaseDatesFromSelectId,
            getBaseSelectIdFromKey: getBaseSelectIdFromKey,
            getBaseDates: getBaseDates,
            getCompareSelectIdFromKey: getCompareSelectIdFromKey,
            getCompareDatesFromCompareSelectId: getCompareDatesFromCompareSelectId,
            getPreviousCustomBaseRange: getPreviousCustomBaseRange,
            getPreviousDates: getPreviousDates,
            getPreviousWeekCustomBaseRange: getPreviousWeekCustomBaseRange,
            getPreviousYearCustomBaseRange: getPreviousYearCustomBaseRange,
            isBaseCustom: isBaseCustom,
            isCompareCustom: isCompareCustom,
            isDate: isDate,
            loadLocale: loadLocale
        };

        // ------------------------------------------------------------------------------------------------------ //
        // ------------------------------------------------------------------------------------------------------ //

        function formatMomentForReport(m) {
            return m.format('YYYY-MM-DD');
        }

        function getBaseDatesFromSelectId(id) {
            var dates = getBaseDates();
            return dates.filter(function (date) {
                return date.id === id;
            })[0];
        }

        function getBaseSelectIdFromKey(key) {
            var dates = getBaseDates();
            var date = dates.filter(function (date) {
                return date.key === key;
            })[0];

            return Helper.isUnsetOrEmpty(date) ? null : date.id;
        }

        function getBaseDates() {
            var today = [moment(), moment()];
            var yesterday = [moment().subtract(1, 'days'), moment().subtract(1, 'days')];
            var lastWeek = [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')];
            var lastMonth = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
            var last7Days = [moment().subtract(7, 'days'), moment().subtract(1, 'days')];
            var last30Days = [moment().subtract(30, 'days'), moment().subtract(1, 'days')];

            return [
                {label: 'Custom', range: [moment(), moment()], id: 0, key: 'custom', translate: 'COMMON_CUSTOM'},
                {label: 'Today', range: today, id: 1, key: 'today', translate: 'COMMON_TODAY'},
                {label: 'Yesterday', range: yesterday, id: 2, key: 'yesterday', translate: 'COMMON_YESTERDAY'},
                {label: 'Last Week', range: lastWeek, id: 3, key: 'lastWeek', translate: 'COMMON_LAST_WEEK'},
                {label: 'Last Month', range: lastMonth, id: 4, key: 'lastMonth', translate: 'COMMON_LAST_MONTH'},
                {label: 'Last 7 Days', range: last7Days, id: 5, key: 'last7', translate: 'COMMON_LAST_7_DAYS'},
                {label: 'Last 30 Days', range: last30Days, id: 6, key: 'last30', translate: 'COMMON_LAST_30_DAYS'}
            ];
        }

        function getCompareSelectIdFromKey(key) {
            var selectId = null;
            switch (key) {
                case "previousPeriod":
                    selectId = COMPARE_PREVIOUS_PERIOD_ID;
                    break;
                case "previousWeek":
                    selectId = COMPARE_PREVIOUS_WEEK_ID;
                    break;
                case "previousYear":
                    selectId = COMPARE_PREVIOUS_YEAR_ID;
                    break;
            }
            return selectId;
        }

        function getCompareDatesFromCompareSelectId(compareSelectId, baseStartMoment, baseEndMoment) {
            var dates = [];
            switch (compareSelectId) {
                case COMPARE_CUSTOM_ID:
                    break;
                case COMPARE_PREVIOUS_YEAR_ID:
                    dates = getPreviousYearCustomBaseRange(baseStartMoment, baseEndMoment);
                    break;
                case COMPARE_PREVIOUS_WEEK_ID:
                    dates = getPreviousWeekCustomBaseRange(baseStartMoment, baseEndMoment);
                    break;
                case COMPARE_PREVIOUS_PERIOD_ID:
                    dates = getPreviousCustomBaseRange(baseStartMoment, baseEndMoment);
                    break;
            }
            return dates;
        }

        function getPreviousCustomBaseRange(baseStartMoment, baseEndMoment) {
            var diffDays = Number(baseEndMoment.diff(baseStartMoment, "days")) + 1;
            var previousCompareEndMoment = moment().set({
                'year': baseStartMoment.year(),
                'month': baseStartMoment.month(),
                'date': baseStartMoment.date()
            }).subtract(1, 'days');
            var previousCompareStartMoment = moment().set({
                'year': baseStartMoment.year(),
                'month': baseStartMoment.month(),
                'date': baseStartMoment.date()
            }).subtract(diffDays, 'days');
            return [previousCompareStartMoment, previousCompareEndMoment];
        }

        function getPreviousDates() {
            var daysToSubtractFromEndOfLastMonth = moment().subtract(1, 'month').daysInMonth() * 2 - 1;
            var endOfLastMonth = moment().subtract(1, 'month').endOf("month");

            var today = [moment().subtract(1, 'days'), moment().subtract(1, 'days')];
            var yesterday = [moment().subtract(2, 'days'), moment().subtract(2, 'days')];
            var lastWeek = [moment().subtract(2, 'week').startOf('week'), moment().subtract(2, 'week').endOf('week')];
            var lastMonth = [moment(endOfLastMonth.format()).subtract(daysToSubtractFromEndOfLastMonth, 'days'), moment().subtract(2, 'months').endOf('month')];
            var last7Days = [moment().subtract(14, 'days'), moment().subtract(8, 'days')];
            var last30Days = [moment().subtract(60, 'days'), moment().subtract(31, 'days')];

            return [
                {label: 'Custom', range: [], id: 0},
                {label: 'Today', range: today, id: 1},
                {label: 'Yesterday', range: yesterday, id: 2},
                {label: 'Last Week', range: lastWeek, id: 3},
                {label: 'Last Month', range: lastMonth, id: 4},
                {label: 'Last 7 Days', range: last7Days, id: 5},
                {label: 'Last 30 Days', range: last30Days, id: 6}
            ];
        }

        function getPreviousWeekCustomBaseRange(baseStartMoment, baseEndMoment) {
            var start = angular.copy(baseStartMoment);
            var end = angular.copy(baseEndMoment);
            var previousCompareStartMoment = start.subtract(1, "week");
            var previousCompareEndMoment = end.subtract(1, "week");
            return [previousCompareStartMoment, previousCompareEndMoment];
        }

        function getPreviousYearCustomBaseRange(baseStartMoment, baseEndMoment) {
            var start = angular.copy(baseStartMoment);
            var end = angular.copy(baseEndMoment);
            var previousCompareStartMoment = start.subtract(1, "year");
            var previousCompareEndMoment = end.subtract(1, "year");
            return [previousCompareStartMoment, previousCompareEndMoment];
        }

        function isBaseCustom(id) {
            return id === BASE_CUSTOM_ID;
        }

        function isCompareCustom(id) {
            return id === COMPARE_CUSTOM_ID;
        }

        function isDate(newDateStr) {
            var parms = newDateStr.split(/[\.\-\/]/);
            var yearStr = String(parms[2]);

            if (yearStr.length > 4) {
                return {isValid: false, date: null};
            }

            var yyyy = parseInt(yearStr, 10);

            // US clients want mm/dd/yyyy not dd/mm/yyyy
            var mm = parseInt(parms[0], 10);
            var dd = parseInt(parms[1], 10);
            var date = new Date(yyyy, mm - 1, dd, 0, 0, 0, 0);
            var isValid = (date.getMonth() + 1) && dd === date.getDate() && yyyy === date.getFullYear();

            return {isValid: isValid, date: date};
        }

        function loadLocale() {
            var locale = {
                daysMin: TranslationsService.getShortWeekdays(),
                monthsShort: TranslationsService.getShortMonths(),
                months: TranslationsService.getShortMonths()
            };
            return locale;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .directive('mobileDatePicker', mobileDatePickerDirective);

    /** @ngInject */
    function mobileDatePickerDirective() {
        return {
            restrict: 'E',
            scope: {
                mobileDates: '=',
                reportDates: '='
            },
            templateUrl: 'app/main/directives/mobile-date-picker/mobile-date-picker.html',
            controller: function (DatePickerHelper) {
                var vm = this;

                // Methods
                vm.compare = compare;
                vm.setMobileReportDates = setMobileReportDates;
                vm.validateMobileDates = validateMobileDates;

                // ------------------------------------------------------------------------------------------------------ //
                // Methods definitions
                // ------------------------------------------------------------------------------------------------------ //

                function compare() {
                    var dates = DatePickerHelper.getPreviousCustomBaseRange(moment(vm.mobileDates.baseStart), moment(vm.mobileDates.baseEnd));
                    if (vm.mobileDates.compareChecked === true && Helper.isUnsetOrEmpty(vm.mobileDates.compareStart)) {
                        vm.mobileDates.compareStart = dates[0];
                        vm.mobileDates.compareEnd = dates[1];
                        vm.reportDates.compareStartDate = _formatDate(dates[0]);
                        vm.reportDates.compareEndDate = _formatDate(dates[1]);
                    } else if (vm.mobileDates.compareChecked === false) {
                        vm.mobileDates.compareStart = null;
                        vm.mobileDates.compareEnd = null;
                        vm.reportDates.compareStartDate = null;
                        vm.reportDates.compareEndDate = null;
                    }
                    vm.reportDates.compareChecked = vm.mobileDates.compareChecked;
                }

                function setMobileReportDates() {
                    vm.reportDates.baseStartDate = _formatDate(vm.mobileDates.baseStart);
                    vm.reportDates.baseEndDate = _formatDate(vm.mobileDates.baseEnd);
                    if (vm.mobileDates.compareChecked === true) {
                        vm.reportDates.compareStartDate = _formatDate(vm.mobileDates.compareStart);
                        vm.reportDates.compareEndDate = _formatDate(vm.mobileDates.compareEnd);
                    }
                }

                function validateMobileDates() {
                    if (vm.mobileDates.baseStart > vm.mobileDates.baseEnd) {
                        var copyStart = angular.copy(vm.mobileDates.baseStart);
                        var copyEnd = angular.copy(vm.mobileDates.baseEnd);
                        vm.mobileDates.baseStart = copyEnd;
                        vm.mobileDates.baseEnd = copyStart;
                    }
                    if (vm.mobileDates.compareChecked && vm.mobileDates.compareStart > vm.mobileDates.compareEnd) {
                        var copyStart = angular.copy(vm.mobileDates.compareStart);
                        var copyEnd = angular.copy(vm.mobileDates.compareEnd);
                        vm.mobileDates.compareStart = copyEnd;
                        vm.mobileDates.compareEnd = copyStart;
                    }
                }

                // ------------------------------------------------------------------------------------------------------ //
                // Private methods
                // ------------------------------------------------------------------------------------------------------ //

                function _formatDate(myDate) {
                    return moment.utc(myDate.toISOString()).format('YYYY-MM-DD');
                }
            },
            controllerAs: 'vm',
            bindToController: true
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .directive('confirmPassword', confirmPasswordDirective);

    /** @ngInject */
    function confirmPasswordDirective() {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, elem, attrs, ctrl) {
                var firstPassword = '#' + attrs.confirmPassword;
                elem.add(firstPassword).on('keyup', function () {
                    scope.$apply(function () {
                        ctrl.$setValidity('pwmatch', elem.val() === $(firstPassword).val());
                    });
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('TermsDialogController', TermsDialogController);

    /** @ngInject */
    function TermsDialogController($mdDialog) {
        var vm = this;
        vm.handleCloseClick = function() {
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('LoadingDialogController', LoadingDialogController);

    /** @ngInject */
    function LoadingDialogController(message) {
        var vm = this;
        vm.message = message;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.auth.reset-password', [])
        .config(config);

    /** @ngInject */
    function config() {
    }

})();
(function () {
    'use strict';

    angular
        .module('app.auth.reset-password')
        .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
    function ResetPasswordController(IsValidToken, RootService, PublisherService, $state, $stateParams) {
        var vm = this;

        // Data
        vm.publisher = new PublisherService();
        vm.isError = false;
        vm.isValidToken = IsValidToken;
        vm.isSaving = false;
        vm.isSuccess = false;

        // Methods
        vm.handleBackClick = handleBackClick;
        vm.handleResetClick = handleResetClick;

        // ------------------------------------------------------------------------------------------------------ //
        // Method definitions
        // ------------------------------------------------------------------------------------------------------ //

        // directs the user to the login page
        function handleBackClick() {
            $state.go(RootService.states.STATE_LOGIN);
        }

        // resets the users password
        function handleResetClick() {
            vm.isError = false;
            vm.isSaving = true;
            vm.isSuccess = false;

            vm.publisher.resetPassword($stateParams.token)
                .then(function () {
                    vm.isSuccess = true;
                    vm.isSaving = false;
                })
                .catch(function () {
                    vm.isError = true;
                    vm.isSaving = false;
                });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.auth.register', [])
        .config(config);

    /** @ngInject */
    function config() {
    }

})();
(function () {
    'use strict';

    angular
        .module('app.auth.register')
        .controller('RegisterController', RegisterController);

    /** @ngInject */
    function RegisterController(RootService, PublisherService, DomainService, $state, $mdDialog, $translate, $window, TERMS_PAGE) {
        var vm = this;

        // Data
        vm.publisher = new PublisherService();
        vm.domain = new DomainService();
        vm.errorMessage = "";
        vm.isError = false;
        vm.isSaving = false;

        // Methods
        vm.handleCreateClick = handleCreateClick;
        vm.handleLoginClick = handleLoginClick;
        vm.handleTermsClick = handleTermsClick;

        // ------------------------------------------------------------------------------------------------------ //
        // Method definitions
        // ------------------------------------------------------------------------------------------------------ //

        // creates a new account; then directs the user to the home page
        function handleCreateClick() {
            vm.isError = false;
            vm.isSaving = true;

            vm.publisher.create(vm.domain).then(function () {
                fireGAEvent();
                $state.go(RootService.states.STATE_HOME);
            }).catch(function (e) {
                if (!Helper.isUnsetOrEmpty(e, e.message)) {
                    vm.errorMessage = e.message;
                } else {
                    vm.errorMessage = $translate.instant("FE_SIGNUP_ERROR");
                }
                vm.isError = true;
                vm.isSaving = false;
            });
        }

        // directs the user to the login page
        function handleLoginClick() {
            $state.go(RootService.states.STATE_LOGIN);
        }

        // shows the user the terms and conditions
        function handleTermsClick() {
            $window.open(TERMS_PAGE);
        }

        function fireGAEvent() {
            // tag manager script is included in the index.html file
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'UA-123186613-1');
            gtag('event', 'sign-up');
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.auth.login', [])
        .config(config);

    /** @ngInject */
    function config() {
    }

})();
(function () {
    'use strict';

    angular
        .module('app.auth.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController(RootService, PublisherService, $state) {
        var vm = this;

        // Data
        vm.isError = false;
        vm.isSaving = false;
        vm.publisher = new PublisherService();

        // Methods
        vm.handleForgotClick = handleForgotClick;
        vm.handleLoginClick = handleLoginClick;
        vm.handleRegisterClick = handleRegisterClick;

        // ------------------------------------------------------------------------------------------------------ //
        // Method definitions
        // ------------------------------------------------------------------------------------------------------ //

        // directs the user to the forgot password page
        function handleForgotClick() {
            $state.go(RootService.states.STATE_FORGOT_PASSWORD);
        }

        // tries to log the user in
        function handleLoginClick() {
            vm.isError = false;
            vm.isSaving = true;

            vm.publisher.login().then(function () {
                $state.go(RootService.states.STATE_HOME);
            }).catch(function () {
                vm.isError = true;
                vm.isSaving = false;
            });
        }

        // directs the user to the register page
        function handleRegisterClick() {
            $state.go(RootService.states.STATE_REGISTER);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.auth.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config() {
    }

})();
(function () {
    'use strict';

    angular
        .module('app.auth.forgot-password')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController(RootService, PublisherService, $state) {
        var vm = this;

        // Data
        vm.publisher = new PublisherService();
        vm.isError = false;
        vm.isSaving = false;
        vm.isSuccess = false;

        // Methods
        vm.handleBackClick = handleBackClick;
        vm.handleResetClick = handleResetClick;

        // ------------------------------------------------------------------------------------------------------ //
        // Method definitions
        // ------------------------------------------------------------------------------------------------------ //

        // directs the user to the login page
        function handleBackClick() {
            $state.go(RootService.states.STATE_LOGIN);
        }

        // handles the reset button click that sends the user an email
        function handleResetClick() {
            vm.isError = false;
            vm.isSaving = true;
            vm.isSuccess = false;

            vm.publisher.recoverPassword()
                .then(function () {
                    vm.isSuccess = true;
                    vm.isSaving = false;
                })
                .catch(function () {
                    vm.isError = true;
                    vm.isSaving = false;
                });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.pages',
            [
                'app.pages.home',
                'app.pages.getStarted',
                'app.pages.sellers',
                'app.pages.viewAdsTxt',
                'app.pages.manualEntries',
                'app.pages.authorizedSeller',
                'app.pages.accountSettings',
                'datatables',
                'chart.js'
            ]
        )
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider, $stateProvider) {

        // State
        $stateProvider.state('app.pages', {
            abstract: true,
            url: '',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/pages/page.html',
                    controller: 'PagesController as vm'
                }
            }
        });

        msNavigationServiceProvider.saveItem('pages_home', {
            title: 'Home',
            translate: 'FE_NAV_HOME',
            icon: 'icon-home',
            state: "app.pages.home",
            weight: 1
        });

        msNavigationServiceProvider.saveItem('pages_getStarted', {
            title: 'Get Started',
            translate: 'FE_NAV_GET_STARTED',
            icon: 'icon-rocket',
            state: "app.pages.getStarted",
            weight: 2
        });

        msNavigationServiceProvider.saveItem('pages_manualEntries', {
            title: 'Manual Entries',
            translate: 'FE_NAV_MANUAL_ENTRIES',
            icon: 'icon-table-edit',
            state: "app.pages.manualEntries",
            weight: 3
        });

        msNavigationServiceProvider.saveItem('pages_sellers', {
            title: 'Sellers',
            translate: 'FE_NAV_SELLERS',
            icon: 'icon-person-plus',
            state: "app.pages.sellers",
            weight: 4
        });

        msNavigationServiceProvider.saveItem('pages_viewAdsTxt', {
            title: 'View Ads.txt',
            translate: 'FE_NAV_VIEW_ADS_TXT',
            icon: 'icon-eye',
            state: "app.pages.viewAdsTxt",
            weight: 5
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.pages')
        .controller('PagesController', PagesController);

    /** @ngInject */
    function PagesController(RootService, AuthorizedSellerList, $state, $timeout, ngIntroService, $translate, msUtils) {
        var vm = this;

        // Data
        vm.authorizedSellerList = AuthorizedSellerList;

        // Methods
        vm.handleAddSellerClick = handleAddSellerClick;
        vm.handleViewClick = handleViewClick;

        // ------------------------------------------------------------------------------------------------------ //
        // Init
        // ------------------------------------------------------------------------------------------------------ //

        initTutorial();

        $timeout(function () {
            // show the intro if not mobile and if the user has not seen it already
            if (!localStorage.HAS_SEEN_INTRO && !msUtils.isMobile()) {
                ngIntroService.start();
            }
        });

        // ------------------------------------------------------------------------------------------------------ //
        // Method definitions
        // ------------------------------------------------------------------------------------------------------ //

        // directs the user to authorize sellers page
        function handleAddSellerClick() {
            $state.go(RootService.states.STATE_SELLERS);
        }

        // directs the user to the correct manage page; either manual entries or authorized seller
        function handleViewClick(seller) {
            if (seller.sellerId === 0) {
                // manual entries
                $state.go(RootService.states.STATE_MANUAL_ENTRIES);
            } else {
                // authorized seller
                $state.go(RootService.states.STATE_AUTHORIZED_SELLER, {id: seller.sellerId});
            }
        }

        // sets up the tutorial
        function initTutorial() {
            // store that the user has seen the intro so we don't show it again
            ngIntroService.onExit(function () {
                localStorage.HAS_SEEN_INTRO = true;
            });

            ngIntroService.setOptions({
                exitOnOverlayClick: false,
                showStepNumbers: false,
                highlightClass: 'highlight',
                overlayOpacity: 0.4,
                steps: [
                    {
                        intro: "<strong>"+ $translate.instant("FE_STEPS_INTRO_TITLE") +"</strong><br>" + $translate.instant("FE_STEPS_INTRO_TEXT")
                    },
                    {
                        element: '#view-file-button',
                        position: 'top',
                        intro: "<strong>"+ $translate.instant("FE_STEPS_VIEW_TITLE") +"</strong><br>" + $translate.instant("FE_STEPS_VIEW_TEXT")
                    },
                    {
                        element: '#seller-sidenav',
                        position: 'left',
                        intro: "<strong>"+ $translate.instant("FE_STEPS_SIDENAV_TITLE") +"</strong><br>" + $translate.instant("FE_STEPS_SIDENAV_TEXT")
                    },
                    {
                        element: '#site-selections',
                        position: 'bottom',
                        intro: "<strong>"+ $translate.instant("FE_STEPS_SITE_TITLE") +"</strong><br>" + $translate.instant("FE_STEPS_SITE_TEXT")
                    },
                    {
                        element: '#widget-integrated',
                        intro: "<strong>"+ $translate.instant("FE_STEPS_INTEGRATED_TITLE") +"</strong><br>" + $translate.instant("FE_STEPS_INTEGRATED_TEXT")
                    },
                    {
                        element: '#widget-display',
                        intro: "<strong>"+ $translate.instant("FE_STEPS_DISPLAY_TITLE") +"</strong><br>" + $translate.instant("FE_STEPS_DISPLAY_TEXT")
                    },
                    {
                        element: '#widget-get-started',
                        intro: "<strong>"+ $translate.instant("FE_STEPS_START_TITLE") +"</strong><br>" + $translate.instant("FE_STEPS_START_TEXT")
                    }
                ]
            });
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService) {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass: 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort: function() {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init() {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function(response) {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if (typeof vm.shortcuts !== 'undefined' && vm.shortcuts.length > 0) {
                        vm.results = response;
                    } else {
                        vm.shortcuts = [];
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function(current, old) {
                if (angular.isUndefined(current)) {
                    return;
                }

                if (angular.equals(current, old)) {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function(response) {
                        vm.results = response;
                    },
                    // Error
                    function() {
                        vm.results = [];
                    }
                ).finally(
                    function() {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults() {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for (var x = 0; x < flatNavigation.length; x++) {
                if (flatNavigation[x].uisref) {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if (vm.query) {
                results = results.filter(function(item) {
                    if (angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1) {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for (var i = 0; i < results.length; i++) {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for (var y = 0; y < vm.shortcuts.length; y++) {
                        if (vm.shortcuts[y]._id === results[i]._id) {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            } else {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if (vm.shortcuts.length > 0) {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function() {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts() {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('ANALYTICS.shortcuts'));

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts() {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('ANALYTICS.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function() {
                deferred.resolve({ 'success': true });
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item) {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item) {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for (var x = 0; x < vm.shortcuts.length; x++) {
                if (vm.shortcuts[x]._id === item._id) {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if (!vm.query) {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if (vm.shortcuts.length === 0) {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else {
                            if (x >= vm.shortcuts.length) {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item) {
            // Add or remove the shortcut
            if (item.hasShortcut) {
                vm.removeShortcut(item);
            } else {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event) {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event) {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if (keys.indexOf(keyCode) > -1) {
                event.preventDefault();
            }

            switch (keyCode) {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                    // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if (vm.selectedResultIndex - 1 >= 0) {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                    // Down Arrow
                case 40:

                    // Increase the selected result index
                    if (vm.selectedResultIndex + 1 < vm.results.length) {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index) {
            if (vm.ignoreMouseEvents) {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents() {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function() {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible() {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if (resultsEl && selectedItemEl) {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if (resultsEl.scrollTop() > top) {
                    resultsEl.scrollTop(top);
                }

                if (bottom > (resultsEl.height() + resultsEl.scrollTop())) {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar() {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective() {
        return {
            restrict: 'E',
            scope: {},
            require: 'msShortcuts',
            controller: 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl: 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile: function(tElement) {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement) {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective($state)
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel',
                clickState  : "=clickState"
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;
                    scope.handleViewClick = handleViewClick;
                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }

                    function handleViewClick() {
                        $state.go(scope.clickState);
                    }
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('TranslationsService', TranslationsService);

    /** @ngInject */
    function TranslationsService($translate) {

        return {
            getMonths: getMonths,
            getShortMonths: getShortMonths,
            getShortWeekdays: getShortWeekdays,
            getWeekdays: getWeekdays
        };

        function getMonths() {
            var translations = [
                "MONTH_JANUARY",
                "MONTH_FEBRUARY",
                "MONTH_MARCH",
                "MONTH_APRIL",
                "MONTH_MAY",
                "MONTH_JUNE",
                "MONTH_JULY",
                "MONTH_AUGUST",
                "MONTH_SEPTEMBER",
                "MONTH_OCTOBER",
                "MONTH_NOVEMBER",
                "MONTH_DECEMBER"
            ];
            return _process(translations);
        }

        function getShortMonths() {
            var translations = [
                "MONTH_SHORT_JAN",
                "MONTH_SHORT_FEB",
                "MONTH_SHORT_MAR",
                "MONTH_SHORT_APR",
                "MONTH_SHORT_MAY",
                "MONTH_SHORT_JUN",
                "MONTH_SHORT_JUL",
                "MONTH_SHORT_AUG",
                "MONTH_SHORT_SEP",
                "MONTH_SHORT_OCT",
                "MONTH_SHORT_NOV",
                "MONTH_SHORT_DEC"
            ];
            return _process(translations);
        }

        function getShortWeekdays() {
            var translations = [
                "DAY_SHORT_SUN",
                "DAY_SHORT_MON",
                "DAY_SHORT_TUE",
                "DAY_SHORT_WED",
                "DAY_SHORT_THU",
                "DAY_SHORT_FRI",
                "DAY_SHORT_SAT"
            ];
            return _process(translations);
        }

        function getWeekdays() {
            var translations = [
                "DAY_SUNDAY",
                "DAY_MONDAY",
                "DAY_TUESDAY",
                "DAY_WEDNESDAY",
                "DAY_THURSDAY",
                "DAY_FRIDAY",
                "DAY_SATURDAY"
            ];
            return _process(translations);
        }

        function _process(translations) {
            var translationResults = $translate.instant(translations);
            return Object.keys(translationResults).map(function (key) {
                return translationResults[key];
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('TrackingService', TrackingService);

    /** @ngInject */
    function TrackingService($http, $location, SERVICE_API) {

        return {
            addActivityLog: addActivityLog
        };

        // ------------------------------------------------------------------------------------------------------ //
        // ------------------------------------------------------------------------------------------------------ //

        function addActivityLog() {
            return $http.post(SERVICE_API + '/publisher/activityLog', {page: $location.$$path});
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('SellerService', SellerService);

    /** @ngInject */
    function SellerService() {

        var apiKeys = {
            sellerId: "sellerId",
            sellerName: "sellerName",
            sellerUrl: "sellerUrl",
            entryCount: "entryCount",
            icon: "icon",
            iconType: "iconType",
            isFeatured: "isFeatured",
            isAuthorized: "isAuthorized",
            dateAuthorized: "dateAuthorized",
            dateAdded: "dateAdded"
        };

        // Constructor
        function Seller() {
            this.sellerId = 0;
            this.sellerName = "";
            this.sellerUrl = "";
            this.entryCount = "";
            this.icon = "";
            this.iconType = "";
            this.isFeatured = 0;
            this.isAuthorized = false;
            this.dateAuthorized = "";
            this.dateAdded = "";
        }

        // ------------------------------------------------------------------------------------------------------ //
        // Prototypes
        // ------------------------------------------------------------------------------------------------------ //

        // loads the seller from a json object
        Seller.prototype.loadFromJSON = function (json) {
            if (json.hasOwnProperty(apiKeys.sellerId)) {
                this.sellerId = json[apiKeys.sellerId];
            }
            if (json.hasOwnProperty(apiKeys.sellerName)) {
                this.sellerName = json[apiKeys.sellerName];
            }
            if (json.hasOwnProperty(apiKeys.sellerUrl)) {
                this.sellerUrl = json[apiKeys.sellerUrl];
            }
            if (json.hasOwnProperty(apiKeys.entryCount)) {
                this.entryCount = json[apiKeys.entryCount];
            }
            if (json.hasOwnProperty(apiKeys.icon)) {
                this.icon = json[apiKeys.icon];
            }
            if (json.hasOwnProperty(apiKeys.iconType)) {
                this.iconType = json[apiKeys.iconType];
            }
            if (json.hasOwnProperty(apiKeys.isFeatured)) {
                this.isFeatured = json[apiKeys.isFeatured];
            }
            if (json.hasOwnProperty(apiKeys.isAuthorized)) {
                this.isAuthorized = json[apiKeys.isAuthorized];
            }
            if (json.hasOwnProperty(apiKeys.dateAuthorized)) {
                this.dateAuthorized = json[apiKeys.dateAuthorized];
            }
            if (json.hasOwnProperty(apiKeys.dateAdded)) {
                this.dateAdded = json[apiKeys.dateAdded];
            }
        };

        return Seller;
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('SellerListService', SellerListService);

    /** @ngInject */
    function SellerListService(SERVICE_API, RootService, Errors, SellerService, $http, $q) {

        // Constructor
        function SellerList() {
            this.list = [];
        }

        // ------------------------------------------------------------------------------------------------------ //
        // Static methods
        // ------------------------------------------------------------------------------------------------------ //

        // gets all the sellers
        SellerList.GetNewList = function () {
            var list = new SellerList();
            return list.getAll()
                .then(function () {
                    return list;
                })
                .catch(function () {
                    return $q.reject(Errors.create(Errors.DB_ERROR, "ErASL1", "XHR request failed - GetNewList"));
                });
        };

        // gets all the authorized sellers
        SellerList.GetNewAuthorizedList = function () {
            var list = new SellerList();
            return list.getAuthorized()
                .then(function () {
                    return list;
                })
                .catch(function () {
                    return $q.reject(Errors.create(Errors.DB_ERROR, "ErASL2", "XHR request failed - GetNewAuthorizedList"));
                });
        };

        // ------------------------------------------------------------------------------------------------------ //
        // Prototypes
        // ------------------------------------------------------------------------------------------------------ //

        // increases/descreases the entry count for the seller by the count
        SellerList.prototype.adjustEntryCount = function (sellerId, count) {
            var seller = this.filterById(sellerId);
            if (Helper.isUnsetOrEmpty(seller)) return;
            seller.entryCount += count;
        };

        // authorize's a seller for a domain
        SellerList.prototype.authorizeSeller = function (sellerId) {
            var self = this;
            return $http.post(SERVICE_API + '/publisher/seller/authorize/' + sellerId)
                .then(function (response) {
                    if (response.status !== 200 || Helper.isResponseStatusFalse(response)) {
                        return $q.reject();
                    }

                    // adds the seller from the list of authorized sellers
                    var seller = _loadSingleSellerFromResponse(response.data);
                    self.list.push(seller);

                    RootService.showToast();
                    return response.data;
                })
                .catch(function () {
                    RootService.showToastError();
                    return $q.reject();
                });
        };

        // filters the list by an id
        SellerList.prototype.filterById = function (id) {
            return this.list.filter(function (seller) {
                return seller.sellerId === parseInt(id);
            })[0];
        };

        // gets all the sellers
        SellerList.prototype.getAll = function () {
            var self = this;

            // clear the current list
            self.list = [];

            return $http.get(SERVICE_API + '/publisher/seller/getAll')
                .then(function (response) {
                    if (response.status !== 200 || Helper.isResponseStatusFalse(response)) {
                        return $q.reject();
                    }

                    // create a list from the response
                    self.list = _createListFromResponse(response.data);
                    return self;
                })
                .catch(function () {
                    return $q.reject(Errors.create(Errors.DB_ERROR, "ErASL3", "XHR request failed - getAll"));
                });
        };

        // gets all the authorized sellers
        SellerList.prototype.getAuthorized = function () {
            var self = this;

            // clear the current list
            self.list = [];

            return $http.get(SERVICE_API + '/publisher/seller/getAuthorized')
                .then(function (response) {
                    if (response.status !== 200 || Helper.isResponseStatusFalse(response)) {
                        return $q.reject();
                    }

                    // create a list from the response
                    self.list = _createListFromResponse(response.data);
                    return self;
                })
                .catch(function () {
                    return $q.reject(Errors.create(Errors.DB_ERROR, "ErASL4", "XHR request failed - getAuthorized"));
                });
        };

        // gets the id's from the list items
        SellerList.prototype.getIds = function () {
            return this.list.map(function (item) {
                return item.sellerId;
            });
        };

        // removes a seller from the current list
        SellerList.prototype.removeItemById = function (id) {
            this.list = _.without(this.list, _.findWhere(this.list, {
                sellerId: id
            }));
        };

        // unauthorize's a seller for a domain
        SellerList.prototype.unauthorizeSeller = function (sellerId) {
            var self = this;
            return $http.delete(SERVICE_API + '/publisher/seller/unauthorize/' + sellerId)
                .then(function (response) {
                    if (response.status !== 200 || Helper.isResponseStatusFalse(response)) {
                        return $q.reject();
                    }

                    // removes the seller from the list of authorized sellers
                    self.removeItemById(sellerId);

                    RootService.showToast();
                    return self;
                })
                .catch(function () {
                    RootService.showToastError();
                    return $q.reject();
                });
        };

        // ------------------------------------------------------------------------------------------------------ //
        // Private functions
        // ------------------------------------------------------------------------------------------------------ //

        // creates a list from the response
        function _createListFromResponse(responseData) {
            if (Array.isArray(responseData) === false) return [];

            var list = [];
            for (var i = 0; i < responseData.length; i++) {
                var seller = new SellerService();
                seller.loadFromJSON(responseData[i]);
                list.push(seller);
            }

            return list;
        }

        // loads a single seller from the response
        function _loadSingleSellerFromResponse(responseData) {
            var seller = new SellerService();
            seller.loadFromJSON(responseData);
            return seller;
        }

        return SellerList;
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('SellerEntryService', SellerEntryService);

    /** @ngInject */
    function SellerEntryService() {

        var apiKeys = {
            sellerEntryId: "sellerEntryId",
            sellerId: "sellerId",
            advertisingSystemDomain: "advertisingSystemDomain",
            sellerAccountId: "sellerAccountId",
            accountType: "accountType",
            certificationAuthorityId: "certificationAuthorityId",
            isEnabled: "isEnabled"
        };

        // Constructor
        function SellerEntry() {
            this.sellerEntryId = 0;
            this.sellerId = 0;
            this.advertisingSystemDomain = "";
            this.sellerAccountId = "";
            this.accountType = "DIRECT";
            this.certificationAuthorityId = "";
            this.isEnabled = false;
            this.isEditing = false;
            this.isSelected = false;
        }

        // ------------------------------------------------------------------------------------------------------ //
        // Prototypes
        // ------------------------------------------------------------------------------------------------------ //

        // load the object from a json object
        SellerEntry.prototype.loadFromJSON = function (json) {
            if (json.hasOwnProperty(apiKeys.sellerEntryId)) {
                this.sellerEntryId = json[apiKeys.sellerEntryId];
            }
            if (json.hasOwnProperty(apiKeys.sellerId)) {
                this.sellerId = json[apiKeys.sellerId];
            }
            if (json.hasOwnProperty(apiKeys.advertisingSystemDomain)) {
                this.advertisingSystemDomain = json[apiKeys.advertisingSystemDomain];
            }
            if (json.hasOwnProperty(apiKeys.sellerAccountId)) {
                this.sellerAccountId = json[apiKeys.sellerAccountId];
            }
            if (json.hasOwnProperty(apiKeys.accountType)) {
                this.accountType = json[apiKeys.accountType];
            }
            if (json.hasOwnProperty(apiKeys.certificationAuthorityId)) {
                this.certificationAuthorityId = json[apiKeys.certificationAuthorityId];
            }
            if (json.hasOwnProperty(apiKeys.isEnabled)) {
                this.isEnabled = json[apiKeys.isEnabled];
            }
        };

        return SellerEntry;
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('SellerEntryListService', SellerEntryListService);

    /** @ngInject */
    function SellerEntryListService(SERVICE_API, RootService, Errors, SellerEntryService, $http, $q) {

        // Constructor
        function SellerEntryList() {
            this.list = [];
        }

        // ------------------------------------------------------------------------------------------------------ //
        // Static methods
        // ------------------------------------------------------------------------------------------------------ //

        // gets all the seller entries for a site
        SellerEntryList.GetNewList = function (sellerId) {
            var list = new SellerEntryList();
            return list.getAll(sellerId)
                .then(function () {
                    return list;
                })
                .catch(function () {
                    return $q.reject(Errors.create(Errors.DB_ERROR, "ErASELS1", "XHR request failed - GetNewList"));
                });
        };

        // ------------------------------------------------------------------------------------------------------ //
        // Prototypes
        // ------------------------------------------------------------------------------------------------------ //

        // adds an item to the list
        SellerEntryList.prototype.addItem = function (item) {
            this.list.push(item);
        };

        // sets an entry to enabled/disabled by id
        SellerEntryList.prototype.alterListItemsEnabledById = function (entryIds, isEnabled) {
            _.each(this.list, function (entry) {
                if (entryIds.indexOf(entry.sellerEntryId) !== -1) {
                    entry.isEnabled = isEnabled;
                }
            });
        };

        // sets the entries to deselected by id
        SellerEntryList.prototype.deselectItemsById = function (entryIds) {
            _.each(this.list, function (entry) {
                if (entryIds.indexOf(entry.sellerEntryId) !== -1) {
                    entry.isSelected = false;
                }
            });
        };

        // disables a list of entries
        SellerEntryList.prototype.disable = function (entryIds) {
            var self = this;
            return $http.post(SERVICE_API + '/publisher/seller/entries/disable', {entryIds: entryIds})
                .then(function (response) {
                    if (response.status !== 200 || Helper.isResponseStatusFalse(response)) {
                        return $q.reject();
                    }

                    // disables each entry in the list
                    self.alterListItemsEnabledById(entryIds, 0);

                    RootService.showToast();
                    return self;
                })
                .catch(function () {
                    RootService.showToastError();
                    return $q.reject();
                });
        };

        // enables a list of entries
        SellerEntryList.prototype.enable = function (entryIds) {
            var self = this;
            return $http.delete(SERVICE_API + '/publisher/seller/entries/enable', {data: {entryIds: entryIds}})
                .then(function (response) {
                    if (response.status !== 200 || Helper.isResponseStatusFalse(response)) {
                        return $q.reject();
                    }

                    // enables each entry in the list
                    self.alterListItemsEnabledById(entryIds, 1);

                    RootService.showToast();
                    return self;
                })
                .catch(function () {
                    RootService.showToastError();
                    return $q.reject();
                });
        };

        // filters the list by an id
        SellerEntryList.prototype.filterById = function (id) {
            return this.list.filter(function (entry) {
                return entry.sellerEntryId === id;
            })[0];
        };

        // gets all the seller entries for a site
        SellerEntryList.prototype.getAll = function (sellerId) {
            var self = this;

            // clear the current list
            self.list = [];

            return $http.get(SERVICE_API + '/publisher/seller/entries/get/' + sellerId)
                .then(function (response) {
                    if (response.status !== 200 || Helper.isResponseStatusFalse(response)) {
                        return $q.reject();
                    }

                    // create a list from the response
                    self.list = _createListFromResponse(response.data);
                    return self;
                })
                .catch(function () {
                    return $q.reject(Errors.create(Errors.DB_ERROR, "ErASELS2", "XHR request failed - getAll"));
                });
        };

        // returns a list of selected entry ids from a list of entries
        SellerEntryList.prototype.getSelectedIds = function () {
            var ids = [];
            _.each(this.list, function (entry) {
                if (entry.isSelected) ids.push(entry.sellerEntryId);
            });
            return ids;
        };

        // remove id's for entries that are not enabled or that are enabled
        SellerEntryList.prototype.filterIdsByIsEnabled = function (list, isEnabled) {
            var self = this;
            return _.filter(list, function (entryId) {
                var entry = self.filterById(entryId);
                if (Helper.isUnsetOrEmpty(entry)) return false;
                return entry.isEnabled === isEnabled;
            });
        };

        // sets the entries to selected by id
        SellerEntryList.prototype.selectItemsById = function (entryIds) {
            _.each(this.list, function (entry) {
                if (entryIds.indexOf(entry.sellerEntryId) !== -1) {
                    entry.isSelected = true;
                }
            });
        };

        // ------------------------------------------------------------------------------------------------------ //
        // Private functions
        // ------------------------------------------------------------------------------------------------------ //

        // creates a list from the response
        function _createListFromResponse(responseData) {
            if (Array.isArray(responseData) === false) return [];

            var list = [];
            for (var i = 0; i < responseData.length; i++) {
                var entry = new SellerEntryService();
                entry.loadFromJSON(responseData[i]);
                list.push(entry);
            }

            return list;
        }

        return SellerEntryList;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('RootService', RootService);

    /** @ngInject */
    function RootService($mdDialog, $translate, $mdToast) {
        return {
            states: {
                DEFAULT_STATE: "app.pages.home",
                STATE_HOME: "app.pages.home",
                STATE_LOGIN: "auth.login",
                STATE_REGISTER: "auth.register",
                STATE_FORGOT_PASSWORD: "auth.forgotPassword",
                STATE_500_ERROR: "app.errors_error-500",
                STATE_ACCOUNT_SETTINGS: "app.pages.accountSettings",
                STATE_SELLERS: "app.pages.sellers",
                STATE_AUTHORIZED_SELLER: "app.pages.authorizedSeller",
                STATE_GET_STARTED: "app.pages.getStarted",
                STATE_MANUAL_ENTRIES: "app.pages.manualEntries",
                STATE_VIEW_ADS_TXT: "app.pages.viewAdsTxt"
            },
            hideLoading: hideLoading,
            showLoading: showLoading,
            showToast: showToast,
            showToastError: showToastError,
            showToastResponseError: showToastResponseError
        };

        // ------------------------------------------------------------------------------------------------------ //
        // ------------------------------------------------------------------------------------------------------ //

        // hide the loading message
        function hideLoading() {
            $mdDialog.hide();
        }

        // show the loading message
        function showLoading(message) {
            $mdDialog.show({
                controller: 'LoadingDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dialogs/loading/loading-dialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                focusOnOpen: false,
                locals: {
                    message: $translate.instant(message)
                }
            });
        }

        // show a toast message
        function showToast(messageTranslateKey, stayOpen) {
            var hideDelay = (stayOpen === true) ? 0 : 1500;
            if (Helper.isUnsetOrEmpty(messageTranslateKey)) {
                messageTranslateKey = "FE_TOAST_SAVE";
            }
            if (hideDelay === 0) {
                $mdToast.show($mdToast.simple().textContent($translate.instant(messageTranslateKey)).position('top right').hideDelay(hideDelay).action($translate.instant('FE_CLOSE')).highlightAction(true));
            } else {
                $mdToast.show($mdToast.simple().textContent($translate.instant(messageTranslateKey)).position('top right'));
            }
        }

        // show an error toast message
        function showToastError(messageTranslateKey, stayOpen) {
            var hideDelay = (stayOpen === true) ? 0 : 500;
            if (Helper.isUnsetOrEmpty(messageTranslateKey)) {
                messageTranslateKey = "FE_TOAST_ERROR_SAVE";
            }
            if (hideDelay === 0) {
                $mdToast.show($mdToast.simple().textContent($translate.instant(messageTranslateKey)).position('top right').hideDelay(hideDelay).action($translate.instant('FE_CLOSE')).theme("error-toast").highlightAction(false));
            } else {
                $mdToast.show($mdToast.simple().textContent($translate.instant(messageTranslateKey)).position('top right').theme("error-toast"));
            }
        }

        // show an error toast for a response error message result
        function showToastResponseError(e) {
            if (!Helper.isUnsetOrEmpty(e, e.message)) {
                this.showToastError(e.message, true);
            } else {
                this.showToastError();
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('PublisherService', PublisherService);

    /** @ngInject */
    function PublisherService(SERVICE_API, RootService, DomainListService, SellerListService, $http, $q) {

        var apiKeys = {
            company: "company",
            dateAdded: "dateAdded",
            domainList: "domainList",
            email: "email",
            firstName: "firstName",
            lastName: "lastName",
            publisherId: "publisherId",
            selectedDomainId: "selectedDomainId"
        };

        // Constructor
        function Publisher() {
            this.company = "";
            this.dateAdded = "";
            this.email = "";
            this.firstName = "";
            this.lastName = "";
            this.publisherId = 0;

            this.domainList = new DomainListService();
            this.selectedDomainId = -1; // all sites
        }

        // ------------------------------------------------------------------------------------------------------ //
        // Static methods
        // ------------------------------------------------------------------------------------------------------ //

        // gets a publisher
        Publisher.Load = function () {
            var pub = new Publisher();
            return pub.get()
                .then(function () {
                    return pub;
                });
        };

        // validates that the token has not expired
        Publisher.ValidateToken = function (token) {
            var pub = new Publisher();
            return pub.validateToken(token)
                .then(function (isValid) {
                    return isValid;
                })
        };

        // ------------------------------------------------------------------------------------------------------ //
        // Prototypes
        // ------------------------------------------------------------------------------------------------------ //

        // loads the publisher from a json object
        Publisher.prototype.assignFromJson = function (json) {
            if (json.hasOwnProperty(apiKeys.company)) {
                this.company = json[apiKeys.company];
            }
            if (json.hasOwnProperty(apiKeys.dateAdded)) {
                this.dateAdded = json[apiKeys.dateAdded];
            }
            if (json.hasOwnProperty(apiKeys.email)) {
                this.email = json[apiKeys.email];
            }
            if (json.hasOwnProperty(apiKeys.firstName)) {
                this.firstName = json[apiKeys.firstName];
            }
            if (json.hasOwnProperty(apiKeys.lastName)) {
                this.lastName = json[apiKeys.lastName];
            }
            if (json.hasOwnProperty(apiKeys.publisherId)) {
                this.publisherId = json[apiKeys.publisherId];
            }
            if (json.hasOwnProperty(apiKeys.selectedDomainId)) {
                this.selectedDomainId = json[apiKeys.selectedDomainId];
            }
            if (json.hasOwnProperty(apiKeys.domainList)) {
                this.domainList.assignFromJson(json.domainList);
            }
        };

        // adds a site for the publisher
        Publisher.prototype.createDomain = function (domain) {
            var self = this;
            return $http.post(SERVICE_API + "/publisher/domain/save", domain._getObjectForApi())
                .then(function (response) {
                    if (response.status !== 200) {
                        return $q.reject();
                    } else if (Helper.isResponseStatusFalse(response)) {
                        return $q.reject(response.data); // error with existing information (site name / email / etc.)
                    }

                    // adds the new domain to the list
                    self.domainList.addItemFromResponse(response.data);

                    RootService.showToast();
                    return response.data;
                })
                .catch(function (e) {
                    RootService.showToastResponseError(e);
                    return $q.reject();
                });
        };

        // remove a site for the publisher
        Publisher.prototype.removeDomain = function (domain) {
            var self = this;
            return $http.post(SERVICE_API + "/publisher/domain/remove", domain._getObjectForApi())
                .then(function (response) {
                    if (response.status !== 200) {
                        return $q.reject();
                    } else if (Helper.isResponseStatusFalse(response)) {
                        return $q.reject(response.data); // error with existing information (site name / email / etc.)
                    }

                    // removes the domain from the list
                    self.domainList.removeItemFromResponse(response.data);

                    RootService.showToast("FE_TOAST_REMOVE");
                    return response.data;
                })
                .catch(function (e) {
                    RootService.showToastResponseError(e);
                    return $q.reject();
                });
        };

        // creates a new publisher record; also creates the publisher's first site
        Publisher.prototype.create = function (domain) {
            var self = this;
            return $http.post(SERVICE_API + '/publisher/create',
                {
                    publisher: self._getObjectForApi(),
                    domain: domain._getObjectForApi()
                })
                .then(function (response) {
                    if (response.status !== 200) {
                        return $q.reject();
                    } else if (Helper.isResponseStatusFalse(response)) {
                        return $q.reject(response.data); // error with existing information (site name / email / etc.)
                    }
                    RootService.showToast("FE_TOAST_ACCOUNT_CREATED", true);
                    return response.data;
                }).catch(function (err) {
                    return $q.reject(err);
                });
        };

        // get a publisher
        Publisher.prototype.get = function () {
            var self = this;
            return $http.get(SERVICE_API + '/publisher/get')
                .then(function (response) {
                    if (response.status !== 200 || Helper.isResponseStatusFalse(response)) {
                        return $q.reject();
                    }
                    self.assignFromJson(response.data);
                    return self;
                }).catch(function () {
                    return $q.reject();
                });
        };

        // returns the selected domain
        Publisher.prototype.getSelectedDomain = function () {
            var domain = this.domainList.filterById(this.selectedDomainId);
            if (!Helper.isUnsetOrEmpty(domain)) {
                return domain;
            }
            return null;
        };

        // returns the selected domain name
        Publisher.prototype.getSelectedDomainName = function () {
            var domain = this.domainList.filterById(this.selectedDomainId);
            if (!Helper.isUnsetOrEmpty(domain)) {
                return domain.domain;
            }
            return "";
        };

        // returns if the selected domain is an ezoic domain
        Publisher.prototype.isSelectedDomainEzoic = function () {
            var domain = this.domainList.filterById(this.selectedDomainId);
            if (!Helper.isUnsetOrEmpty(domain)) {
                return domain.isEzoicDomain;
            }
            return 0;
        };

        // tries to log a publisher in
        Publisher.prototype.login = function () {
            var self = this;
            return $http.post(SERVICE_API + '/publisher/login', self._getObjectForApiLogin())
                .then(function (response) {
                    if (response.status !== 200 || Helper.isResponseStatusFalse(response)) {
                        return $q.reject();
                    }
                    return response.data;
                }).catch(function () {
                    return $q.reject();
                });
        };

        // tries to log the publisher out
        Publisher.prototype.logout = function () {
            return $http.post(SERVICE_API + '/publisher/logout')
                .then(function (response) {
                    if (response.status !== 200 || Helper.isResponseStatusFalse(response)) {
                        return $q.reject();
                    }
                    return response.data;
                }).catch(function () {
                    RootService.showToastError("FE_TOAST_ERROR_LOGOUT", true);
                    return $q.reject();
                });
        };

        // sends a request to reset the publisher's password
        Publisher.prototype.recoverPassword = function () {
            return $http.post(SERVICE_API + '/publisher/forgotPassword', this._getObjectForApiRecoverPassword())
                .then(function (response) {
                    if (response.status !== 200 || Helper.isResponseStatusFalse(response)) {
                        return $q.reject();
                    }
                    return response.data;
                }).catch(function () {
                    return $q.reject();
                });
        };

        // sends the new password from the reset password form
        Publisher.prototype.resetPassword = function (token) {
            return $http.post(SERVICE_API + '/publisher/resetPassword', this._getObjectForApiResetPassword(token))
                .then(function (response) {
                    if (response.status !== 200 || Helper.isResponseStatusFalse(response)) {
                        return $q.reject();
                    }
                    return response.data;
                }).catch(function () {
                    return $q.reject();
                });
        };

        // saves the publisher's information
        Publisher.prototype.save = function () {
            var self = this;
            return $http.put(SERVICE_API + "/publisher/update", self._getObjectForApi())
                .then(function (response) {
                    if (response.status !== 200) {
                        return $q.reject();
                    } else if (Helper.isResponseStatusFalse(response)) {
                        return $q.reject(response.data);
                    }
                    RootService.showToast();
                    return response.data;
                })
                .catch(function (e) {
                    RootService.showToastResponseError(e);
                    return $q.reject();
                });
        };

        // saves the publisher's password
        Publisher.prototype.savePassword = function () {
            return $http.put(SERVICE_API + "/publisher/changePassword", this._getObjectForApiChangePassword())
                .then(function (response) {
                    if (response.status !== 200 || Helper.isResponseStatusFalse(response)) {
                        return $q.reject();
                    }
                    RootService.showToast();
                    return response.data;
                })
                .catch(function (resp) {
                    if (resp.status !== 400) {
                        RootService.showToastError();
                    }
                    return $q.reject(resp);
                });
        };

        // selects a domain
        Publisher.prototype.setSelectedDomain = function (domainId) {
            var self = this;
            return $http.post(SERVICE_API + '/publisher/domain/select/' + domainId)
                .then(function (response) {
                    if (response.status !== 200 || Helper.isResponseStatusFalse(response)) {
                        return $q.reject();
                    }
                    self.selectedDomainId = domainId;
                    return self;
                }).catch(function () {
                    RootService.showToastError("FE_TOAST_ERROR_SELECT_SITE");
                    return $q.reject();
                });
        };

        // validates a reset password token to make sure it has not expired
        Publisher.prototype.validateToken = function (token) {
            return $http.post(SERVICE_API + "/publisher/resetPassword/" + token)
                .then(function (response) {
                    if (response.status !== 200) {
                        return $q.reject();
                    }
                    return response.data.status;
                })
                .catch(function () {
                    return $q.reject();
                });
        };

        // formats an object for the api to read
        Publisher.prototype._getObjectForApi = function () {
            return {
                publisherId: this.publisherId,
                company: this.company,
                email: this.email,
                firstName: this.firstName,
                lastName: this.lastName,
                password: Helper.isUnsetOrEmpty(this.password) ? "" : this.password,
                confirmPassword: Helper.isUnsetOrEmpty(this.confirmPassword) ? "" : this.confirmPassword
            }
        };

        // formats an object for the api to read during login
        Publisher.prototype._getObjectForApiChangePassword = function () {
            return {
                currentPassword: this.currentPassword,
                password: this.password,
                confirmPassword: this.confirmPassword
            }
        };

        // formats an object for the api to read during login
        Publisher.prototype._getObjectForApiLogin = function () {
            return {
                email: this.email,
                password: this.password
            }
        };

        // formats an object for the api to read during the recover password process
        Publisher.prototype._getObjectForApiRecoverPassword = function () {
            return {
                email: this.email
            }
        };

        // formats an object for the api to read during the reset password process
        Publisher.prototype._getObjectForApiResetPassword = function (token) {
            return {
                publisher: {
                    email: this.email,
                    password: this.password,
                    confirmPassword: this.confirmPassword
                },
                hash: token
            }
        };

        return Publisher;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('HelpService', HelpService);

    /** @ngInject */
    function HelpService($http, $q, SERVICE_API, HelpArticleService, Errors) {

        var help = {
            title: "",
            list: []
        };

        return {
            get: get,
            help: help,
            search: search
        };

        // ------------------------------------------------------------------------------------------------------ //
        // Prototypes
        // ------------------------------------------------------------------------------------------------------ //

        function get(page) {
            // clear the current segments
            _clear();

            return $http.get(SERVICE_API + "/help", {
                params: {
                    action: "get_articles",
                    page: page
                }
            })
                .then(function (response) {
                    if (response.status !== 200) {
                        return $q.reject();
                    }
                    help.title = response.data.title;
                    help.list = _createListFromResponse(response.data.items);
                    return help;
                }).catch(function () {
                    return $q.reject(Errors.create(Errors.DB_ERROR, "0xHLG1", "XHR request failed - HelpListService::get"));
                });
        }

        function search(searchQuery) {
            _clear();

            return $http.get(SERVICE_API + "/help", {
                params: {
                    action: "search",
                    query: searchQuery
                }
            })
                .then(function (response) {
                    if (response.status !== 200) {
                        return $q.reject();
                    }
                    help.title = response.data.title;
                    help.list = _createListFromResponse(response.data.items);
                    return help;
                }).catch(function () {
                    return $q.reject(Errors.create(Errors.DB_ERROR, "0xHLS2", "XHR request failed - HelpListService::search"));
                });
        }

        // ------------------------------------------------------------------------------------------------------ //
        // Private functions
        // ------------------------------------------------------------------------------------------------------ //

        function _clear() {
            help.title = "";
            help.list = [];
        }

        function _createListFromResponse(responseData) {
            if (Array.isArray(responseData) === false) return [];

            var list = [];
            for (var i = 0; i < responseData.length; i++) {
                var article = new HelpArticleService();
                article.loadFromJSON(responseData[i]);
                list.push(article);
            }

            return list;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('HelpArticleService', HelpArticleService);

    /** @ngInject */
    function HelpArticleService() {

        function HelpArticle() {
            this.URL = "";
            this.Title = "";
            this.Body = "";
            this.CategoryTitle = "";
            this.SectionTitle = "";
            this.IsImportant = 0;
        }

        // ------------------------------------------------------------------------------------------------------ //
        // Prototypes
        // ------------------------------------------------------------------------------------------------------ //

        HelpArticle.prototype.loadFromJSON = function (json) {
            _.assign(this, json);
            if (this.CategoryTitle === null) {
                this.CategoryTitle = "General";
            }
            if (this.SectionTitle === null) {
                this.SectionTitle = "General";
            }
        };

        return HelpArticle;
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('DomainService', DomainService);

    /** @ngInject */
    function DomainService(SERVICE_API, Errors, RootService, $http, $q) {

        var apiKeys = {
            domainId: "domainId",
            publisherId: "publisherId",
            domain: "domain",
            isAdsTxtEnabled: "isAdsTxtEnabled",
            isEzoicDomain: "isEzoicDomain",
            isIntegrated: "isValid",
            lastIntegrationCheck: "lastIntegrationCheck",
            dateAdded: "dateAdded"
        };

        // Constructor
        function Domain() {
            this.domainId = 0;
            this.publisherId = 0;
            this.domain = "";
            this.isAdsTxtEnabled = 0;
            this.isEzoicDomain = 0;
            this.isIntegrated = 0;
            this.lastIntegrationCheck = "";
            this.dateAdded = "";
        }

        // ------------------------------------------------------------------------------------------------------ //
        // Static methods
        // ------------------------------------------------------------------------------------------------------ //

        Domain.GetAdsTxt = function () {
            return $http.get(SERVICE_API + "/publisher/domain/view")
                .then(function (response) {
                    if (response.status !== 200 || Helper.isResponseStatusFalse(response)) {
                        return $q.reject();
                    }
                    return response.data;
                })
                .catch(function () {
                    return $q.reject(Errors.create(Errors.DB_ERROR, "ErDS1", "XHR request failed - GetAdsTxt"));
                });
        };

        // gets the crawl stats for a domain
        Domain.GetCrawlStats = function() {
            return $http.get(SERVICE_API + "/publisher/domain/crawlStats")
                .then(function (response) {
                    if (response.status !== 200 || Helper.isResponseStatusFalse(response)) {
                        return $q.reject();
                    }
                    return response.data;
                })
                .catch(function () {
                    return $q.reject(Errors.create(Errors.DB_ERROR, "ErDS2", "XHR request failed - GetCrawlStats"));
                });
        };

        // ------------------------------------------------------------------------------------------------------ //
        // Prototypes
        // ------------------------------------------------------------------------------------------------------ //

        // checks the site's integration status
        Domain.prototype.checkIntegration = function () {
            var self = this;
            return $http.get(SERVICE_API + "/publisher/domain/validate")
                .then(function (response) {
                    if (response.status !== 200 || Helper.isResponseStatusFalse(response)) {
                        return $q.reject();
                    }

                    // sets the integration status
                    self.isIntegrated = response.data.isValid;
                    self.lastIntegrationCheck = response.data.dateAdded;

                    RootService.showToast("FE_TOAST_INTEGRATION_CHECKED");
                    return response.data;
                })
                .catch(function () {
                    RootService.showToastError();
                    return $q.reject();
                });
        };

        // checks the site's integration status
        Domain.prototype.importAdsTxt = function () {
            var self = this;
            return $http.post(SERVICE_API + "/publisher/entries/import")
                .then(function (response) {
                    if (response.status !== 200 || Helper.isResponseStatusFalse(response)) {
                        return $q.reject();
                    }
                    RootService.showToast("FE_IMPORTED");
                    return response.data;
                })
                .catch(function () {
                    RootService.showToastError("FE_IMPORT_ERROR", true);
                    return $q.reject();
                });
        };

        // loads the domain from a json object
        Domain.prototype.loadFromJSON = function (json) {
            if (json.hasOwnProperty(apiKeys.domainId)) {
                this.domainId = json[apiKeys.domainId];
            }
            if (json.hasOwnProperty(apiKeys.publisherId)) {
                this.publisherId = json[apiKeys.publisherId];
            }
            if (json.hasOwnProperty(apiKeys.domain)) {
                this.domain = json[apiKeys.domain];
            }
            if (json.hasOwnProperty(apiKeys.isAdsTxtEnabled)) {
                this.isAdsTxtEnabled = json[apiKeys.isAdsTxtEnabled];
            }
            if (json.hasOwnProperty(apiKeys.isEzoicDomain)) {
                this.isEzoicDomain = json[apiKeys.isEzoicDomain];
            }
            if (json.hasOwnProperty(apiKeys.isIntegrated)) {
                this.isIntegrated = json[apiKeys.isIntegrated];
            }
            if (json.hasOwnProperty(apiKeys.lastIntegrationCheck)) {
                this.lastIntegrationCheck = json[apiKeys.lastIntegrationCheck];
            }
            if (json.hasOwnProperty(apiKeys.dateAdded)) {
                this.dateAdded = json[apiKeys.dateAdded];
            }
        };

        // saves the site's ads.txt status
        Domain.prototype.saveStatus = function (status) {
            var api = status > 0 ? "enable" : "disable";
            return $http.put(SERVICE_API + "/publisher/domain/" + api)
                .then(function (response) {
                    if (response.status !== 200 || Helper.isResponseStatusFalse(response)) {
                        return $q.reject();
                    }
                    RootService.showToast();
                    return response.data;
                })
                .catch(function () {
                    RootService.showToastError();
                    return $q.reject();
                });
        };

        // formats an object for the api to read
        Domain.prototype._getObjectForApi = function () {
            return {
                domainId: this.domainId,
                domain: this.domain
            }
        };

        return Domain;
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('DomainListService', DomainListService);

    /** @ngInject */
    function DomainListService(SERVICE_API, Errors, DomainService) {

        // Constructor
        function DomainList() {
            this.list = [];
        }

        // ------------------------------------------------------------------------------------------------------ //
        // Prototypes
        // ------------------------------------------------------------------------------------------------------ //

        // adds a single domain from a json response
        DomainList.prototype.addItemFromResponse = function(responseJson) {
            var site = new DomainService();
            site.loadFromJSON(responseJson);
            this.list.push(site);
        };

        // removes a single domain from a json response
        DomainList.prototype.removeItemFromResponse = function(responseJson) {
            var site = new DomainService();
            site.loadFromJSON(responseJson);
            this.list = this.list.filter(function (domain) {
                return domain.domainId !== site.domainId
            });
        };

        // creates a list from the json object
        DomainList.prototype.assignFromJson = function (json) {
            if (Array.isArray(json) === false) return [];
            for (var i = 0; i < json.length; i++) {
                var site = new DomainService();
                site.loadFromJSON(json[i]);
                this.list.push(site);
            }
        };

        // filters the domain list by an id
        DomainList.prototype.filterById = function (id) {
            return this.list.filter(function (domain) {
                return domain.domainId === id;
            })[0];
        };

        return DomainList;
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('DomainEntryService', DomainEntryService);

    /** @ngInject */
    function DomainEntryService(SERVICE_API, RootService, $http, $q) {

        var apiKeys = {
            domainEntryId: "domainEntryId",
            sellerId: "sellerId",
            advertisingSystemDomain: "advertisingSystemDomain",
            sellerAccountId: "sellerAccountId",
            accountType: "accountType",
            certificationAuthorityId: "certificationAuthorityId",
        };

        // Constructor
        function DomainEntry() {
            this.domainEntryId = 0;
            this.sellerId = 0;
            this.advertisingSystemDomain = "";
            this.sellerAccountId = "";
            this.accountType = "DIRECT";
            this.certificationAuthorityId = "";
            this.isEditing = false;
            this.isSelected = false;
        }

        // ------------------------------------------------------------------------------------------------------ //
        // Prototypes
        // ------------------------------------------------------------------------------------------------------ //

        // creates a new entry
        DomainEntry.prototype.create = function () {
            return $http.post(SERVICE_API + "/publisher/entries/save", this._getObjectForApi())
                .then(function (response) {
                    if (response.status !== 200) {
                        return $q.reject();
                    } else if (Helper.isResponseStatusFalse(response)) {
                        return $q.reject(response.data);
                    }

                    // load the new entry
                    var newEntry = new DomainEntry();
                    newEntry.loadFromJSON(response.data.data);

                    RootService.showToast();
                    return newEntry;
                })
                .catch(function (res) {
                    if (res && res.message !== "") {
                        RootService.showToastResponseError(res);
                    } else {
                        RootService.showToastError();
                    }
                    return $q.reject();
                });
        };

        // load the object from a json object
        DomainEntry.prototype.loadFromJSON = function (json) {
            if (json.hasOwnProperty(apiKeys.domainEntryId)) {
                this.domainEntryId = json[apiKeys.domainEntryId];
            }
            if (json.hasOwnProperty(apiKeys.sellerId)) {
                this.sellerId = json[apiKeys.sellerId];
            }
            if (json.hasOwnProperty(apiKeys.advertisingSystemDomain)) {
                this.advertisingSystemDomain = json[apiKeys.advertisingSystemDomain];
            }
            if (json.hasOwnProperty(apiKeys.sellerAccountId)) {
                this.sellerAccountId = json[apiKeys.sellerAccountId];
            }
            if (json.hasOwnProperty(apiKeys.accountType)) {
                this.accountType = json[apiKeys.accountType];
            }
            if (json.hasOwnProperty(apiKeys.certificationAuthorityId)) {
                this.certificationAuthorityId = json[apiKeys.certificationAuthorityId];
            }
        };

        // saves an entry
        DomainEntry.prototype.save = function () {
            var self = this;
            return $http.put(SERVICE_API + "/publisher/entries/save/" + this.domainEntryId, this._getObjectForApi())
                .then(function (response) {
                    if (response.status !== 200) {
                      return $q.reject();
                    } else if (Helper.isResponseStatusFalse(response)) {
                      return $q.reject(response.data);
                    }

                    RootService.showToast();
                    return self;
                })
                .catch(function (res) {
                  if (res && res.message !== '') {
                    RootService.showToastResponseError(res);
                  } else {
                    RootService.showToastError();
                  }
                  return $q.reject();
                });
        };

        // formats an object for the api to read
        DomainEntry.prototype._getObjectForApi = function () {
            return {
                domainEntryId: this.domainEntryId,
                sellerId: this.sellerId,
                advertisingSystemDomain: this.advertisingSystemDomain,
                sellerAccountId: this.sellerAccountId,
                accountType: this.accountType,
                certificationAuthorityId: this.certificationAuthorityId
            }
        };

        return DomainEntry;
    }
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('DomainEntryListService', DomainEntryListService);

    /** @ngInject */
    function DomainEntryListService(SERVICE_API, RootService, Errors, DomainEntryService, $http, $q) {

        // Constructor
        function DomainEntryList() {
            this.list = [];
        }

        // ------------------------------------------------------------------------------------------------------ //
        // Static methods
        // ------------------------------------------------------------------------------------------------------ //

        // gets all the manual entries for a site
        DomainEntryList.GetNewList = function (sellerId) {
            var list = new DomainEntryList();
            return list.getAll(sellerId)
                .then(function () {
                    return list;
                })
                .catch(function () {
                    return $q.reject(Errors.create(Errors.DB_ERROR, "ErDELS1", "XHR request failed - GetNewList"));
                });
        };

        // ------------------------------------------------------------------------------------------------------ //
        // Prototypes
        // ------------------------------------------------------------------------------------------------------ //

        // adds an item to the list
        DomainEntryList.prototype.addItem = function (item) {
            this.list.push(item);
        };

        // saves a text list into manual entries
        DomainEntryList.prototype.bulkUpload = function (data) {
            var self = this;
            return $http.post(SERVICE_API + '/publisher/entries/upload', data)
                .then(function (response) {
                    if (response.status !== 200 || Helper.isResponseStatusFalse(response)) {
                        return $q.reject();
                    }

                    // add the new items to the current list
                    var list = _createListFromResponse(response.data.success);
                    self.list = _.union(self.list, list);

                    RootService.showToast();
                    return response.data;
                })
                .catch(function () {
                    RootService.showToastError();
                    return $q.reject();
                });
        };

        // saves a text list into manual entries assigned to a specific seller
        DomainEntryList.prototype.bulkUploadSeller = function (data, sellerId) {
            var self = this;
            return $http.post(SERVICE_API + '/publisher/entries/upload/' + sellerId, data)
                .then(function (response) {
                    if (response.status !== 200 || Helper.isResponseStatusFalse(response)) {
                        return $q.reject();
                    }

                    // add the new items to the current list
                    var list = _createListFromResponse(response.data.success);
                    self.list = _.union(self.list, list);

                    RootService.showToast();
                    return response.data;
                })
                .catch(function () {
                    RootService.showToastError();
                    return $q.reject();
                });
        };

        // deletes the list of entries
        DomainEntryList.prototype.delete = function (entryIds) {
            var self = this;
            return $http.delete(SERVICE_API + '/publisher/entries/delete', {data: {entryIds: entryIds}})
                .then(function (response) {
                    if (response.status !== 200 || Helper.isResponseStatusFalse(response)) {
                        return $q.reject();
                    }

                    // remove the items from the current list
                    self.removeItemsById(entryIds);

                    RootService.showToast();
                    return self;
                })
                .catch(function () {
                    RootService.showToastError();
                    return $q.reject();
                });
        };

        // sets the entries to deselected by id
        DomainEntryList.prototype.deselectItemsById = function (entryIds) {
            _.each(this.list, function (entry) {
                if (entryIds.indexOf(entry.domainEntryId) !== -1) {
                    entry.isSelected = false;
                }
            });
        };

        // gets all the manual entries for a site
        DomainEntryList.prototype.getAll = function (sellerId) {
            var self = this;

            // clear the current list
            self.list = [];

            return $http.get(SERVICE_API + '/publisher/entries/get/' + sellerId)
                .then(function (response) {
                    if (response.status !== 200 || Helper.isResponseStatusFalse(response)) {
                        return $q.reject();
                    }

                    // create a list from the response
                    self.list = _createListFromResponse(response.data);
                    return self;
                })
                .catch(function () {
                    return $q.reject(Errors.create(Errors.DB_ERROR, "ErDELS2", "XHR request failed - getAll"));
                });
        };

        // returns a list of selected entry ids from a list of entries
        DomainEntryList.prototype.getSelectedIds = function () {
            var ids = [];
            _.each(this.list, function (entry) {
                if (entry.isSelected) ids.push(entry.domainEntryId);
            });
            return ids;
        };

        // re-assigns a list of entries to a new authorized seller
        DomainEntryList.prototype.reassign = function (entryIds, sellerId) {
            var self = this;
            return $http.put(SERVICE_API + '/publisher/entries/assign', {
                sellerId: sellerId,
                entryIds: entryIds
            })
                .then(function (response) {
                    if (response.status !== 200 || Helper.isResponseStatusFalse(response)) {
                        return $q.reject();
                    }

                    // re-assign the ids in the actually domain entry list now
                    self.removeItemsById(entryIds);

                    RootService.showToast();
                    return self;
                })
                .catch(function () {
                    RootService.showToastError();
                    return $q.reject();
                });
        };

        // removes a list of entries from the current list from their id's
        DomainEntryList.prototype.removeItemsById = function (entryIds) {
            var self = this;
            _.each(entryIds, function (id) {
                self.list = _.without(self.list, _.findWhere(self.list, {
                    domainEntryId: id
                }));
            });
        };

        // sets the entries to selected by id
        DomainEntryList.prototype.selectItemsById = function (entryIds) {
            _.each(this.list, function (entry) {
                if (entryIds.indexOf(entry.domainEntryId) !== -1) {
                    entry.isSelected = true;
                }
            });
        };

        // ------------------------------------------------------------------------------------------------------ //
        // Private functions
        // ------------------------------------------------------------------------------------------------------ //

        // creates a list from the response
        function _createListFromResponse(responseData) {
            if (Array.isArray(responseData) === false) return [];

            var list = [];
            for (var i = 0; i < responseData.length; i++) {
                var entry = new DomainEntryService();
                entry.loadFromJSON(responseData[i]);
                list.push(entry);
            }

            return list;
        }

        return DomainEntryList;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('CSRFHeaderInterceptor', CSRFHeaderInterceptor);

    /** @ngInject */
    function CSRFHeaderInterceptor($q, $cookies, COOKIE_CSRF) {
        return {
            request: function(config) {
                config.headers['X-CSRF-Token'] = $cookies.get(COOKIE_CSRF);
                return config;
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('CommonService', CommonService);

    /** @ngInject */
    function CommonService(SVC_COMMERCE_API, Errors, $http, $q) {

        return {
            loadCountries: loadCountries
        };

        // ------------------------------------------------------------------------------------------------------ //
        // Methods
        // ------------------------------------------------------------------------------------------------------ //

        function loadCountries() {
            return $http.post(SVC_COMMERCE_API, 'action=get_countries', Helper.getFormPostHeader())
                .then(function (response) {
                    if (response.status === 200) {
                        return response.data.data;
                    }
                    return $q.reject();
                })
                .catch(function () {
                    return $q.reject(Errors.create(Errors.DB_ERROR, "0xCS1", "XHR request failed - CommonService::loadCountries"));
                });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('AuthHttpResponseInterceptor', AuthHttpResponseInterceptor);

    /** @ngInject */
    function AuthHttpResponseInterceptor($q, $window, ATM_LOGIN_PAGE) {
        return {
            responseError: function (rejection) {
                if (rejection.status === 401 && location.pathname !== '/auth/login') {
                    $window.location.href = ATM_LOGIN_PAGE;
                }
                return $q.reject(rejection);
            }
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('removeSpaces', removeSpaces);

    /** @ngInject */
    function removeSpaces() {
        return function(input) {
            return (!!input) ? input.replace(/ /g, "") : '';
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('nl2br', nl2br);

    /** @ngInject */
    function nl2br($sce) {
        return function(input) {
            var msg = (input+ '').replace(/\\n/g, '<br>');
            return $sce.trustAsHtml(msg);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('monthYear', monthYear);

    /** @ngInject */
    function monthYear() {
        return function(input) {
            return input.length > 0 ? moment(input).format("MMMM YYYY") : moment().format("MMMM YYYY");
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('monthDay', monthDay);

    /** @ngInject */
    function monthDay() {
        return function(input) {
            return input.length > 0 ? moment(input).format("MMMM DD") : moment().format("MMMM DD");
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('longTime', longTime);

    /** @ngInject */
    function longTime() {
        return function(input) {
            return input.length > 0 ? moment(input).format("MMM D, h:mm a") : moment().format("MMM D, h:mm a");
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('longDate', longDate);

    /** @ngInject */
    function longDate() {
        return function(input) {
            return input.length > 0 ? moment(input).format("MMMM D, YYYY") : moment().format("MMMM D, YYYY");
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('filterListByProperty', filterListByProperty);

    /** @ngInject */
    function filterListByProperty() {
        return function (items, propertyName, value) {
            var filtered = [];
            _.forEach(items, function(item) {
                if (item.hasOwnProperty(propertyName) === true && item[propertyName] === value) {
                    filtered.push(item);
                }
            });
            return filtered;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('filterColumnsByRequired', filterColumnsByRequired);

    /** @ngInject */
    function filterColumnsByRequired() {
        return function (items, requiredList, isRequired) {
            var filtered = [];
            if (!Array.isArray(requiredList)) return filtered;
            _.forEach(items, function(item) {
                if (isRequired && _exist(requiredList, item)) {
                    filtered.push(item);
                } else if (!isRequired && !_exist(requiredList, item)) {
                    filtered.push(item);
                }
            });
            return filtered;
        };

        function _exist(list, obj) {
            for (var i = 0; i < list.length; i++) {
                if (angular.equals(list[i], obj)) {
                    return true;
                }
            }
            return false;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropId', filterByPropId);

    /** @ngInject */
    function filterByPropId() {
        return function (items, parameter, ids) {
            if (items.length === 0 || !ids) {
                return items;
            }

            var filtered = [];

            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                var match = false;

                for (var j = 0; j < ids.length; j++) {
                    var id = ids[j];
                    if (item[parameter] == id) {
                        match = true;
                        break;
                    }
                }

                if (match) {
                    filtered.push(item);
                }
            }

            return filtered;
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('capitalize', capitalize);

    /** @ngInject */
    function capitalize() {
        return function(input) {
            return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('capitalizeColumnNames', capitalizeColumnNames);

    /** @ngInject */
    function capitalizeColumnNames() {
        return function(input) {
            return (!!input) ? input.toTitleCase().replace(/pv/gi, 'PV').replace(/tos/gi, 'TOS').replace(/\/v/gi, '/V').replace(/epmv/gi, 'ePMV').replace(/cpm/gi, 'CPM').replace(/rpm/gi, 'RPM') : '';
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function () {
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds() {
        return function(items, parameter, ids) {
            if (items.length === 0 || !ids || ids.length === 0) {
                return items;
            }

            var filtered = [];

            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                var match = false;

                for (var j = 0; j < ids.length; j++) {
                    var id = ids[j];
                    if (item[parameter].indexOf(id) > -1) {
                        match = true;
                        break;
                    }
                }

                if (match) {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController(QuickPanel, Publisher, $state, $mdSidenav, msNavigationService, RootService) {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.publisher = Publisher;
        vm.quickPanel = QuickPanel;

        // Methods
        vm.handleHelpClick = handleHelpClick;
        vm.handleProfileClick = handleProfileClick;
        vm.logout = logout;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.toggleSidenav = toggleSidenav;

        // ------------------------------------------------------------------------------------------------------ //
        // Method definitions
        // ------------------------------------------------------------------------------------------------------ //

        // log the user out
        function logout() {
            vm.publisher.logout().then(function () {
                $state.go(RootService.states.STATE_LOGIN);
            });
        }

        // opens the help tab
        function handleHelpClick() {
            vm.quickPanel.setSelectedTab(vm.quickPanel.tabs.HELP);
            vm.quickPanel.toggle();
        }

        // open the profile settings page
        function handleProfileClick() {
            $state.go(RootService.states.STATE_ACCOUNT_SETTINGS);
        }

        // open/close the mobile menu
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        // open/close the navigation
        function toggleMsNavigationFolded() {
            msNavigationService.toggleFolded();
        }

        // open/close sidenav
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('QuickPanelService', QuickPanelService);

    /** @ngInject */
    function QuickPanelService(msNavigationService, $window, $mdSidenav) {

        var QUICK_PANEL_ID = "quick-panel";

        // Constructor
        function QuickPanel() {
            this.selectedTab = 0;
            this.tabs = {
                TODAY: 0,
                SITES: 1,
                HELP: 2
            };
        }

        // ------------------------------------------------------------------------------------------------------ //
        // Prototypes
        // ------------------------------------------------------------------------------------------------------ //

        // set what tab is selected
        QuickPanel.prototype.setSelectedTab = function (id) {
            this.selectedTab = id;
        };

        // opens/closes the panel
        QuickPanel.prototype.toggle = function () {
            $mdSidenav(QUICK_PANEL_ID).toggle();
        };

        return QuickPanel;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(RootService, QuickPanel, Publisher, DomainService, COOKIE_LANGUAGE, COOKIE_LANGUAGE_DOMAIN, $window, $cookies, $scope, $rootScope, $state, $mdDialog, $translate) {
        var vm = this;
        var origSelectedDomainId = angular.copy(Publisher.selectedDomainId);

        // Data
        vm.publisher = Publisher;
        vm.quickPanel = QuickPanel;
        vm.selectedDomain = Publisher.getSelectedDomain();
        vm.selectedTab = 0;
        vm.languages = {
            en: {
                'title': 'English',
                'translation': 'LANGUAGE_ENGLISH',
                'code': 'en',
                'flag': 'us'
            },
            fr: {
                'title': 'French',
                'translation': 'LANGUAGE_FRENCH',
                'code': 'fr',
                'flag': 'fr'
            },
            de: {
                'title': 'German',
                'translation': 'LANGUAGE_GERMAN',
                'code': 'de',
                'flag': 'de'
            }
        };
        vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];

        // sets the original status of the ads.txt display
        var originalStatus = vm.selectedDomain.isAdsTxtEnabled;

        // Methods
        vm.handleAddSiteClick = handleAddSiteClick;
        vm.handleAdsTxtToggle = handleAdsTxtToggle;
        vm.changeLanguage = changeLanguage;
        vm.handleSiteSelected = handleSiteSelected;
        vm.handleTabSelection = handleTabSelection;
        vm.handleRemoveSiteClick = handleRemoveSiteClick;

        // ------------------------------------------------------------------------------------------------------ //
        // Init
        // ------------------------------------------------------------------------------------------------------ //

        $scope.$watch('ctrlQuickPanel.quickPanel.selectedTab', function (current, old) {
            if (!Helper.isUnsetOrEmpty(current, old) && parseInt(current) !== parseInt(old)) {
                _.defer(function () {
                    $scope.$apply(vm.selectedTab = current)
                });
            }
        });

        $scope.$watch('ctrlQuickPanel.publisher.selectedDomainId', function (current, old) {
            if (!Helper.isUnsetOrEmpty(current, old) && parseInt(current) !== parseInt(old) && parseInt(current) !== origSelectedDomainId) {
                handleSiteSelected(parseInt(current));
            }
        });

        // ------------------------------------------------------------------------------------------------------ //
        // Method definitions
        // ------------------------------------------------------------------------------------------------------ //

        // handles a language change request
        function changeLanguage(lang) {
            if (vm.selectedLanguage === lang) return; // nothing has changed
            vm.selectedLanguage = lang;

            var expireDate = new Date();
            expireDate.setDate(expireDate.getDate() + 365);

            // Change the language
            $cookies.put(COOKIE_LANGUAGE, lang.code.toUpperCase(), {
                'expires': expireDate,
                'path': '/',
                'domain': COOKIE_LANGUAGE_DOMAIN
            });
            $window.location.reload();
        }

        // returns a dialog that confirms disabling ads.txt
        function getDisableAdsTxtConfirm() {
            return $mdDialog
                .confirm()
                .title($translate.instant('FE_CONFIRM_ADS_TXT_DISABLE_TITLE'))
                .textContent($translate.instant('FE_CONFIRM_ADS_TXT_DISABLE_TEXT'))
                .ariaLabel('confirm disable')
                .clickOutsideToClose(false)
                .parent(angular.element(document.body))
                .ok($translate.instant('FE_CONFIRM'))
                .cancel($translate.instant('FE_CANCEL'));
        }

        // open the dialog to add a site
        function handleAddSiteClick() {
            $mdDialog.show({
                controller: 'CreateDomainDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/pages/dialogs/create-domain/create-domain-dialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                focusOnOpen: false,
                locals: {
                    publisher: vm.publisher
                }
            });
        }

        // handles the toggling of ads.txt status
        function handleAdsTxtToggle() {
            if (originalStatus === 1) {
                $mdDialog.show(getDisableAdsTxtConfirm()).then(
                    function () {
                        saveAdsTxtStatusChanges(0);
                    }, function () {
                        vm.selectedDomain.isAdsTxtEnabled = 1;
                    });
            } else {
                saveAdsTxtStatusChanges(1);
            }
        }

        // set the site as selected
        function handleSiteSelected(domainId) {
            RootService.showLoading('FE_SAVING');
            Publisher.setSelectedDomain(domainId)
                .then(function () {
                    origSelectedDomainId = angular.copy(vm.publisher.selectedDomainId);
                    $state.reload();
                    QuickPanel.toggle();
                })
                .catch(function () {
                    vm.publisher.selectedDomainId = origSelectedDomainId;
                    RootService.hideLoading();
                });
        }

        // sets the selected tab
        function handleTabSelection(tab) {
            vm.quickPanel.selectedTab = tab;
        }

        // toggles the status of displaying the ads.txt file for a site
        function saveAdsTxtStatusChanges(status) {
            RootService.showLoading('FE_SAVING');

            vm.selectedDomain.saveStatus(status)
                .then(function() {
                    // set to the new status and set the original to the new status
                    vm.selectedDomain.isAdsTxtEnabled = status;
                    originalStatus = status;
                })
                .catch(function () {
                    // reset to the original status
                    vm.selectedDomain.isAdsTxtEnabled = originalStatus;
                })
                .finally(function () {
                    RootService.hideLoading();
                });
        }

        // get the confirm dialog to show before deleting
        function getConfirmDialog() {
            return $mdDialog
                .confirm()
                .title($translate.instant('FE_CONFIRM_REMOVE_SITE_TITLE'))
                .ariaLabel('confirm delete')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok($translate.instant('FE_CONFIRM'))
                .cancel($translate.instant('FE_CANCEL'));
        }

        function handleRemoveSiteClick(domain) {
            if (vm.publisher.domainList.list.length <= 1) {
                return;
            }
            $mdDialog.show(getConfirmDialog()).then(function() {
                removeDomain(domain);
            });
        }

        function removeDomain(domain) {
            RootService.showLoading('FE_DELETING');

            // reload to next available domain if current domain is removed
            if (vm.publisher.selectedDomainId === domain.domainId) {
                const selectedDomainIndex = vm.publisher.domainList.list.findIndex(function (domain) {
                    return domain.domainId === vm.publisher.selectedDomainId
                });
                const pubDomainList = vm.publisher.domainList.list;
                const nextDomainIndex = (selectedDomainIndex + 1) % pubDomainList.length;
                handleSiteSelected(pubDomainList[nextDomainIndex].domainId);
            }

            vm.publisher.removeDomain(domain)
                .then(function(response) {
                })
                .finally(function() {
                    RootService.hideLoading();
                });
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController(RootService, DomainService, $scope, $rootScope, $mdDialog) {
        var vm = this;

        // set default chart settings
        Chart.defaults.global.defaultFontFamily = '"Roboto", "Helvetica Neue", "Arial", sans-serif';
        Chart.defaults.global.defaultFontColor = 'rgba(0,0,0,0.54)';

        // show the ads.txt file
        vm.handleViewClick = handleViewClick;

        // ------------------------------------------------------------------------------------------------------ //
        // Init
        // ------------------------------------------------------------------------------------------------------ //

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event) {
            if (event.targetScope.$id === $scope.$id) {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });

        // ------------------------------------------------------------------------------------------------------ //
        // Method definitions
        // ------------------------------------------------------------------------------------------------------ //

        // shows the ads.txt file in a modal
        function handleViewClick() {
            RootService.showLoading("FE_LOADING");
            DomainService.GetAdsTxt()
                .then(function (adsTxt) {
                    RootService.hideLoading();
                    $mdDialog.show(
                        $mdDialog.alert()
                            .clickOutsideToClose(false)
                            .parent(angular.element(document.body))
                            .title("Ads.txt")
                            .htmlContent("<div class='view-txt'>" + adsTxt + "</div>")
                            .ariaLabel('Ads.txt')
                            .ok('Close')
                    );
                })
                .catch(function () {
                    RootService.hideLoading();
                });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined'
    && typeof require === 'function' ? factory(require('../moment')) :
        typeof define === 'function' && define.amd ? define(['../moment'], factory) :
            factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return de;

})));

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined'
    && typeof require === 'function' ? factory(require('../moment')) :
        typeof define === 'function' && define.amd ? define(['../moment'], factory) :
            factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fr = moment.defineLocale('fr', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Aujourd\'hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        ordinalParse: /\d{1,2}(er|)/,
        ordinal : function (number) {
            return number + (number === 1 ? 'er' : '');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fr;

})));

(function () {
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, $mdDialog, $document, RootService, HelpService, $location, $cookies, COOKIE_ATM, IS_LOCAL, TrackingService) {
        var handlingUnsavedChanges = false;
        var helpLoaded = false;

        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', stateChangeStart);

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function (event, to, toParams, from, fromParams) {
            $timeout(function () {
                $rootScope.loadingProgress = false;
                RootService.hideLoading();
            });

            // only load help when logged in
            if ($location.$$path.indexOf("auth/") === -1 && helpLoaded === false) {
                HelpService.get($location.$$path);
                helpLoaded = true;
            }

            $rootScope.previousState = from;
            handlingUnsavedChanges = false;

            if (to.name.indexOf('auth') === -1) {
                if (!IS_LOCAL) {
                    TrackingService.addActivityLog();
                }
            }
        });

        // Handle error in state resolve
        var stateChangeErrorEvent = $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
            if (angular.isObject(error) && angular.isString(error.code)) {
                var s = $state.get(RootService.states.STATE_500_ERROR);
                s.error = error;
                s.error.fromStateName = fromState.name;
                $state.go(RootService.states.STATE_500_ERROR);
            } else {
                // unexpected error
                $state.go(RootService.states.STATE_500_ERROR);
            }
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function () {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
            stateChangeErrorEvent();
        });

        // Methods

        function stateChangeStart(event, toState, toParams) {
            $rootScope.loadingProgress = true;

            // don't let user see login page unless they are not logged in
            if ((toState.name === "auth.login" || toState.name === "auth.register") && typeof $cookies.get(COOKIE_ATM) !== "undefined") {
                event.preventDefault();
                $state.go(RootService.states.STATE_HOME);
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise("/auth/login");

        // State definitions
        $stateProvider
            .state('auth', {
                url: '/auth',
                abstract: true,
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    }
                },
            })
            .state('auth.login', {
                url: '/login',
                views: {
                    'content@auth': {
                        templateUrl: 'app/main/auth/login/login.html',
                        controller: 'LoginController as vm'
                    }
                }
            })
            .state('auth.register', {
                url: '/register',
                views: {
                    'content@auth': {
                        templateUrl: 'app/main/auth/register/register.html',
                        controller: 'RegisterController as vm'
                    }
                }
            })
            .state('auth.forgotPassword', {
                url: '/forgot-password',
                views: {
                    'content@auth': {
                        templateUrl: 'app/main/auth/forgot-password/forgot-password.html',
                        controller: 'ForgotPasswordController as vm'
                    }
                }
            })
            .state('auth.resetPassword', {
                url: '/reset-password/:token',
                views: {
                    'content@auth': {
                        templateUrl: 'app/main/auth/reset-password/reset-password.html',
                        controller: 'ResetPasswordController as vm'
                    }
                },
                resolve: {
                    IsValidToken: function (PublisherService, $state, $stateParams) {
                        return PublisherService.ValidateToken($stateParams.token).then(function (isValid) {
                            return isValid;
                        });
                    }
                }
            })
            .state('error', {
                url: '/error',
                abstract: true,
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    }
                },
                bodyClass: 'error-404'
            })
            .state('error.error-404', {
                url: '/404',
                views: {
                    'content@error': {
                        templateUrl: 'app/main/errors/404/error-404.html',
                        controller: 'Error404Controller as vm'
                    }
                }
            })
            .state('error.error-503', {
                url: '/503',
                views: {
                    'content@error': {
                        templateUrl: 'app/main/errors/503/error-503.html',
                        controller: 'Error503Controller as vm'
                    }
                }
            })
            .state('app', {
                abstract: true,
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/horizontal-navigation.html',
                        controller: 'MainController as vm'
                    },
                    'toolbar@app': {
                        templateUrl: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                        controller: 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: 'app/navigation/layouts/horizontal-navigation/navigation.html',
                        controller: 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller: 'QuickPanelController as ctrlQuickPanel'
                    }
                },
                resolve: {
                    translateReady: function ($translate) {
                        return $translate.onReady();
                    },
                    Publisher: function (PublisherService, $state) {
                        return PublisherService.Load().then(function (pub) {
                            return pub;
                        }).catch(function () {
                            $state.go('error.error-503');
                        });
                    },
                    AuthorizedSellerList: function (SellerListService, $state) {
                        return SellerListService.GetNewAuthorizedList().then(function (list) {
                            return list;
                        }).catch(function () {
                            $state.go('error.error-503');
                        });
                    },
                    QuickPanel: function (QuickPanelService) {
                        return new QuickPanelService();
                    }
                }
            });
    }

})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming, $scope, $http, SERVICE_API) {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
        vm.showLoader = false;

        $scope.$on("SHOW_LOADER", function(event, args) {
            if (args.show === true) {
                vm.showLoader = true;
            } else if (args.show === false) {
                vm.showLoader = false;
            }
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        });

        // call the token endpoint on initial pageload
        $http.get(SERVICE_API + '/token');
    }
})();

(function () {
    'use strict';

    var fuse = angular.module('fuse');

    if (location.origin === "http://l.adstxtmanager.com:3100") {
        fuse.constant('IS_LOCAL', true);
        fuse.constant('SERVICE_API', 'http://l.adstxtmanager.com:9093');
        fuse.constant('ATM_LOGIN_PAGE', 'http://l.adstxtmanager.com:3100/auth/login');
        fuse.constant('COOKIE_LANGUAGE_DOMAIN', 'localhost');
        fuse.constant('COOKIE_CSRF', 'atm_local_csrf');
    } else {
        fuse.constant('IS_LOCAL', false);
        fuse.constant('SERVICE_API', 'https://svc.adstxtmanager.com:9092');
        fuse.constant('ATM_LOGIN_PAGE', 'https://svc.adstxtmanager.com/auth/login');
        fuse.constant('COOKIE_LANGUAGE_DOMAIN', '.adstxtmanager.com');
        fuse.constant('COOKIE_CSRF', 'atm_csrf');
    }

    fuse.constant('HELP_CENTER', "https://support.ezoic.com/");
    fuse.constant('TERMS_PAGE', "https://www.adstxtmanager.com/terms/");
    fuse.constant('COOKIE_LANGUAGE', "sessionLanguage");
    fuse.constant('COOKIE_ATM_INTERNAL', "atmint");
    fuse.constant('COOKIE_ATM', "atm_sesh");
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($translateProvider, $qProvider, $httpProvider, COOKIE_LANGUAGE, SERVICE_API, $mdThemingProvider) {
        // Put your common app configurations here
        $qProvider.errorOnUnhandledRejections(false);

        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies',
            function (_$cookies) {
                $cookies = _$cookies;
            }
        ]);

        $mdThemingProvider.theme('error-toast');

        // Gets the language
        var lang = $cookies.get(COOKIE_LANGUAGE);
        lang = !Helper.isUnsetOrEmpty(lang) ? lang.toLowerCase() : 'en';
        lang = ['en', 'de', 'fr'].indexOf(lang) === -1 ? 'en' : lang;

        moment.locale(lang);

        // angular-translate configuration
        $translateProvider.useUrlLoader(SERVICE_API + "/translations", {lang: lang});
        $translateProvider.preferredLanguage(lang);
        $translateProvider.useSanitizeValueStrategy('escapeParameters');

        $httpProvider.defaults.withCredentials = true;
        $httpProvider.interceptors.push('CSRFHeaderInterceptor');
        $httpProvider.interceptors.push('AuthHttpResponseInterceptor');

        $.fn.DataTable.ext.pager.numbers_length = 5;
        $.fn.dataTable.ext.errMode = 'throw';
    }

})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService() {
        var api = {};
        api.baseUrl = 'app/data/';
        return api;
    }

})();
String.prototype.sprintF = function () {
    var args = arguments;
    return this.replace(/{(\d+)}/g, function (match, number) {
        return typeof args[number] !== 'undefined' ? args[number] : match;
    });
};

String.prototype.ucFirst = function () {
    return this.charAt(0).toUpperCase() + this.substr(1);
};

String.prototype.toTitleCase = function () {
    return this.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
};

String.prototype.toTitleCaseTable = function () {
    return this.toTitleCase()
        .replace(/pv/gi, 'PV')
        .replace(/tos/gi, 'TOS')
        .replace(/\/v/gi, '/V')
        .replace(/cpm/gi, 'CPM')
        .replace(/rpm/gi, 'RPM')
        .replace(/epmv/gi, 'ePMV');
};

Array.prototype.objectExists = function (obj) {
    for (var i = 0; i < this.length; i++) {
        if (angular.equals(this[i], obj)) {
            return true;
        }
    }
    return false;
};

Array.prototype.getObjectIndex = function (obj) {
    for (var i = 0; i < this.length; i++) {
        if (angular.equals(this[i], obj)) {
            return i;
        }
    }
    return -1;
};

var Helper = (function () {
    return {
        getFormPostHeader: function () {
            return {headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}};
        },
        isUnsetOrEmpty: function () {
            for (var i = 0; i < arguments.length; i++) {
                var arg = arguments[i];
                if (typeof arg === "undefined" || arg === null || arg === "") {
                    return true;
                }
            }
            return false;
        },
        isResponseStatusFalse: function (response) {
            return !Helper.isUnsetOrEmpty(response.data.status) && response.data.status === false;
        },
        removeNotNumericChars: function (str) {
            if (this.isUnsetOrEmpty(str)) return;
            return str.replace(/[^0-9.]/g, '');
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.errors', [
            'app.errors.error-500'
        ])
        .config(config);

    /** @ngInject */
    function config() {
    }
})();
(function () {
    'use strict';

    angular
        .module('app.auth', [
            'app.auth.login',
            'app.auth.register',
            'app.auth.forgot-password',
            'app.auth.reset-password'
        ])
        .config(config);

    /** @ngInject */
    function config() {
    }
})();
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-selected=\"ctrlQuickPanel.selectedTab\" id=\"quick-panel-tabs\" md-no-pagination md-swipe-content \nmd-stretch-tabs=\"always\"><md-tab md-on-select=\"ctrlQuickPanel.handleTabSelection(0)\"><md-tab-label><span \ntitle=\"{{\'FE_TODAY\' | translate}}\" translate=\"FE_SETTINGS\"></span></md-tab-label><md-tab-body><md-content \nclass=\"today-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\" \nng-controller=\"TodayTabController as vm\"></md-content></md-tab-body></md-tab><md-tab \nmd-on-select=\"ctrlQuickPanel.handleTabSelection(1)\"><md-tab-label><span title=\"{{\'FE_SITES\' | translate}}\" \ntranslate=\"FE_SITES\"></span></md-tab-label><md-tab-body><md-content class=\"sites-tab scrollable\" ms-scroll \nng-include=\"\'app/quick-panel/tabs/sites/sites-tab.html\'\" ng-controller=\"SitesTabController as vm\"></md-content>\n</md-tab-body></md-tab><md-tab md-on-select=\"ctrlQuickPanel.handleTabSelection(2)\"><md-tab-label><span \ntitle=\"{{\'FE_HELP\' | translate}}\" translate=\"FE_HELP\"></span></md-tab-label><md-tab-body><md-content \nclass=\"help-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/help/help-tab.html\'\" \nng-controller=\"HelpTabController as vm\"></md-content></md-tab-body></md-tab></md-tabs></md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"row\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content><md-button id=\"view-file-button\" class=\"md-fab md-primary view-file\" \naria-label=\"view\" ng-click=\"vm.handleViewClick()\"><md-icon md-font-icon=\"icon-eye\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\'FE_NAV_VIEW_ADS_TXT\' | translate}}</md-tooltip></md-button></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-fade-in-out md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"{{ \'SFE_SEARCH_PLACEHOLDER\' | translate }}\" flex ng-model=\"MsSearchBar.query\" \nng-model-options=\"MsSearchBar.queryOptions\" ng-blur=\"MsSearchBar.collapse()\" \nng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button class=\"ms-search-bar-collapser md-icon-button\" \nng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\"><md-icon md-font-icon=\"icon-close\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-results\" ng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" \nng-if=\"MsSearchBar.results.length === 0\" translate=\"SFE_LIST_NO_RESULTS\"></div><div class=\"result\" \nng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.translate | translate}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/apps/pages/page.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"md-hue-2 pagescontent\"><div class=\"animate-slide-up md-hue-2 pagescontent\" ui-view=\"pagescontent\" flex>\n</div></div></div><md-sidenav id=\"seller-sidenav\" class=\"sidenav md-sidenav-right\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper ng-cloak><div \nclass=\"widget-group\"><ms-widget flippable=\"false\" class=\"sidenav-widget\"><ms-widget-front><div class=\"seller-widget\" \nlayout=\"column\" layout-align=\"start\"><div class=\"h3\" translate=\"FE_UNASSIGNED\"></div><div class=\"ms-card\" \nng-repeat=\"seller in vm.authorizedSellerList.list | filter: { sellerId: \'0\'}\" ng-click=\"vm.handleViewClick(seller)\">\n<div class=\"ms-card-content-wrapper widget-manual\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"media\"><img class=\"image\" ng-src=\"/assets/images/sellers/manual.png\" alt=\"{{seller.sellerName}}\"></div><div \nclass=\"info\" layout=\"column\" layout-align=\"space-between\" layout-fill flex><div class=\"p-8\"><div class=\"title h4\">\n{{seller.sellerName}}</div><div class=\"subtitle h4 secondary-text\">\n{{seller.entryCount}} {{seller.entryCount == 1 ? \'FE_ENTRY\' : \'FE_ENTRIES\' | translate | lowercase}}</div></div></div>\n<md-button class=\"md-icon-button\" aria-label=\"more\" translate translate-attr-aria-label=\"manage {{seller.sellerName}}\">\n<md-icon md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon><md-tooltip md-direction=\"bottom\" md-delay=\"500\">\n{{ \'FE_MANAGE_MANUAL_ENTRIES\' | translate }}</md-tooltip></md-button></div></div></div><div class=\"h3 mt-16\" \ntranslate=\"FE_AUTHORIZED_SELLERS\"></div><div><div class=\"ms-card\" \nng-repeat=\"seller in vm.authorizedSellerList.list | filter: { sellerId: \'!0\'}\"><div \nclass=\"ms-card-content-wrapper widget-auth-seller\" ng-click=\"vm.handleViewClick(seller)\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"media\"><img class=\"image\" \nng-src=\"data:{{seller.iconType}};base64,{{seller.icon}}\" alt=\"{{seller.sellerName}}\"></div><div class=\"info\" \nlayout=\"column\" layout-align=\"space-between\" layout-fill flex><div class=\"p-8\"><div class=\"title h4\">\n{{seller.sellerName}}</div><div class=\"subtitle h4 secondary-text\">\n{{seller.entryCount}} {{seller.entryCount == 1 ? \'FE_ENTRY\' : \'FE_ENTRIES\' | translate | lowercase}}</div></div></div>\n<md-button class=\"md-icon-button\" aria-label=\"more\" translate translate-attr-aria-label=\"manage {{seller.sellerName}}\">\n<md-icon md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon><md-tooltip md-direction=\"bottom\" md-delay=\"500\">\n{{ \'FE_MANAGE_AUTHORIZED_SELLER\' | translate }}</md-tooltip></md-button></div></div></div></div><div \nng-if=\"vm.authorizedSellerList.list.length == 1\" class=\"ms-card add h-60\"><div class=\"ms-card-content-wrapper\" \nlayout=\"column\" layout-align=\"center center\" ng-click=\"vm.handleAddSellerClick()\"><div layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-person-plus\" class=\"mr-8 title h4\"></md-icon><div \nclass=\"title h4\" translate=\"FE_CLICK_TO_AUTHORIZE\"></div></div></div></div></div></ms-widget-front></ms-widget></div>\n<md-button class=\"md-fab help-button md-accent-bg\" ng-click=\"vm.handleAddSellerClick()\" \naria-label=\"help center button\"><md-icon md-font-icon=\"icon-person-plus\"></md-icon><md-tooltip md-direction=\"left\">\n{{ \'FE_ADD_AUTHORIZED_SELLER\' | translate }}</md-tooltip></md-button></md-sidenav></div>");
$templateCache.put("app/main/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\">\n<md-progress-linear ng-if=\"vm.isSaving\" md-mode=\"indeterminate\"></md-progress-linear><div class=\"p-32\"><div \nclass=\"logo\"><img src=\"/assets/images/logos/symbol.png\" alt=\"adstxtmanager.com\" title=\"adstxtmanager.com\"></div><div \nng-if=\"vm.isError\" class=\"p-16 red-bg white-fg mb-32\" translate=\"FE_FORGOT_ERROR\"></div><div class=\"title\" \ntranslate=\"FE_FORGOT_PASSWORD_TITLE\"></div><div ng-if=\"vm.isSuccess\" class=\"p-16 green-bg white-fg mb-32\" \ntranslate=\"FE_FORGOT_SUCCESS\"></div><form name=\"forgotPasswordForm\" novalidate ng-if=\"!vm.isSuccess\">\n<md-input-container class=\"md-block\" md-no-float><label translate=\"FE_EMAIL\"></label><input type=\"email\" name=\"email\" \nng-model=\"vm.publisher.email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"forgotPasswordForm.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message-exp=\"[\'required\', \'pattern\']\"><span translate=\"FE_EMAIL_ERROR\"></span>\n</div></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"RESET MY PASSWORD\" ng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" \ntranslate=\"FE_FORGOT_PASSWORD_SEND_LINK\" ng-click=\"vm.handleResetClick()\" \ntranslate-attr-aria-label=\"FE_FORGOT_PASSWORD_SEND_LINK\"></md-button></form><div class=\"login\" layout=\"row\" \nlayout-align=\"center center\"><a class=\"link\" href=\"#\" ng-click=\"vm.handleBackClick()\" translate=\"FE_BACK_TO_LOGIN\"></a>\n</div></div></div></div></div>");
$templateCache.put("app/main/auth/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><md-progress-linear ng-if=\"vm.isSaving\" \nmd-mode=\"indeterminate\"></md-progress-linear><div class=\"p-32\"><div class=\"logo\"><img \nsrc=\"/assets/images/logos/symbol.png\" alt=\"adstxtmanager.com\" title=\"adstxtmanager.com\"></div><div ng-if=\"vm.isError\" \nclass=\"p-16 red-bg white-fg mb-32\" translate=\"FE_LOGIN_ERROR\"></div><div class=\"title\" translate=\"FE_LOGIN_TITLE\">\n</div><form name=\"loginForm\" novalidate><md-input-container class=\"md-block\" md-no-float><label translate=\"FE_EMAIL\">\n</label><input type=\"email\" name=\"email\" ng-model=\"vm.publisher.email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message-exp=\"[\'required\', \'pattern\']\">\n<span translate=\"FE_EMAIL_ERROR\"></span></div></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float><label translate=\"FE_PASSWORD\"></label><input type=\"password\" name=\"password\" \nng-model=\"vm.publisher.password\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\'FE_PASSWORD\' | translate}} {{\'FE_FIELD_IS_REQUIRED\' | translate}}</span></div></div>\n</md-input-container><div class=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\"><div></div><a href=\"#\" ng-click=\"vm.handleForgotClick()\" \nclass=\"forgot-password md-accent-color\" translate=\"FE_LOGIN_FORGOT_PASSWORD\"></a></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine || vm.isSaving\" ng-click=\"vm.handleLoginClick()\" \ntranslate=\"FE_LOGIN\"></md-button></form><div class=\"register\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center center\"><span class=\"text\" translate=\"FE_LOGIN_NO_ACCOUNT\"></span> <a class=\"link\" href=\"#\" \nng-click=\"vm.handleRegisterClick()\" translate=\"FE_LOGIN_CREATE_ACCOUNT\"></a></div></div></div></div></div>");
$templateCache.put("app/main/auth/register/register.html","<div id=\"register\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"register-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"register-form\" class=\"md-whiteframe-8dp\"><md-progress-linear ng-if=\"vm.isSaving\" \nmd-mode=\"indeterminate\"></md-progress-linear><div class=\"p-32\"><div class=\"logo\"><img \nsrc=\"/assets/images/logos/symbol.png\" alt=\"adstxtmanager.com\" title=\"adstxtmanager.com\"></div><div ng-if=\"vm.isError\" \nclass=\"p-16 red-bg white-fg mb-16\">{{vm.errorMessage}}</div><div class=\"title\" translate=\"FE_REGISTER_TITLE\"></div><div\n layout=\"row\" layout-sm=\"column\" layout-align=\"start center\"><span translate=\"FE_REGISTER_TAGLINE\" class=\"tagline\">\n</span></div><form name=\"registerForm\" novalidate><div layout=\"row\" layout-align=\"start\"><md-input-container \nclass=\"md-block\" md-no-float flex><label translate=\"FE_SITE_NAME\"></label><input name=\"siteName\" \nng-model=\"vm.domain.domain\" ng-pattern=\"/^[a-zA-Z0-9]+?[a-zA-Z0-9-]{0,}?[a-zA-Z0-9]+?[.][a-zA-Z0-9.]+?$/\" required><div\n ng-messages=\"registerForm.siteName.$error\"><div ng-message=\"pattern\">{{\'FE_SITE_NAME_ERROR\' | translate}}</div><div \nng-message=\"required\">{{\'FE_SITE_NAME\' | translate}} {{\'FE_FIELD_IS_REQUIRED\' | translate}}</div></div>\n</md-input-container></div><md-input-container class=\"md-block\" md-no-float><label translate=\"FE_COMPANY\"></label>\n<input name=\"company\" ng-model=\"vm.publisher.company\"></md-input-container><div layout=\"row\" layout-align=\"start\">\n<md-input-container class=\"md-block\" md-no-float flex><label translate=\"FE_FIRST_NAME\"></label><input name=\"firstName\" \nng-model=\"vm.publisher.firstName\" required><div ng-messages=\"registerForm.firstName.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\'FE_FIRST_NAME\' | translate}} {{\'FE_FIELD_IS_REQUIRED\' | translate}}.</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float flex><label translate=\"FE_LAST_NAME\"></label>\n<input name=\"lastName\" ng-model=\"vm.publisher.lastName\" required><div ng-messages=\"registerForm.lastName.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{\'FE_LAST_NAME\' | translate}} {{\'FE_FIELD_IS_REQUIRED\' | translate}}.\n</span></div></div></md-input-container></div><md-input-container class=\"md-block\" md-no-float flex><label \ntranslate=\"FE_EMAIL\"></label><input type=\"email\" name=\"email\" ng-model=\"vm.publisher.email\" minlength=\"7\" \nmaxlength=\"100\" ng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"registerForm.email.$error\"><div \nng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\">{{\'FE_EMAIL_ERROR\' | translate}}</div></div>\n</md-input-container><div layout=\"row\" layout-align=\"start\"><md-input-container class=\"md-block\" md-no-float flex>\n<label translate=\"FE_PASSWORD\"></label><input type=\"password\" name=\"password\" ng-model=\"vm.publisher.password\" \nminlength=\"5\" id=\"password\" required><div ng-messages=\"registerForm.password.$error\" role=\"alert\"><div \nng-message-exp=\"[\'required\', \'minlength\']\">{{\'FE_PASSWORD_ERROR\' | translate}}</div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float flex><label translate=\"FE_CONFIRM_PASSWORD\"></label><input \ntype=\"password\" name=\"confirmPassword\" ng-model=\"vm.publisher.confirmPassword\" confirm-password=\"password\" required>\n<div ng-messages=\"registerForm.confirmPassword.$error\" role=\"alert\"><div \nng-message-exp=\"[\'required\', \'pattern\', \'pwmatch\']\">{{\'FE_CONFIRM_PASSWORD_ERROR\' | translate}}</div></div>\n</md-input-container></div><div class=\"terms\" layout=\"row\" layout-align=\"center center\"><md-checkbox name=\"terms\" \nng-model=\"data.cb1\" aria-label=\"I read and accept\" required></md-checkbox><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"start center\"><span translate=\"FE_REGISTER_TERMS_DESCRIPTION\"></span> <a href=\"#\" \nng-click=\"vm.handleTermsClick()\" class=\"md-accent-color\" translate=\"FE_REGISTER_TERMS_AND_CONDITIONS\"></a></div></div>\n<md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine || vm.isSaving\" ng-click=\"vm.handleCreateClick()\" \ntranslate=\"FE_REGISTER_CREATE_ACCOUNT\"></md-button></form><div class=\"login\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"center center\"><span class=\"text\" translate=\"FE_REGISTER_ALREADY_HAVE\"></span> <a class=\"link\" href=\"#\" \nng-click=\"vm.handleLoginClick()\" translate=\"FE_LOGIN\"></a></div></div></div></div></div>");
$templateCache.put("app/main/auth/reset-password/reset-password.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\">\n<md-progress-linear ng-if=\"vm.isSaving\" md-mode=\"indeterminate\"></md-progress-linear><div class=\"p-32\"><div \nclass=\"logo\"><img src=\"/assets/images/logos/symbol.png\" alt=\"adstxtmanager.com\" title=\"adstxtmanager.com\"></div><div \nng-if=\"vm.isError\" class=\"p-16 red-bg white-fg mb-32\" translate=\"FE_RESET_ERROR\"></div><div class=\"title\" \ntranslate=\"FE_RESET_PASSWORD_TITLE\"></div><div ng-if=\"!vm.isValidToken\" class=\"p-16 red-bg white-fg mb-32\" \ntranslate=\"FE_RESET_TOKEN_ERROR\"></div><div ng-if=\"vm.isSuccess\" class=\"p-16 green-bg white-fg mb-32\" \ntranslate=\"FE_RESET_SUCCESS\"></div><form name=\"resetPasswordForm\" novalidate ng-if=\"vm.isValidToken && !vm.isSuccess\">\n<div layout=\"column\"><md-input-container class=\"md-block\" md-no-float><label translate=\"FE_EMAIL\"></label><input \ntype=\"email\" name=\"email\" ng-model=\"vm.publisher.email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"resetPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message-exp=\"[\'required\', \'pattern\']\"><span translate=\"FE_EMAIL_ERROR\"></span></div></div></md-input-container>\n<md-input-container flex><input type=\"password\" name=\"password\" ng-model=\"vm.publisher.password\" \nplaceholder=\"{{\'FE_PASSWORD\' | translate}}\" minlength=\"5\" required><div \nng-messages=\"resetPasswordForm.password.$error\" role=\"alert\"><div ng-message-exp=\"[\'required\', \'minlength\']\">\n{{\'FE_PASSWORD_ERROR\' | translate}}</div></div></md-input-container><md-input-container flex><input type=\"password\" \nname=\"confirmPassword\" ng-model=\"vm.publisher.confirmPassword\" placeholder=\"{{\'FE_CONFIRM_PASSWORD\' | translate}}\" \nng-pattern=\"vm.publisher.password\" required><div ng-messages=\"resetPasswordForm.confirmPassword.$error\" role=\"alert\">\n<div ng-message-exp=\"[\'required\', \'pattern\']\">{{\'FE_CONFIRM_PASSWORD_ERROR\' | translate}}</div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"Reset Password\" \nng-click=\"vm.handleResetClick()\" ng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine\" \ntranslate=\"FE_RESET_PASSWORD\"></md-button></div></form><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a \nclass=\"link\" href=\"#\" ng-click=\"vm.handleBackClick()\" translate=\"FE_GO_TO_LOGIN\"></a></div></div></div></div></div>");
$templateCache.put("app/main/dialogs/loading/loading-dialog.html","<md-dialog id=\"loading-dialog\" class=\"loading-dialog\" aria-label=\"loading dialog\"><md-dialog-content ms-scroll><div \nclass=\"saving-msg\" layout=\"column\" layout-align=\"center start\"><md-subheader class=\"md-no-sticky\"><span>{{vm.message}}\n</span></md-subheader><md-progress-linear class=\"\" md-mode=\"indeterminate\"></md-progress-linear></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialogs/terms/terms-dialog.html","<md-dialog id=\"terms-dialog\" class=\"terms-dialog\" aria-label=\"terms and conditions\"><md-dialog-content ms-scroll><div \nclass=\"md-headline\">Terms and Conditions</div><p>\nEzoic Inc, a Nevada corporation (\"Ads.txt Manager\") provides the website located at adstxtmanager.com (\"adstxtmanager.com\"), all the content under this domain, certain related software, and it\'s services to you subject to the following terms and conditions. By using Ads.txt Manager you agree to be bound be the latest amended versions of this Agreement and Ads.txt Managers\'s Privacy and Security Policy (see \"Modifications\" below).\n</p><div class=\"md-title\">SECTION 1: ACCEPTING THE TERMS</div><p>\nAds.txt Manager optimizes, caches, alters, monetizes, collects data, and serves your website to end users. Services include but are not limited to analytics tools, reporting and optimization tools and services. By using the information, tools, features and functionality located on adstxtmanager.com, through any Ads.txt Manager APIs, or through any software or other websites that interface with adstxtmanager.com or its APIs, (collectively the \"Service\"), you agree to be bound by this Agreement, whether you are a \"Visitor\" (meaning you merely browse the adstxtmanager.com website) or you are a \"Member\" (meaning you have registered with Ads.txt Manager). The term \"you\" or \"User\" refers to a Visitor or a Member. If you wish to become a Member and make use of the Service you must read this Agreement and indicate your acceptance during the Registration process. If you accept this Agreement, you represent that you have the capacity to be bound by it or, if you are acting on behalf of a company or entity, that you have the authority to bind such entity.\n</p><div class=\"md-title\">SECTION 2: COPYRIGHTS</div><p>\nAll content included on adstxtmanager.com, such as text, graphics, logos, button icons, images, audio clips, digital downloads, data compilations, and software, as well as the compilation of that content into one, coherent website, is the property of Ads.txt Manager and protected by United States and international copyright laws. Reproduction of the content of adstxtmanager.com without the written permission of Ads.txt Manager is prohibited.\n</p></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.handleCloseClick()\">Close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/directives/mobile-date-picker/mobile-date-picker.html","<div layout=\"row\" layout-align=\"space-around center\" class=\"mv-15\"><md-datepicker ng-model=\"vm.mobileDates.baseStart\" \nmd-hide-icons=\"calendar\" md-open-on-focus md-max-date=\"vm.mobileDates.maxDate\" \nng-change=\"vm.validateMobileDates(); vm.setMobileReportDates();\" md-placeholder=\"Enter date\"></md-datepicker>\n<md-datepicker ng-model=\"vm.mobileDates.baseEnd\" md-hide-icons=\"calendar\" md-open-on-focus \nmd-max-date=\"vm.mobileDates.maxDate\" ng-change=\"vm.validateMobileDates(); vm.setMobileReportDates();\" \nmd-placeholder=\"Enter date\"></md-datepicker></div><div layout=\"row\" layout-align=\"center\" class=\"mv-15\"><md-checkbox \nng-model=\"vm.mobileDates.compareChecked\" ng-change=\"vm.compare()\" aria-label=\"Compare\">Compare</md-checkbox></div><div \nlayout=\"row\" ng-if=\"vm.mobileDates.compareChecked\" layout-align=\"space-around center\" class=\"mv-15\"><md-datepicker \nng-model=\"vm.mobileDates.compareStart\" md-hide-icons=\"calendar\" md-open-on-focus md-max-date=\"vm.mobileDates.maxDate\" \nng-change=\"vm.validateMobileDates(); vm.setMobileReportDates();\" md-placeholder=\"Enter date\"></md-datepicker>\n<md-datepicker ng-model=\"vm.mobileDates.compareEnd\" md-hide-icons=\"calendar\" md-open-on-focus \nmd-max-date=\"vm.mobileDates.maxDate\" ng-change=\"vm.validateMobileDates(); vm.setMobileReportDates();\" \nmd-placeholder=\"Enter date\"></md-datepicker></div>");
$templateCache.put("app/main/directives/range-date-picker/range-date-picker.html","<md-menu md-offset=\"0 30\"><span class=\"md-select-value\" \nng-click=\"(($mdMenu && $mdMenu.open) ? $mdMenu.open($event) : $mdOpenMenu($event))\"><span ng-bind-html=\"inputDate\">\n</span> <span class=\"md-select-icon\" aria-hidden=\"true\"></span></span><md-menu-content class=\"md-custom-menu-content\" \nstyle=\"max-height: none!important; height: auto!important; padding: 0!important\"><div class=\"ez-date-picker\"><div \nid=\"dateCardContainer\" class=\"cardContainer\"><div class=\"calendarContainer\"><div layout=\"row\"><div flex=\"72\" \nid=\"datepicker-calendar\"></div><div flex=\"28\" class=\"side\" layout=\"column\"><div class=\"side-title side-padding\" \ntranslate=\"SFE_PICK_TIME_PERIOD\"></div><div class=\"selectContainer side-padding\" id=\"baseSelect\"><select><option \nng-repeat=\"option in baseRanges\" value=\"{{option.id}}\" ng-selected=\"currentBaseOption == option.id\">\n{{option.translate | translate}}</option></select></div><div class=\"toFrom side-padding\" layout=\"row\"><input \ntype=\"text\" class=\"baseRange\" flex=\"1\" id=\"inputBaseStartDate\" placeholder=\"MM/DD/YYYY\"> <input type=\"text\" \nclass=\"baseRange\" flex=\"1\" id=\"inputBaseEndDate\" placeholder=\"MM/DD/YYYY\"></div><div id=\"compareRange\" \nclass=\"side-padding\"><input class=\"inputCheckbox\" id=\"inputCompareCheckbox\" type=\"checkbox\" value=\"0\"> <span \ntranslate=\"COMMON_COMPARE\"></span></div><div class=\"selectContainer side-padding\" id=\"compareSelect\"><select><option \nvalue=\"0\" translate=\"COMMON_PREVIOUS_PERIOD\"></option><option value=\"1\" translate=\"COMMON_PREVIOUS_WEEK\"></option>\n<option value=\"2\" translate=\"COMMON_PREVIOUS_YEAR\"></option><option value=\"3\" translate=\"COMMON_CUSTOM\"></option>\n</select></div><div id=\"compareGroup\" class=\"toFrom side-padding\" layout=\"row\"><input type=\"text\" \nclass=\"inputDate compareRange\" id=\"inputCompareStartDate\" placeholder=\"MM/DD/YYYY\"> <input type=\"text\" \nclass=\"inputDate compareRange\" id=\"inputCompareEndDate\" placeholder=\"MM/DD/YYYY\"></div><div \nclass=\"buttons-row side-padding\"><md-button id=\"cancelDates\" \nclass=\"md-raised md-button md-default-theme md-ink-ripple\" md-prevent-menu-close=\"md-prevent-menu-close\">\n{{ \'COMMON_RESET\' | translate }}</md-button><md-button id=\"applyDates\" \nclass=\"md-raised md-primary md-button md-default-theme md-ink-ripple\">{{ \'COMMON_APPLY\' | translate }}</md-button>\n</div></div></div></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/main/errors/404/error-404.html","<div id=\"error-404\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\">404</div><div class=\"message\" translate=\"FE_ERROR_404_TITLE\">\n</div><br><br><a class=\"back-link md-accent-color\" href=\"#\" ng-click=\"vm.goBack()\" translate=\"FE_ERROR_404_LINK\"></a>\n</div></div>");
$templateCache.put("app/main/errors/500/error-500.html","<div id=\"maintenance\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"maintenance-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"maintenance-form\" class=\"md-whiteframe-8dp\"><h1>{{vm.error.code}}\n</h1><div class=\"title\" translate=\"FE_ERROR_500_TITLE\"></div><div class=\"subtitle\" translate=\"FE_ERROR_500_SUBTITLE\">\n</div><div><a class=\"report-link md-accent-color\" href=\"#\" ng-click=\"vm.goBack()\" translate=\"FE_ERROR_500_LINK\"></a>\n</div></div></div></div>");
$templateCache.put("app/main/errors/503/error-503.html","<div id=\"error-503\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\">503</div><div class=\"message\" translate=\"FE_ERROR_500_TITLE\">\n</div><div class=\"subtitle\" translate=\"FE_ERROR_503_SUBTITLE\"></div><br><a class=\"back-link md-accent-color\" href=\"#\" \nng-click=\"vm.goBack()\" translate=\"FE_ERROR_503_LINK\"></a></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\" class=\"md-grey-900-bg\" flex=\"100\"><ms-navigation-horizontal>\n</ms-navigation-horizontal></div>");
$templateCache.put("app/quick-panel/tabs/help/help-tab.html","<div class=\"md-toolbar-tools md-toolbar-tools-bottom\"><div class=\"search-wrapper md-whiteframe-1dp\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input flex type=\"text\" \nplaceholder=\"{{\'FE_SEARCH_HELP_PLACEHOLDER\' | translate}}\" ng-keypress=\"vm.search($event)\"></div></div></div><md-list \nclass=\"date\"><md-subheader class=\"md-no-sticky\"><span class=\"toupper\" translate=\"FE_HELP\"></span></md-subheader>\n<md-list-item class=\"md-display-1 md-line\"><div class=\"secondary-text\"><div>{{vm.helpList.title}}</div></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"help-list\"><md-subheader ng-if=\"vm.isLoading\" \nclass=\"md-no-sticky pb-16\"><span translate=\"FE_LOADING\"></span></md-subheader><md-progress-linear ng-if=\"vm.isLoading\" \nclass=\"ph-16\" md-mode=\"indeterminate\"></md-progress-linear><md-subheader ng-if=\"!vm.isLoading\" class=\"md-no-sticky\">\n<span>{{vm.helpList.list.length}} <span translate=\"FE_ARTICLES\"></span></span></md-subheader><md-list-item \nng-if=\"!vm.isLoading\" class=\"md-2-line\" ng-repeat=\"helpItem in vm.helpList.list\" \nng-click=\"vm.handleHelpClick(helpItem)\"><div class=\"md-list-item-text\"><div layout=\"row\"><md-icon \nng-if=\"helpItem.isImportant\" md-font-icon=\"icon-label\" class=\"icon s16\"></md-icon><p>\n{{helpItem.categoryTitle}} > {{helpItem.sectionTitle}}</p></div><h3>{{helpItem.title}}</h3></div></md-list-item>\n</md-list><md-button class=\"md-fab help-button md-accent\" ng-click=\"vm.gotoHelpCenter()\" \naria-label=\"help center button\"><md-icon md-font-icon=\"icon-hospital-building\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\'FE_VISIT_HELP_CENTER_TOOLTIP\' | translate}}</md-tooltip></md-button>");
$templateCache.put("app/quick-panel/tabs/sites/sites-tab.html","<div ng-hide=\"ctrlQuickPanel.publisher.domainList.list.length <= 1\" class=\"md-toolbar-tools md-toolbar-tools-bottom\">\n<div class=\"search-wrapper md-whiteframe-1dp\" layout=\"row\" layout-align=\"start center\" flex><div class=\"search\" flex \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input flex \nng-model=\"vm.siteSearch\" type=\"text\" placeholder=\"{{\'FE_SEARCH_PLACEHOLDER\' | translate}}\"></div></div></div><md-list \nclass=\"sites-list scrollable\" ms-scroll><md-subheader class=\"md-no-sticky md-white-bg\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"list-title\" layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"FE_SITES\"></span> <span ng-if=\"ctrlQuickPanel.publisher.domainList.list.length\" \nclass=\"secondary-text contacts-count\">({{ctrlQuickPanel.publisher.domainList.list.length}})</span></div><div flex>\n</div><md-menu><md-button class=\"md-icon-button\" aria-label=\"Sort\"><md-icon md-font-icon=\"icon-sort-alphabetical\" \nng-click=\"$mdMenu.open($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.listOrderAsc = false\" aria-label=\"Sort ASC\" ng-style=\"vm.listOrderAsc === false && {\'font-weight\':\'500\'}\">\n<span translate=\"FE_SITE_NAME\"></span> <small translate=\"FE_LIST_SEARCH_ASC\"></small></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.listOrderAsc = true\" aria-label=\"Sort DESC\" \nng-style=\"vm.listOrderAsc === true && {\'font-weight\':\'500\'}\"><span translate=\"FE_SITE_NAME\"></span> <small \ntranslate=\"FE_LIST_SEARCH_DESC\"></small></md-button></md-menu-item></md-menu-content></md-menu></div></md-subheader>\n<md-radio-group ng-model=\"ctrlQuickPanel.publisher.selectedDomainId\"><md-list-item class=\"site-item md-white-bg\" \nmd-ink-ripple \nng-repeat=\"domain in ctrlQuickPanel.publisher.domainList.list | filter: {domain: vm.siteSearch} | orderBy:\'domain\' :vm.listOrderAsc as filteredSites track by domain.domainId\" \nng-click=\"ctrlQuickPanel.publisher.selectedDomainId = domain.domainId\"><md-radio-button value=\"{{domain.domainId}}\" \nclass=\"md-primary\" aria-label=\"{{domain.domain}}\"></md-radio-button><p class=\"text-truncate\">{{domain.domain}}</p>\n<md-button class=\"md-icon-button\" aria-label=\"more\" translate translate-attr-aria-label=\"remove {{ domain.domain }}\" \nng-hide=\"ctrlQuickPanel.publisher.domainList.list.length === 1\" \nng-click=\"ctrlQuickPanel.handleRemoveSiteClick(domain)\"><md-icon md-font-icon=\"icon-cancel\" class=\"s20\"></md-icon>\n<md-tooltip md-direction=\"bottom\" md-delay=\"500\">{{ \'FE_REMOVE_SITE\' | translate }}</md-tooltip></md-button>\n</md-list-item><md-list-item class=\"add-site-item site-item md-white-bg\" md-ink-ripple \nng-click=\"ctrlQuickPanel.handleAddSiteClick()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><p class=\"text-truncate\">\n{{\'FE_ADD_SITE\' | translate | uppercase}}</p></md-list-item></md-radio-group></md-list><md-button \nclass=\"md-fab add-site-button md-accent\" ng-click=\"ctrlQuickPanel.handleAddSiteClick()\" aria-label=\"add site\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"left\">{{\'FE_ADD_SITE\' | translate}}</md-tooltip>\n</md-button>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list><md-subheader class=\"md-no-sticky\"><span translate=\"FE_QUICK_SETTINGS\"></span></md-subheader><md-list-item><h3\n translate=\"FE_ENABLE_ADS_TXT\"></h3><md-switch class=\"md-secondary\" \nng-model=\"ctrlQuickPanel.selectedDomain.isAdsTxtEnabled\" ng-true-value=\"1\" ng-false-value=\"0\" \naria-label=\"FE_ENABLE_ADS_TXT\" translate ng-change=\"ctrlQuickPanel.handleAdsTxtToggle()\"></md-switch></md-list-item>\n</md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky pb-15\"><span translate=\"FE_LANGUAGE\">\n</span></md-subheader><md-list-item><md-radio-group ng-model=\"ctrlQuickPanel.selectedLanguage.code\"><md-radio-button \nvalue=\"{{language.code}}\" ng-repeat=\"language in ctrlQuickPanel.languages\" \nng-click=\"ctrlQuickPanel.changeLanguage(language)\">{{language.translation | translate}}</md-radio-button>\n</md-radio-group></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"FE_ACCOUNT_ID\"></span></md-subheader><md-list-item><h3>{{ctrlQuickPanel.publisher.publisherId}}</h3>\n</md-list-item></md-list><md-divider></md-divider>");
$templateCache.put("app/toolbar/directives/site-selection/site-selection.html","<div id=\"site-selections\" ng-click=\"vm.handleSelectionsClick()\"><md-button md-no-ink>\n{{vm.publisher.getSelectedDomainName()}}</md-button><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\" hide-xs><img src=\"/assets/images/logos/adstxtmanager-dark.png\" hide-xs \nalt=\"adstxtmanager.com\" title=\"adstxtmanager.com\"> <img src=\"/assets/images/logos/symbol.png\" hide-gt-xs \nalt=\"adstxtmanager.com\" title=\"adstxtmanager.com\"></div><div class=\"toolbar-separator\" hide-xs></div><site-selection \npublisher=\"vm.publisher\" quick-panel=\"vm.quickPanel\" hide-xs></site-selection><div class=\"toolbar-separator\" hide-xs>\n</div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular><md-menu-bar \nid=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"username\" hide-xs>\n{{vm.publisher.firstName | capitalize}} {{vm.publisher.lastName | capitalize}}</span> <span class=\"username\" \nhide-gt-xs translate=\"FE_ACCOUNT\"></span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon>\n</div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ng-click=\"vm.handleProfileClick()\">\n<md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button aria-label=\"profile settings\" \ntranslate=\"FE_NAV_PROFILE\"></md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item \nclass=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button aria-label=\"logout\" \nng-click=\"vm.logout()\" translate=\"FE_NAV_LOGOUT\"></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar>\n<div class=\"toolbar-separator\" hide-xs></div><md-button hide-xs id=\"help-toggle\" class=\"md-icon-button\" \nng-click=\"vm.handleHelpClick()\" aria-label=\"Toggle quick panel\"><md-icon md-font-icon=\"icon-help-circle\" class=\"icon\">\n</md-icon></md-button><div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.quickPanel.toggle()\" aria-label=\"Toggle quick panel\"><md-icon md-font-icon=\"icon-format-list-bulleted\" \nclass=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <a class=\"ms-navigation-horizontal-button md-grey-900-bg\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-grey-800-bg md-accent-fg\"\n           ng-class=\"{\'active md-grey-900-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\" layout=\"row\" layout-align=\"start center\">\n            <md-icon md-font-icon=\"{{node.icon}}\" class=\"mr-8 menu-top white-fg s18\"></md-icon>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n        </a>\n\n    </div>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/apps/directives/bulk-upload/bulk-upload.html","<bulk-upload-form domain-entry-list=\"domainEntryList\" authorized-seller-list=\"authorizedSellerList\" \ncallback-errors=\"callbackErrors\" callback-duplicate-errors=\"callbackDuplicateErrors\" \nauthorized-seller=\"authorizedSeller\" type=\"\'new\'\"></bulk-upload-form><div bulk-upload-button \nclass=\"bulk-upload-button\"><span translate=\"FE_PLACEHOLDER_BULK_UPLOAD_BUTTON\"></span></div>");
$templateCache.put("app/main/apps/directives/bulk-upload-form/bulk-upload-form.html","<form ng-submit=\"BulkUploadForm.submit()\"><md-input-container md-no-float ng-if=\"!BulkUploadForm.isSaving\"><textarea \ntype=\"text\" class=\"note-description-textarea\" \nplaceholder=\"{{ \'FE_PLACEHOLDER_BULK_UPLOAD\' | translate }}&#10;&#10;adsense.com, 123456, DIRECT&#10;adsense.com, 654321, RESELLER, abcdefghi\" \nng-model=\"BulkUploadForm.form.description\">\n    </textarea></md-input-container><div ng-if=\"BulkUploadForm.isSaving\" \nlayout=\"column\" class=\"ph-8 pv-16\"><span class=\"pb-16 pt-8\" translate=\"FE_SAVING\"></span><md-progress-linear \nmd-mode=\"indeterminate\"></md-progress-linear></div><div class=\"footer\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"space-between center\" layout=\"column\" layout-align=\"center center\"><div layout=\"row\" \nlayout-align=\"end center\"><md-button type=\"submit\" class=\"md-raised md-accent mr-15\" \nng-disabled=\"BulkUploadForm.isNotValid()\">{{ \'FE_UPLOAD\' | translate }}</md-button></div></div></form>");
$templateCache.put("app/main/apps/directives/manual-entries/manual-entries.html","<div id=\"manual-entries-directive\" class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap ng-cloak><ms-widget \nflippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div layout=\"row\" \nclass=\"p-16 md-accent-bg entry-header\" layout-align=\"space-between center\"><div layout=\"row\"><md-icon \nmd-font-icon=\"icon-library-books\" class=\"white-fg m-0 mr-16\"></md-icon><div class=\"h2\"><span \nng-if=\"vm.authorizedSeller.sellerId != 0\">{{vm.authorizedSeller.sellerName}}:</span>\n {{ \'FE_MANUAL_ENTRIES\' | translate }}</div></div><div layout=\"row\" hide-xs><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input \nid=\"manual-entries-search\" class=\"search-input\" type=\"text\" placeholder=\"{{ \'FE_SEARCH\' | translate }}\" translate \ntranslate-attr-placeholder=\"FE_SEARCH\" flex></div></div></div><div layout=\"row\" class=\"md-accent-bg md-hue-3 ph-8\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.handleReassignClick()\"><md-icon md-font-icon=\"icon-folder-move\" \nclass=\"white-fg\"></md-icon><md-tooltip>{{ \'FE_REASSIGN_ENTRIES\' | translate }}</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.handleDeleteClick()\"><md-icon md-font-icon=\"icon-trash\" class=\"white-fg\"></md-icon>\n<md-tooltip>{{ \'FE_DELETE_SELECTED_ENTRIES\' | translate }}</md-tooltip></md-button></div><div class=\"table-box\"><table \nclass=\"dataTable row-border hover entries\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr class=\"md-grey-100-bg\">\n<th><md-checkbox ng-model=\"vm.selectAll\" class=\"m-0\" aria-label=\"select all / select none\" \nng-click=\"vm.checkBoxToggleAll()\"></md-checkbox></th><th class=\"black-fg\" translate=\"FE_COLUMN_AD_NETWORK_DOMAIN\"></th>\n<th class=\"black-fg\" translate=\"FE_COLUMN_AD_NETWORK_ACCOUNT_ID\"></th><th class=\"black-fg\" \ntranslate=\"FE_COLUMN_ACCOUNT_TYPE\"></th><th class=\"black-fg\" translate=\"FE_COLUMN_CERTIFICATION_AUTHORITY_ID\"></th><th>\n</th></tr></thead><tbody><tr ng-class=\"{\'edit\': entry.isEditing}\" ng-form name=\"editForm{{entry.domainEntryId}}\" \nng-repeat=\"entry in vm.domainEntryList.list\"><td><md-checkbox ng-if=\"!entry.isEditing\" class=\"m-0\" \nng-model=\"entry.isSelected\" ng-true-value=\"true\" ng-false-value=\"false\" data-entry=\"{{ entry.domainEntryId }}\" \naria-label=\"select entry\"></md-checkbox></td><td><span ng-if=\"!entry.isEditing\">{{ entry.advertisingSystemDomain }}\n</span> <span ng-if=\"entry.isEditing\"><md-input-container><input type=\"text\" ng-model=\"entry.advertisingSystemDomain\" \nplaceholder=\"{{ \'FE_COLUMN_AD_NETWORK_DOMAIN\' | translate }}\" required></md-input-container></span></td><td><span \nng-if=\"!entry.isEditing\">{{ entry.sellerAccountId }}</span> <span ng-if=\"entry.isEditing\"><md-input-container><input \ntype=\"text\" ng-model=\"entry.sellerAccountId\" placeholder=\"{{ \'FE_COLUMN_AD_NETWORK_ACCOUNT_ID\' | translate }}\" \nrequired></md-input-container></span></td><td><span ng-if=\"!entry.isEditing\">{{ entry.accountType }}</span> <span \nng-if=\"entry.isEditing\"><md-select ng-model=\"entry.accountType\" class=\"md-no-underline\" aria-label=\"account type\">\n<md-option value=\"DIRECT\">{{ \'FE_DIRECT\' | translate | uppercase }}</md-option><md-option value=\"RESELLER\">\n{{ \'FE_RESELLER\' | translate | uppercase }}</md-option></md-select></span></td><td><span ng-if=\"!entry.isEditing\">\n{{ entry.certificationAuthorityId }}</span> <span ng-if=\"entry.isEditing\"><md-input-container><input type=\"text\" \nng-model=\"entry.certificationAuthorityId\" placeholder=\"{{ \'FE_COLUMN_CERTIFICATION_AUTHORITY_ID\' | translate }}\">\n</md-input-container></span></td><td class=\"text-right\"><md-button ng-if=\"!entry.isEditing\" aria-label=\"label\" \nclass=\"md-icon-button\" md-no-ink ng-click=\"entry.isEditing = true\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18\">\n</md-icon><md-tooltip>{{ \'FE_EDIT_ENTRY\' | translate }}</md-tooltip></md-button><md-button ng-if=\"entry.isEditing\" \naria-label=\"label\" class=\"md-icon-button\" md-no-ink ng-disabled=\"!editForm{{entry.domainEntryId}}.$valid\" \nng-click=\"vm.handleSaveClick(entry)\"><md-icon class=\"s18 md-accent\" md-font-icon=\"icon-content-save\"></md-icon>\n<md-tooltip>{{ \'FE_EDIT_ENTRY\' | translate }}</md-tooltip></md-button></td></tr></tbody><tfoot><tr \nng-if=\"vm.domainEntryList.list.length == 0\"><td colspan=\"6\"><div class=\"pv-16\" layout=\"column\" \nlayout-align=\"center center\"><span class=\"md-title md-primary-fg\" translate=\"FE_NO_ENTRIES_TITLE\"></span> <span \nclass=\"md-subhead\" translate=\"FE_NO_ENTRIES_SUBTITLE\"></span></div></td></tr><tr class=\"add md-blue-50-bg\" ng-form \nname=\"addForm\"><td><md-icon md-font-icon=\"icon-plus\"></md-icon></td><td><md-input-container><input type=\"text\" \nng-model=\"vm.newEntry.advertisingSystemDomain\" placeholder=\"{{ \'FE_COLUMN_AD_NETWORK_DOMAIN\' | translate }}\" \nclass=\"md-no-float\" required></md-input-container></td><td><md-input-container><input type=\"text\" \nng-model=\"vm.newEntry.sellerAccountId\" placeholder=\"{{ \'FE_COLUMN_AD_NETWORK_ACCOUNT_ID\' | translate }}\" required>\n</md-input-container></td><td><md-select ng-model=\"vm.newEntry.accountType\" class=\"md-no-underline\" \naria-label=\"account type\"><md-option value=\"DIRECT\">{{ \'FE_DIRECT\' | translate | uppercase }}</md-option><md-option \nvalue=\"RESELLER\">{{ \'FE_RESELLER\' | translate | uppercase }}</md-option></md-select></td><td><md-input-container><input\n type=\"text\" ng-model=\"vm.newEntry.certificationAuthorityId\" \nplaceholder=\"{{ \'FE_COLUMN_CERTIFICATION_AUTHORITY_ID\' | translate }}\"></md-input-container></td><td \nclass=\"text-right\"><md-button aria-label=\"label\" class=\"md-raised md-accent\" ng-disabled=\"!addForm.$valid\" \nng-click=\"vm.handleAddClick()\">{{ \'FE_ADD\' | translate }}</md-button></td></tr></tfoot></table></div></ms-widget-front>\n</ms-widget></div>");
$templateCache.put("app/main/apps/directives/seller-card/seller-card.html","<md-card ng-class=\"{\'md-grey-50-bg\': !vm.seller.isAuthorized}\"><md-card-title><md-card-title-text><span \nclass=\"md-headline\">{{vm.seller.sellerName}}</span> <span class=\"h5 secondary-text\" \nng-if=\"vm.seller.dateAuthorized != \'\'\">{{\'FE_AUTHORIZED_ON\' | translate}} {{vm.seller.dateAuthorized | longDate}}\n</span></md-card-title-text><md-card-title-media><div class=\"md-media-sm card-media\"><img class=\"image\" \nng-src=\"data:{{vm.seller.iconType}};base64,{{vm.seller.icon}}\" alt=\"{{vm.seller.sellerName}}\"></div>\n</md-card-title-media></md-card-title><md-card-actions layout=\"row\" layout-align=\"end end\"><md-button \nng-if=\"vm.seller.sellerUrl != \'\'\" class=\"md-primary\" ng-href=\"{{vm.seller.sellerUrl}}\" target=\"_blank\">\n{{\'FE_VISIT\' | translate}}</md-button><md-button ng-if=\"!vm.seller.isAuthorized\" class=\"md-raised md-accent\" \nng-click=\"vm.handleAuthorizeClick(vm.seller)\">{{\'FE_AUTHORIZE\' | translate}}</md-button><md-button \nng-if=\"vm.seller.isAuthorized && vm.showManage\" class=\"md-primary\" ng-click=\"vm.handleManageClick(vm.seller)\">\n{{\'FE_MANAGE\' | translate}}</md-button><md-button ng-if=\"vm.seller.isAuthorized && vm.showUnauthorize\" \nclass=\"md-primary\" ng-click=\"vm.handleUnauthorizeClick(vm.seller)\">{{\'FE_UNAUTHORIZE\' | translate}}</md-button>\n</md-card-actions></md-card>");
$templateCache.put("app/main/apps/directives/seller-entries/seller-entries.html","<div id=\"seller-entries-directive\" class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap ng-cloak><ms-widget \nflippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div layout=\"row\" \nclass=\"p-16 md-primary-bg entry-header\" layout-align=\"space-between center\"><div layout=\"row\"><md-icon \nmd-font-icon=\"icon-library-books\" class=\"white-fg m-0 mr-16\"></md-icon><div class=\"h2\" hide-gt-xs>\n{{vm.authorizedSeller.sellerName}}</div><div class=\"h2\" hide-xs>\n{{vm.authorizedSeller.sellerName}}: {{ \'FE_ENTRIES\' | translate }}</div></div><div layout=\"row\"><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" hide-xs><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"seller-entries-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"{{ \'FE_SEARCH\' | translate }}\" translate translate-attr-placeholder=\"FE_SEARCH\" flex></div></div></div>\n<div layout=\"row\" class=\"md-primary-bg md-hue-3 ph-8\"><md-button class=\"md-icon-button\" \nng-click=\"vm.handleDisableClick()\"><md-icon md-font-icon=\"icon-checkbox-blank-circle-outline\" class=\"white-fg\">\n</md-icon><md-tooltip>{{ \'FE_DISABLE_ENTRIES\' | translate }}</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.handleEnableClick()\"><md-icon md-font-icon=\"icon-check-circle\" class=\"white-fg\"></md-icon><md-tooltip>\n{{ \'FE_ENABLE_ENTRIES\' | translate }}</md-tooltip></md-button></div><div class=\"table-box\"><table \nclass=\"dataTable row-border hover seller-entries\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr \nclass=\"md-grey-100-bg\"><th><md-checkbox ng-model=\"vm.selectAll\" class=\"m-0\" aria-label=\"select all / select none\" \nng-click=\"vm.checkBoxToggleAll()\"></md-checkbox></th><th class=\"black-fg\" translate=\"FE_COLUMN_AD_NETWORK_DOMAIN\"></th>\n<th class=\"black-fg\" translate=\"FE_COLUMN_AD_NETWORK_ACCOUNT_ID\"></th><th class=\"black-fg\" \ntranslate=\"FE_COLUMN_ACCOUNT_TYPE\"></th><th class=\"black-fg\" translate=\"FE_COLUMN_CERTIFICATION_AUTHORITY_ID\"></th><th \nclass=\"black-fg\" translate=\"FE_ENABLED\"></th></tr></thead><tbody><tr ng-repeat=\"entry in vm.sellerEntryList.list\"><td>\n<md-checkbox class=\"m-0\" ng-model=\"entry.isSelected\" ng-true-value=\"true\" ng-false-value=\"false\" \ndata-entry=\"{{entry.sellerEntryId}}\" aria-label=\"select entry\"></md-checkbox></td><td><span>\n{{entry.advertisingSystemDomain}}</span></td><td><span>{{entry.sellerAccountId}}</span></td><td><span>\n{{entry.accountType}}</span></td><td><span>{{entry.certificationAuthorityId}}</span></td><td class=\"text-right\"><span \nng-if=\"entry.isEnabled == 1\" class=\"text-boxed m-0 green-bg white-fg\">{{\'FE_YES\' | translate}}</span> <span \nng-if=\"entry.isEnabled == 0\" class=\"text-boxed m-0 red-bg white-fg\">{{\'FE_NO\' | translate}}</span></td></tr></tbody>\n</table></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/apps/pages/account-settings/account-settings.html","<div id=\"account-settings\" class=\"page-layout\"><div class=\"header small-title md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><span class=\"md-display-1 font-weight-300\" translate=\"FE_ACCOUNT_SETTINGS\"></span></div>\n<div class=\"p-24\" layout=\"row\" flex layout-wrap><div flex=\"60\" flex-xs=\"100\" class=\"pb-16\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"settingsForm\" class=\"md-inline-form\" novalidate><div \nclass=\"form-title\" translate=\"FE_ACCOUNT_ID\"></div><div layout=\"column\" layout-gt-sm=\"row\">{{vm.publisher.publisherId}}\n</div></form></div></div><div flex=\"60\" flex-xs=\"100\" class=\"pb-16\"><div class=\"form-wrapper md-whiteframe-1dp\"><form \nname=\"settingsForm\" class=\"md-inline-form\" novalidate><div class=\"form-title\" translate=\"FE_ACCOUNT_SETTINGS\"></div>\n<div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"email\" \nng-model=\"vm.publisher.email\" placeholder=\"{{\'FE_EMAIL\' | translate}}\" minlength=\"7\" maxlength=\"100\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"settingsForm.email.$error\"><div \nng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\">{{\'FE_EMAIL_ERROR\' | translate}}</div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" \nname=\"firstName\" ng-model=\"vm.publisher.firstName\" placeholder=\"{{\'FE_FIRST_NAME\' | translate}}\" required><div \nng-messages=\"settingsForm.firstName.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'FE_FIRST_NAME\' | translate}} {{\'FE_FIELD_IS_REQUIRED\' | translate}}.</span></div></div></md-input-container>\n<md-input-container flex><input type=\"text\" name=\"lastName\" ng-model=\"vm.publisher.lastName\" \nplaceholder=\"{{\'FE_LAST_NAME\' | translate}}\" required><div ng-messages=\"settingsForm.lastName.$error\" role=\"alert\"><div\n ng-message=\"required\"><span>{{\'FE_LAST_NAME\' | translate}} {{\'FE_FIELD_IS_REQUIRED\' | translate}}.</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" \nname=\"company\" ng-model=\"vm.publisher.company\" placeholder=\"{{\'FE_COMPANY\' | translate}}\"><div \nng-messages=\"settingsForm.company.$error\" role=\"alert\"><div ng-message=\"required\"></div></div></md-input-container>\n</div><div layout=\"row\" layout-xs=\"column\" layout-align=\"space-between\"><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-click=\"vm.handleSaveClick()\" \nng-disabled=\"settingsForm.$invalid || settingsForm.$pristine\">{{\'FE_SAVE\' | translate}}</md-button><md-button \naria-label=\"change password\" ng-click=\"vm.handleChangePasswordClick()\"><md-icon md-font-icon=\"icon-lock\"></md-icon>\n{{\'FE_CHANGE_PASSWORD\' | translate}}</md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/apps/pages/authorized-seller/authorized-seller.html","<div id=\"authorized-seller\" class=\"page-layout\"><div class=\"header small-title md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"md-display-1 font-weight-300\">\n{{vm.authorizedSeller.sellerName | capitalize}} {{\'FE_ENTRIES\' | translate | capitalize}}</span><md-button \nclass=\"md-raised\" ng-click=\"vm.handleUnauthorizeClick()\">{{\'FE_UNAUTHORIZE\' | translate}}</md-button></div><div \nclass=\"red-400-bg white-fg p-16\" ng-if=\"vm.errorList.length > 0\" layout=\"row\" layout-align=\"space-between start\"><div>\n<div layout=\"row\" layout-align=\"start start\" flex><span class=\"mr-16\"><md-icon md-font-icon=\"icon-account-alert\">\n</md-icon></span><span class=\"md-subhead\" translate=\"FE_UPLOAD_ERROR\"></span></div><ol class=\"ml-16\"><li class=\"h4\" \nng-repeat=\"(idx, error) in vm.errorList track by idx\">{{error}}</li></ol></div><md-button class=\"md-icon-button\" \nng-click=\"vm.handleCloseErrorsClick()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"red-300-bg white-fg p-16\" ng-if=\"vm.duplicateList.length > 0\" layout=\"row\" layout-align=\"space-between start\">\n<div><div layout=\"row\" layout-align=\"start start\" flex><span class=\"mr-16\"><md-icon md-font-icon=\"icon-account-alert\">\n</md-icon></span><span class=\"md-subhead\" translate=\"FE_UPLOAD_DUPLICATE_ERROR\"></span></div><ol class=\"ml-16\"><li \nclass=\"h4\" ng-repeat=\"(idx, error) in vm.duplicateList track by idx\">{{error}}</li></ol></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.handleCloseDuplicatesClick()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><div class=\"p-16\" layout=\"column\"><div id=\"bulk-upload\"><bulk-upload \ndomain-entry-list=\"vm.domainEntryList\" authorized-seller-list=\"vm.authorizedSellerList\" \ncallback-errors=\"vm.callbackErrors\" callback-duplicate-errors=\"vm.callbackDuplicateErrors\" \nauthorized-seller=\"vm.authorizedSeller\" class=\"md-whiteframe-2dp\"></bulk-upload></div><seller-entries \nseller-entry-list=\"vm.sellerEntryList\" authorized-seller-list=\"vm.authorizedSellerList\" \nauthorized-seller=\"vm.authorizedSeller\"></seller-entries><manual-entries domain-entry-list=\"vm.domainEntryList\" \nauthorized-seller-list=\"vm.authorizedSellerList\" authorized-seller=\"vm.authorizedSeller\"></manual-entries></div></div>");
$templateCache.put("app/main/apps/pages/get-started/get-started.html","<div id=\"get-started\" class=\"compact page-layout\" layout=\"column\" ms-scroll><div \nclass=\"header small-title md-accent-bg\" layout=\"column\" layout-align=\"center start\"><span \nclass=\"md-display-1 font-weight-300\" translate=\"FE_GET_STARTED_HEADER\"></span></div><div \nclass=\"red-400-bg white-fg p-16\" ng-if=\"vm.errorList.length > 0\" layout=\"row\" layout-align=\"space-between start\"><div>\n<div layout=\"row\" layout-align=\"start start\" flex><span class=\"mr-16\"><md-icon md-font-icon=\"icon-account-alert\">\n</md-icon></span><span class=\"md-subhead\" translate=\"FE_UPLOAD_ERROR\"></span></div><ol class=\"ml-16\"><li class=\"h4\" \nng-repeat=\"(idx, error) in vm.errorList track by idx\">{{error}}</li></ol></div><md-button class=\"md-icon-button\" \nng-click=\"vm.handleCloseErrorsClick()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"red-300-bg white-fg p-16\" ng-if=\"vm.duplicateList.length > 0\" layout=\"row\" layout-align=\"space-between start\">\n<div><div layout=\"row\" layout-align=\"start start\" flex><span class=\"mr-16\"><md-icon md-font-icon=\"icon-account-alert\">\n</md-icon></span><span class=\"md-subhead\" translate=\"FE_UPLOAD_DUPLICATE_ERROR\"></span></div><ol class=\"ml-16\"><li \nclass=\"h4\" ng-repeat=\"(idx, error) in vm.duplicateList track by idx\">{{error}}</li></ol></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.handleCloseDuplicatesClick()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><div layout=\"row\"><ms-form-wizard flex><md-tabs md-selected=\"msWizard.selectedIndex\" \nmd-dynamic-height md-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\">1</span> <span class=\"ms-form-wizard-step-text\" \ntranslate=\"FE_WHAT_IS_ADS_TXT\"></span></span></md-tab-label><md-tab-body><div layout=\"column\" class=\"p-24\"><div flex \nlayout=\"row\" layout-align=\"center\"><div layout=\"column\" flex=\"100\"><p><span \ntranslate=\"FE_GET_STARTED_ADS_TXT_DESCRIPTION_1\"></span><br><br><span translate=\"FE_GET_STARTED_ADS_TXT_DESCRIPTION_2\">\n</span><br><br><span translate=\"FE_GET_STARTED_ADS_TXT_DESCRIPTION_3\"></span><br><span \ntranslate=\"FE_GET_STARTED_ADS_TXT_DESCRIPTION_4\"></span><br><span translate=\"FE_GET_STARTED_ADS_TXT_DESCRIPTION_5\">\n</span></p></div></div></div><span class=\"ml-16\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" \nng-disabled=\"msWizard.isLastStep()\" translate=\"FE_NEXT_BUTTON\"></md-button></span><form name=\"wizardStep1\" \nms-form-wizard-form novalidate></form></md-tab-body></md-tab><md-tab><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\">2</span> <span \nclass=\"ms-form-wizard-step-text\" translate=\"FE_AUTHORIZE\"></span></span></md-tab-label><md-tab-body><div \nlayout=\"column\" class=\"p-24\"><div flex layout=\"row\" layout-align=\"center\"><div layout=\"column\" layout-align=\"center\" \nflex=\"100\"><h1 class=\"md-title\" translate=\"FE_GET_STARTED_AUTHORIZE_OPTION_1_TITLE\"></h1><span class=\"mb-8\" \ntranslate=\"FE_GET_STARTED_AUTHORIZE_OPTION_1_DESCRIPTION\"></span> <span class=\"mt-8\"><md-button \nclass=\"md-raised md-accent m-0\" ng-click=\"msWizard.nextStep()\" ng-disabled=\"msWizard.isLastStep()\" \ntranslate=\"FE_NEXT_BUTTON\"></md-button></span><h1 class=\"md-title mt-32\"></h1><span class=\"mb-8\">\n{{\'FE_SELLERS_SUBHEADER\' | translate}}</span><div layout=\"row\" flex><div class=\"font-size-16 mr-16\" layout=\"column\" \nlayout-align=\"start start\"><md-select ng-model=\"vm.sellerListType\" class=\"md-no-underline\" \naria-label=\"seller list type\"><md-option class=\"md-subhead\" value=\"all\">{{\'FE_ALL_SELLERS\' | translate}}</md-option>\n<md-option class=\"md-subhead\" value=\"authorized\">{{\'FE_AUTHORIZED_SELLERS\' | translate}}</md-option><md-option \nclass=\"md-subhead\" value=\"unauthorized\">{{\'FE_UNAUTHORIZED_SELLERS\' | translate}}</md-option></md-select></div>\n<md-input-container class=\"md-block\" flex><label translate=\"FE_SEARCH_SELLER_PLACEHOLDER\"></label><input \nng-model=\"vm.search\"></md-input-container></div><span class=\"mb-8\" translate=\"FE_GET_STARTED_FEATURED_SELLERS\"></span>\n<div class=\"m-0\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nng-if=\"vm.publisher.isSelectedDomainEzoic() == 1\" class=\"md-card-container\" layout=\"column\" \nng-repeat=\"seller in vm.sellerList.list | filter: vm.filters | filter: { sellerId: \'!0\', isFeatured: \'1\' } | filter: { sellerName: vm.search } | orderBy: [\'sellerName\'] | filter: { sellerName: \'Ezoic\' }\">\n<seller-card seller=\"seller\" authorized-seller-list=\"vm.authorizedSellerList\" show-unauthorize=\"true\"></seller-card>\n</div><div class=\"md-card-container\" layout=\"column\" \nng-repeat=\"seller in vm.sellerList.list | filter: vm.filters | filter: { sellerId: \'!0\', isFeatured: \'1\' } | filter: { sellerName: vm.search } | orderBy: [\'sellerName\'] | filter: vm.publisher.isSelectedDomainEzoic() == 1 ? { sellerName: \'!Ezoic\' } : \'\'\">\n<seller-card seller=\"seller\" authorized-seller-list=\"vm.authorizedSellerList\" show-unauthorize=\"true\"></seller-card>\n</div><div class=\"ph-8 pv-16\" ng-if=\"filteredFeaturedSellerList.length == 0\"><span class=\"md-subhead text-bold\">\n{{\'FE_LIST_NO_RESULTS\' | translate}}</span></div></div><span class=\"mb-8 mt-32\" translate=\"FE_GET_STARTED_ALL_SELLERS\">\n</span><div class=\"m-0\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nng-if=\"vm.publisher.isSelectedDomainEzoic() == 1\" class=\"md-card-container\" layout=\"column\" \nng-repeat=\"seller in vm.sellerList.list | orderBy: \'sellerName\': false | filter: vm.filters | filter: { sellerId: \'!0\'} | filter: { sellerName: \'Ezoic\' } | orderBy: \'sellerName\': false | filter: {sellerName: vm.search} as filteredSellerList\">\n<seller-card seller=\"seller\" authorized-seller-list=\"vm.authorizedSellerList\" show-unauthorize=\"true\"></seller-card>\n</div><div ng-if=\"vm.publisher.isSelectedDomainEzoic() == 1\" class=\"md-card-container\" layout=\"column\" \nng-repeat=\"seller in vm.sellerList.list | orderBy: \'sellerName\': false | filter: vm.filters | filter: { sellerId: \'!0\'} | filter: { sellerName: \'!Ezoic\' } | orderBy: \'sellerName\': false | filter: {sellerName: vm.search} as filteredSellerList\">\n<seller-card seller=\"seller\" authorized-seller-list=\"vm.authorizedSellerList\" show-unauthorize=\"true\"></seller-card>\n</div><div ng-if=\"vm.publisher.isSelectedDomainEzoic() == 0\" class=\"md-card-container\" layout=\"column\" \nng-repeat=\"seller in vm.sellerList.list | orderBy: \'sellerName\': false | filter: vm.filters | filter: { sellerId: \'!0\'} | orderBy: \'sellerName\': false | filter: {sellerName: vm.search} as filteredSellerList\">\n<seller-card seller=\"seller\" authorized-seller-list=\"vm.authorizedSellerList\" show-unauthorize=\"true\"></seller-card>\n</div><div class=\"ph-8 pv-16\" ng-if=\"filteredSellerList.length == 0\"><span class=\"md-subhead text-bold\">\n{{\'FE_LIST_NO_RESULTS\' | translate}}</span></div></div></div></div></div><form name=\"f2\" ms-form-wizard-form \nnovalidate></form></md-tab-body></md-tab><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\">3</span> <span class=\"ms-form-wizard-step-text\" \ntranslate=\"FE_GET_STARTED_IMPORT\"></span></span></md-tab-label><md-tab-body><div layout=\"column\" class=\"p-24\"><div \nflex layout=\"row\" layout-align=\"center\"><div layout=\"column\" layout-align=\"center\" flex=\"100\"><p \ntranslate=\"FE_GET_STARTED_IMPORT_DESCRIPTION\"></p><h1 class=\"md-title\" \ntranslate=\"FE_GET_STARTED_IMPORT_OPTION_1_TITLE\"></h1><span translate=\"FE_GET_STARTED_IMPORT_OPTION_1_DESCRIPTION\">\n</span> <span class=\"mt-8\"><md-button class=\"md-accent md-raised m-0\" ng-click=\"vm.handleImportClick()\" \ntranslate=\"FE_GET_STARTED_IMPORT_BUTTON\"></md-button></span><h1 class=\"md-title mt-32\" \ntranslate=\"FE_GET_STARTED_IMPORT_OPTION_2_TITLE\"></h1><span class=\"mb-8\" \ntranslate=\"FE_GET_STARTED_IMPORT_OPTION_2_DESCRIPTION\"></span><div id=\"bulk-upload\"><bulk-upload \ndomain-entry-list=\"vm.domainEntryList\" authorized-seller-list=\"vm.authorizedSellerList\" \ncallback-errors=\"vm.callbackErrors\" callback-duplicate-errors=\"vm.callbackDuplicateErrors\" class=\"md-whiteframe-2dp\">\n</bulk-upload></div><h1 class=\"md-title mt-32\" translate=\"FE_GET_STARTED_IMPORT_OPTION_3_TITLE\"></h1><span \nclass=\"mb-8\" translate=\"FE_GET_STARTED_IMPORT_OPTION_3_DESCRIPTION\"></span> <span><md-button \nclass=\"md-raised md-accent m-0\" ng-click=\"msWizard.nextStep()\" ng-disabled=\"msWizard.isLastStep()\" \ntranslate=\"FE_NEXT_BUTTON\"></md-button></span></div></div></div><form name=\"wizardStep3\" ms-form-wizard-form \nnovalidate></form></md-tab-body></md-tab><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\">4</span> <span class=\"ms-form-wizard-step-text\" \ntranslate=\"FE_GET_STARTED_REDIRECT\"></span></span></md-tab-label><md-tab-body><div layout=\"column\" class=\"p-24\"><div \nflex layout=\"row\" layout-align=\"center\"><div layout=\"column\" layout-align=\"center\" flex=\"100\"><div \nng-if=\"vm.publisher.isSelectedDomainEzoic() == 1\" style=\"padding-bottom: 64px\"><div layout=\"column\"><p \ntranslate=\"FE_GET_STARTED_REDIRECT_EZOIC_DOMAIN_1\"></p><p translate=\"FE_GET_STARTED_REDIRECT_EZOIC_DOMAIN_2\"></p></div>\n<ms-widget class=\"h-140\" style=\"padding:16px 0\" layout=\"column\" flex=\"100\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"p-16 white-bg\" layout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"row\" layout-align=\"space-between center\" flex>\n<div class=\"pl-8\" layout=\"column\" layout-align=\"center start\"><span class=\"font-weight-500 secondary-text\">\n{{\"Account Id\" | uppercase}}</span> <span class=\"md-display-1 pb-8\">{{vm.publisher.publisherId}}</span></div></div>\n</ms-widget-front></ms-widget><span class=\"mt-16\"><md-button class=\"md-raised md-accent m-0\" \nng-click=\"msWizard.nextStep()\" ng-disabled=\"msWizard.isLastStep()\" translate=\"FE_NEXT_BUTTON\"></md-button></span></div>\n<div ng-if=\"vm.publisher.isSelectedDomainEzoic() == 1\"><md-button class=\"mt-16 mb-16 ml-0 mr-0\" \nng-click=\"vm.toggleSelected = !vm.toggleSelected\"><md-icon ng-if=\"vm.toggleSelected\" md-font-icon=\"icon-plus\" \nclass=\"icon\"></md-icon><md-icon ng-if=\"!vm.toggleSelected\" md-font-icon=\"icon-minus\" class=\"icon\"></md-icon><span \ntranslate=\"FE_GET_STARTED_REDIRECT_ADDITIONAL\"></span></md-button></div><div \nng-hide=\"vm.toggleSelected && vm.publisher.isSelectedDomainEzoic() == 1\"><div><span \ntranslate=\"FE_GET_STARTED_REDIRECT_DESCRIPTION\"></span><br><br><span \ntranslate=\"FE_GET_STARTED_REDIRECT_STEPS_DESCRIPTION\"></span></div><ol><li><span \ntranslate=\"FE_GET_STARTED_REDIRECT_STEPS_1\"></span> <code><span translate=\"FE_GET_STARTED_REDIRECT_STEPS_1_CODE\">\n</span> https://srv.adstxtmanager.com/{{vm.publisher.publisherId}}/{{vm.publisher.getSelectedDomainName()}}</code></li>\n<li><span translate=\"FE_GET_STARTED_REDIRECT_STEPS_2\"></span> <code><span \ntranslate=\"FE_GET_STARTED_REDIRECT_STEPS_2_CODE\"></span> <a href=\"https://wordpress.org/plugins/ads-txt-manager/\" \ntarget=\"_blank\" class=\"md-accent-color\">https://wordpress.org/plugins/ads-txt-manager/</a></code></li><li><span \ntranslate=\"FE_GET_STARTED_REDIRECT_STEPS_3\"></span> <code>server {<br>&nbsp;&nbsp;location ~ /ads.txt {<br>\n&nbsp;&nbsp;&nbsp;&nbsp;return 301 https://srv.adstxtmanager.com/{{vm.publisher.publisherId}}/{{vm.publisher.getSelectedDomainName()}};\n<br>&nbsp;&nbsp;}<br>}</code></li><li><span translate=\"FE_GET_STARTED_REDIRECT_STEPS_4\"></span> <code>&lt;?php<br>\n&nbsp;&nbsp;header(\'Location: https://srv.adstxtmanager.com/{{vm.publisher.publisherId}}/{{vm.publisher.getSelectedDomainName()}}\');\n<br>&nbsp;&nbsp;exit;<br>?></code></li></ol><div layout=\"column\" layout-align=\"center\" class=\"mb-16\"><span \ntranslate=\"FE_GET_STARTED_REDIRECT_HELP\"></span> <a \nhref=\"https://support.ezoic.com/kb/article/everything-you-need-to-know-about-adstxt\" target=\"_blank\" \nclass=\"md-accent-color\" translate=\"FE_CLICK_HERE\"></a></div><span class=\"mt-16\" \nng-if=\"vm.publisher.isSelectedDomainEzoic() != 1\"><md-button class=\"md-raised md-accent m-0\" \nng-click=\"msWizard.nextStep()\" ng-disabled=\"msWizard.isLastStep()\" translate=\"FE_NEXT_BUTTON\"></md-button></span></div>\n</div></div></div><form name=\"wizardStep4\" ms-form-wizard-form novalidate></form></md-tab-body></md-tab><md-tab>\n<md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\">5</span> \n<span class=\"ms-form-wizard-step-text\" translate=\"FE_GET_STARTED_VALIDATE\"></span></span></md-tab-label><md-tab-body>\n<div layout=\"column\" class=\"p-16\"><div flex layout=\"row\" layout-align=\"center\"><div layout=\"column\" \nlayout-align=\"center\" flex=\"100\" flex-lg=\"60\" flex-xl=\"50\"><div ng-if=\"vm.publisher.isSelectedDomainEzoic() == 1\"><p>\nIf you are integrating your Ads.txt file with Ezoic, make sure you have added your Account ID into Ezoic\'s Ads.txt app and toggle Ads.txt Manager on in Ezoic. Note: It may take up to 30 minutes for your ads.txt file to be integrated.\n</p></div><p translate=\"FE_GET_STARTED_VALIDATE_DESCRIPTION\"></p><ms-widget class=\"h-140\" style=\"padding:16px 0\" \nlayout=\"column\" flex=\"100\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex><div \nclass=\"pt-8 pb-8\" layout=\"row\" layout-align=\"space-between center\" flex><div class=\"pl-8\" layout=\"column\" \nlayout-align=\"center start\"><span class=\"font-weight-500 secondary-text\">\n{{\"Your ads.txt file is currently\" | uppercase}}</span> <span class=\"md-display-1 pb-8\">\n{{vm.selectedDomain.isIntegrated ? \'FE_INTEGRATED\' : \'FE_NOT_INTEGRATED\' | translate | uppercase}}</span></div><div>\n<md-icon md-font-icon=\"icon-thumb-up\" ng-if=\"vm.selectedDomain.isIntegrated\" class=\"s48 green-500-fg hint-text\">\n</md-icon><md-icon md-font-icon=\"icon-thumb-down\" ng-if=\"!vm.selectedDomain.isIntegrated\" \nclass=\"s48 red-500-fg hint-text\"></md-icon></div></div></ms-widget-front></ms-widget><p layout=\"row\" \nlayout-align=\"center\" translate=\"FE_GET_STARTED_VALIDATE_REVALIDATE_DESCRIPTION\"></p><span layout=\"row\" \nlayout-align=\"center\" class=\"mb-16\"><md-button class=\"md-raised md-accent m-0\" ng-click=\"vm.handleIntegrationClick()\" \ntranslate=\"FE_GET_STARTED_VALIDATE_REVALIDATE_BUTTON\"></md-button></span></div></div></div><form name=\"wizardStep5\" \nms-form-wizard-form novalidate></form></md-tab-body></md-tab></md-tabs></ms-form-wizard></div></div>");
$templateCache.put("app/main/apps/pages/home/home.html","<div id=\"home\" class=\"page-layout\"><div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"center start\"><span \nclass=\"md-display-1 font-weight-300\">{{\'FE_WELCOME\' | translate}}, {{vm.publisher.firstName}}!</span></div><div \nclass=\"widgets-box\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget id=\"widget-integrated\" \nflippable=\"false\" layout=\"column\" class=\"h-160\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"p-16 white-bg\" layout=\"row\" flex ng-click=\"vm.handleIntegrationClick()\"><div class=\"pv-8\" layout=\"row\" \nlayout-align=\"space-between center\" flex><div class=\"pl-8\" layout=\"column\" layout-align=\"center start\"><div \nlayout=\"row\"><div class=\"font-weight-500 secondary-text\">\n{{\'FE_ADS_TXT_STATUS\' | translate | uppercase}} ({{vm.selectedDomain.lastIntegrationCheck == \'\' ? \'FE_NEVER_CHECKED\' : \'FE_LAST_CHECKED\' | translate}} \n<span ng-if=\"vm.selectedDomain.lastIntegrationCheck != \'\'\">{{vm.selectedDomain.lastIntegrationCheck | longTime}})\n</span><md-icon class=\"ml-8\" md-font-icon=\"icon-refresh s16\"></md-icon></div></div><span \nclass=\"md-display-1 font-size-24 pt-8\">\n{{ vm.selectedDomain.isIntegrated ? \'FE_INTEGRATED\' : \'FE_NOT_INTEGRATED\' | translate | uppercase}}</span></div><div>\n<md-icon md-font-icon=\"icon-thumb-up\" ng-if=\"vm.selectedDomain.isIntegrated\" class=\"s48 green-500-fg hint-text\">\n</md-icon><md-icon md-font-icon=\"icon-thumb-down\" ng-if=\"!vm.selectedDomain.isIntegrated\" \nclass=\"s48 red-500-fg hint-text\"></md-icon></div></div><md-tooltip>{{\'FE_RECHECK_STATUS\' | translate}}</md-tooltip>\n</ms-widget-front></ms-widget><ms-widget id=\"widget-display\" flippable=\"false\" layout=\"column\" class=\"h-160\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex \nng-click=\"vm.handleDisplayClick()\"><div class=\"pv-8\" layout=\"row\" layout-align=\"space-between center\" flex><div \nclass=\"pl-8\" layout=\"column\" layout-align=\"center start\"><div layout=\"row\"><div class=\"font-weight-500 secondary-text\">\n{{\'FE_DISPLAY_ADS_TXT\' | translate | uppercase}}</div></div><span class=\"md-display-1 font-size-24 pt-8\">\n{{ vm.selectedDomain.isAdsTxtEnabled ? \'FE_YES\' : \'FE_NO\' | translate | uppercase}}</span></div><div><md-icon \nmd-font-icon=\"icon-thumb-up\" ng-if=\"vm.selectedDomain.isAdsTxtEnabled\" class=\"s48 green-500-fg hint-text\"></md-icon>\n<md-icon md-font-icon=\"icon-thumb-down\" ng-if=\"!vm.selectedDomain.isAdsTxtEnabled\" class=\"s48 red-500-fg hint-text\">\n</md-icon></div></div><md-tooltip>{{\'FE_TOGGLE_DISPLAY\' | translate}}</md-tooltip></ms-widget-front></ms-widget>\n<ms-widget id=\"widget-get-started\" flippable=\"false\" layout=\"column\" class=\"h-160\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex ng-click=\"vm.handleGetStartedClick()\"><div \nlayout=\"column\" layout-align=\"center center\" flex><div class=\"md-display-1 pb-8\" translate=\"FE_GET_STARTED\"></div><div \nclass=\"h3\" translate=\"FE_GET_STARTED_TEXT\"></div></div><div class=\"background-image-center\"><md-icon \nmd-font-icon=\"icon-rocket\" class=\"s140 faint-text\"></md-icon></div><md-tooltip>{{\'FE_GET_STARTED_TEXT\' | translate}}\n</md-tooltip></ms-widget-front></ms-widget><ms-widget id=\"widget-view-ads-txt\" flippable=\"false\" layout=\"column\" \nclass=\"h-160\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex \nng-click=\"vm.handleViewClick()\"><div layout=\"column\" layout-align=\"center center\" flex><div class=\"md-display-1 pb-8\" \ntranslate=\"FE_VIEW\"></div><div class=\"h3\" translate=\"FE_VIEW_TEXT\"></div></div><div class=\"background-image-center\">\n<md-icon md-font-icon=\"icon-eye\" class=\"s140 faint-text\"></md-icon></div><md-tooltip>{{\'FE_VIEW_TEXT\' | translate}}\n</md-tooltip></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget flippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"p-16 white-bg\"><div class=\"pb-16\" \nlayout=\"column\" layout-align=\"start\"><div class=\"h3\">{{\'FE_CRAWL_STATS\' | translate}} <span class=\"font-size-14\">\n({{\'FE_LAST_90_DAYS\' | translate}})</span></div><div class=\"h5 pb-10 secondary-text\" translate=\"FE_CRAWL_STATS_TEXT\">\n</div></div><canvas ng-if=\"vm.lineChart.labels.length > 0\" height=\"250\" id=\"line\" class=\"chart chart-line\" \nchart-data=\"vm.lineChart.data\" chart-options=\"vm.lineChart.options\" chart-labels=\"vm.lineChart.labels\" \nchart-legend=\"true\" chart-series=\"vm.lineChart.series\"></canvas><div ng-if=\"vm.lineChart.labels.length == 0\" \nclass=\"h-300 md-headline secondary-text\" layout=\"row\" layout-align=\"center center\" translate=\"FE_NO_DATA\"></div>\n</ms-widget-front></ms-widget></div></div><div layout=\"column\" class=\"ph-24 pv-8\"><span class=\"md-headline\" \ntranslate=\"FE_WHAT_IS_ADS_TXT\"></span><p class=\"md-subhead\" translate=\"FE_ADS_TXT_DESCRIPTION_1\"></p><p \nclass=\"md-subhead\" translate=\"FE_ADS_TXT_DESCRIPTION_2\"></p></div></div>");
$templateCache.put("app/main/apps/pages/manual-entries/manual-entries.html","<div id=\"manual-entries\" layout=\"column\" class=\"page-layout\" flex><div class=\"header small-title md-accent-bg\" \nlayout=\"column\" layout-align=\"center start\"><span class=\"md-display-1 font-weight-300\" translate=\"FE_MANUAL_ENTRIES\">\n</span></div><div class=\"red-400-bg white-fg p-16\" ng-if=\"vm.errorList.length > 0\" layout=\"row\" \nlayout-align=\"space-between start\"><div><div layout=\"row\" layout-align=\"start start\" flex><span class=\"mr-16\"><md-icon \nmd-font-icon=\"icon-account-alert\"></md-icon></span><span class=\"md-subhead\" translate=\"FE_UPLOAD_ERROR\"></span></div>\n<ol class=\"ml-16\"><li class=\"h4\" ng-repeat=\"(idx, error) in vm.errorList track by idx\">{{error}}</li></ol></div>\n<md-button class=\"md-icon-button\" ng-click=\"vm.handleCloseErrorsClick()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><div class=\"red-300-bg white-fg p-16\" ng-if=\"vm.duplicateList.length > 0\" layout=\"row\" \nlayout-align=\"space-between start\"><div><div layout=\"row\" layout-align=\"start start\" flex><span class=\"mr-16\"><md-icon \nmd-font-icon=\"icon-account-alert\"></md-icon></span><span class=\"md-subhead\" translate=\"FE_UPLOAD_DUPLICATE_ERROR\">\n</span></div><ol class=\"ml-16\"><li class=\"h4\" ng-repeat=\"(idx, error) in vm.duplicateList track by idx\">{{error}}</li>\n</ol></div><md-button class=\"md-icon-button\" ng-click=\"vm.handleCloseDuplicatesClick()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"p-16\" layout=\"column\"><div id=\"bulk-upload\">\n<bulk-upload domain-entry-list=\"vm.domainEntryList\" authorized-seller-list=\"vm.authorizedSellerList\" \ncallback-errors=\"vm.callbackErrors\" callback-duplicate-errors=\"vm.callbackDuplicateErrors\" class=\"md-whiteframe-2dp\">\n</bulk-upload></div><manual-entries domain-entry-list=\"vm.domainEntryList\" \nauthorized-seller-list=\"vm.authorizedSellerList\" authorized-seller=\"vm.authorizedSeller\"></manual-entries></div></div>");
$templateCache.put("app/main/apps/pages/sellers/sellers.html","<div id=\"sellers\" class=\"page-layout\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\" flex><div class=\"md-display-1 font-size-30 font-weight-300\" layout=\"column\" \nlayout-align=\"start start\" flex><md-select ng-model=\"vm.sellerListType\" class=\"md-no-underline\" \naria-label=\"seller list type\"><md-option class=\"md-subhead\" value=\"all\">{{\'FE_ALL_SELLERS\' | translate}}</md-option>\n<md-option class=\"md-subhead\" value=\"authorized\">{{\'FE_AUTHORIZED_SELLERS\' | translate}}</md-option><md-option \nclass=\"md-subhead\" value=\"unauthorized\">{{\'FE_UNAUTHORIZED_SELLERS\' | translate}}</md-option></md-select></div><div \nhide-xs class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"seller-search\" ng-model=\"vm.search\" class=\"search-input\" \ntype=\"text\" placeholder=\"{{\'FE_SEARCH\' | translate}}\" flex></div></div><div class=\"pt-16 ph-24 md-subhead\" \ntranslate=\"FE_SELLERS_SUBHEADER\"></div><div class=\"center\" layout=\"column\" flex><div class=\"p-16\"><div layout=\"row\" \nlayout-align=\"start start\" layout-wrap><div class=\"md-card-container\" layout=\"column\" \nng-repeat=\"seller in vm.sellerList.list | orderBy: \'sellerName\': false | filter: vm.filters | filter: {sellerName: vm.search} as filteredSellerList\">\n<seller-card seller=\"seller\" authorized-seller-list=\"vm.authorizedSellerList\" show-manage=\"true\"></seller-card></div>\n<div class=\"ph-8 pv-16\" ng-if=\"filteredSellerList.length == 0\"><span class=\"md-subhead text-bold\">\n{{\'FE_LIST_NO_RESULTS\' | translate}}</span></div></div></div></div></div>");
$templateCache.put("app/main/apps/pages/view-adstxt/view-adstxt.html","<div id=\"invoice\" class=\"compact page-layout blank\" layout=\"column\" ms-scroll><div \nclass=\"header small-title md-accent-bg\" layout=\"column\" layout-align=\"center start\"><span \nclass=\"md-display-1 font-weight-300\" translate=\"FE_ADS_TXT_PREVIEW\"></span></div><div class=\"pt-16 ph-24 md-subhead\" \ntranslate=\"FE_VIEW_SUBHEADER\"></div><div class=\"invoice-container p-24\" flex=\"100\" layout=\"row\" layout-align=\"start\">\n<div class=\"card md-whiteframe-8dp\" flex=\"60\" flex-xs=\"100\"><div class=\"content\"><div class=\"view-txt\" \nng-bind-html=\"vm.adsTxt\"></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\" ng-class=\"{\'md-grey-50-bg\': !card.isActive}\"><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div \nclass=\"content pv-24 ph-16\"><div class=\"title h3\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text pt-16\" ng-if=\"card.link\">\n<a href=\"{{card.link}}\" target=\"_blank\">{{card.link}}</a></div><div class=\"text-center pt-16\"><md-button \nng-if=\"!card.isActive\" class=\"md-raised md-accent\" ng-href=\"{{googleUrl}}\" target=\"_blank\">Authorize</md-button>\n<md-button ng-if=\"card.isActive\" class=\"md-primary\" ng-href=\"{{googleUrl}}\" target=\"_blank\">Manage</md-button></div>\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between center\"><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"info\" \nlayout=\"column\" layout-align=\"space-between\" layout-fill flex><div class=\"p-8\"><div class=\"title h4\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div></div></div><md-button class=\"md-icon-button\" aria-label=\"more\" translate ng-click=\"handleViewClick()\" \ntranslate-attr-aria-label=\"PROFILE.MORE\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon><md-tooltip \nmd-direction=\"bottom\" md-delay=\"500\">manage authorized seller</md-tooltip></md-button></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/apps/pages/dialogs/authorized-seller/authorized-seller-dialog.html","<md-dialog id=\"authorized-seller-dialog\" class=\"seller-dialog\" aria-label=\"authorized seller dialog\"><md-dialog-content\n class=\"p-24\" ms-scroll><span class=\"md-title\" translate=\"FE_DIALOG_REASSIGN_TITLE\"></span><form name=\"asForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\" class=\"pt-16\"><md-input-container><label \ntranslate=\"FE_AUTHORIZED_SELLER\"></label><md-select ng-model=\"vm.selectedAuthorizedSeller\" required><md-option \nng-if=\"seller.sellerId != vm.authorizedSeller.sellerId\" ng-repeat=\"seller in vm.authorizedSellerList.list\" \nng-value=\"seller.sellerId\">{{ seller.sellerName }}</md-option></md-select></md-input-container></div></form>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button class=\"m-0\" \nng-click=\"vm.cancel()\">{{ \'FE_CANCEL\' | translate }}</md-button><md-button type=\"submit\" ng-click=\"vm.reassign()\" \nclass=\"send-button md-raised md-accent\" aria-label=\"re-assign entries\" ng-disabled=\"vm.selectedAuthorizedSeller == -1\">\n{{ \'FE_REASSIGN\' | translate }}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/pages/dialogs/change-password/change-password-dialog.html","<md-dialog id=\"change-password-dialog\" class=\"change-password-dialog\" aria-label=\"change password dialog\">\n<md-dialog-content class=\"p-24\" ms-scroll><span class=\"md-title\" translate=\"FE_DIALOG_CHANGE_PASSWORD_TITLE\"></span>\n<div ng-if=\"vm.isSaving\" class=\"saving-msg\" layout=\"column\" layout-align=\"center start\"><md-progress-linear class=\"\" \nmd-mode=\"indeterminate\"></md-progress-linear><md-subheader class=\"md-no-sticky\"><span translate=\"FE_SAVING\"></span>\n</md-subheader></div><div layout=\"column\" ng-class=\"{\'hide\': vm.isSaving}\" class=\"pt-16\"><form name=\"passwordForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\"><md-input-container flex><input type=\"password\" \nname=\"currentPassword\" ng-model=\"vm.publisher.currentPassword\" ng-change=\"vm.clearError(\'currentPassword\', \'invalid\')\" \nplaceholder=\"{{\'FE_PASSWORD_CURRENT\' | translate}}\" required><div ng-messages=\"passwordForm.currentPassword.$error\" \nrole=\"alert\"><div ng-message-exp=\"[\'required\', \'invalid\']\">{{\'FE_PASSWORD_CURRENT_ERROR\' | translate}}</div></div>\n</md-input-container><md-input-container flex><input type=\"password\" name=\"password\" ng-model=\"vm.publisher.password\" \nplaceholder=\"{{\'FE_PASSWORD_NEW\' | translate}}\" minlength=\"5\" required><div ng-messages=\"passwordForm.password.$error\" \nrole=\"alert\"><div ng-message-exp=\"[\'required\', \'minlength\']\">{{\'FE_PASSWORD_NEW_ERROR\' | translate}}</div></div>\n</md-input-container><md-input-container flex><input type=\"password\" name=\"confirmPassword\" \nng-model=\"vm.publisher.confirmPassword\" placeholder=\"{{\'FE_PASSWORD_VERIFY\' | translate}}\" \nng-pattern=\"vm.publisher.password\" required><div ng-messages=\"passwordForm.confirmPassword.$error\" role=\"alert\"><div \nng-message-exp=\"[\'required\', \'pattern\']\">{{\'FE_PASSWORD_VERIFY_ERROR\' | translate}}</div></div></md-input-container>\n</div></form></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"m-0\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.isSaving\">{{ \'FE_CANCEL\' | translate }}</md-button><md-button \ntype=\"submit\" ng-click=\"vm.savePassword()\" class=\"send-button md-accent md-raised\" aria-label=\"change password\" \nng-disabled=\"passwordForm.$invalid || passwordForm.$pristine || vm.isSaving\">{{ \'FE_SAVE\' | translate }}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/pages/dialogs/create-domain/create-domain-dialog.html","<md-dialog id=\"change-password-dialog\" class=\"change-password-dialog\" aria-label=\"change password dialog\">\n<md-dialog-content class=\"p-24\" ms-scroll><span class=\"md-title\" translate=\"FE_DIALOG_CREATE_DOMAIN_TITLE\"></span><div \nng-if=\"vm.isSaving\" class=\"saving-msg\" layout=\"column\" layout-align=\"center start\"><md-progress-linear class=\"\" \nmd-mode=\"indeterminate\"></md-progress-linear><md-subheader class=\"md-no-sticky\"><span translate=\"FE_SAVING\"></span>\n</md-subheader></div><div layout=\"column\" ng-class=\"{\'hide\': vm.isSaving}\" class=\"pt-16\"><form name=\"siteForm\" \nclass=\"md-inline-form\" novalidate><div layout=\"column\"><md-input-container flex><input type=\"text\" name=\"siteName\" \nng-model=\"vm.domain.domain\" placeholder=\"{{\'FE_SITE_NAME\' | translate}}\" \nng-pattern=\"/^[a-zA-Z0-9]+?[a-zA-Z0-9-]{0,}?[a-zA-Z0-9]+?[.][a-zA-Z0-9.]+?$/\" required><div class=\"hint\">\nExample: adstxtmanager.com</div><div ng-messages=\"siteForm.siteName.$error\"><div ng-message=\"pattern\">\n{{\'FE_SITE_NAME_ERROR\' | translate}}</div><div ng-message=\"required\">\n{{\'FE_SITE_NAME\' | translate}} {{\'FE_FIELD_IS_REQUIRED\' | translate}}</div></div></md-input-container></div></form>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button class=\"m-0\" \nng-click=\"vm.cancel()\" ng-disabled=\"vm.isSaving\">{{ \'FE_CANCEL\' | translate }}</md-button><md-button type=\"submit\" \nng-click=\"vm.createDomain()\" class=\"send-button md-accent md-raised\" aria-label=\"create site\" \nng-disabled=\"siteForm.$invalid || siteForm.$pristine || vm.isSaving\">{{ \'FE_SAVE\' | translate }}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");}]);